/*
 * AUTO-GENERATED by scripts/generate-chapter.ts.
 * Source: LearningHub / basic-skills
 * Do not edit by hand — regenerate from extracted JSON + translations.
 */
import type { Chapter, Level } from "../types";

export const CHAPTER_ID = "basic-skills";

export const CHAPTER: Chapter = {
    id: "basic-skills",
    title: { zh: "黄金", en: "Gold" },
    description: {
        zh: "吃子手筋、征子、罩与基础战术",
        en: "Capturing tesuji, ladders, nets and basic tactics",
    },
};

const atariToSideLevels: Level[] = [
    {
        id: "basic-skills-atari-to-side-1",
        chapterId: "basic-skills",
        order: 1,
        title: { zh: "打吃至边 · 1/18", en: "Atari To Side · 1/18" },
        instruction: { zh: "黑先。将带标记的白棋驱向棋盘边缘，可以更容易地吃掉它。选择落子点A或B，将带标记的白棋推向边缘。", en: "Black to play. Driving the marked white stone to the side of the board makes it easier to capture it. Choose the point to play to push the marked white stone to the edge, A or B." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "bdbf", white: "ccbe" },
            marks: { A: "ae", B: "ce", triangle: "be" },
            correct: ["ce"],
            wrong: ["aece"],
        },
    },
    {
        id: "basic-skills-atari-to-side-2",
        chapterId: "basic-skills",
        order: 2,
        title: { zh: "打吃至边 · 2/18", en: "Atari To Side · 2/18" },
        instruction: { zh: "黑先。选择落子点A或B，将带标记的白棋棋串推向棋盘边缘。", en: "Black to play. Choose the point to play to push the marked white chain to the side, A or B." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "dbfbdcfc", white: "ebeccecg" },
            marks: { A: "ea", B: "ed", triangle: "eceb" },
            correct: ["ed"],
            wrong: ["eaed"],
        },
    },
    {
        id: "basic-skills-atari-to-side-3",
        chapterId: "basic-skills",
        order: 3,
        title: { zh: "打吃至边 · 3/18", en: "Atari To Side · 3/18" },
        instruction: { zh: "黑先。选择落子点A或B，将带标记的白棋棋串推向棋盘边缘。", en: "Black to play. Choose the point to play to push the marked white chain to the side, A or B." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "bccddd", white: "bdcecf" },
            marks: { A: "ad", B: "be", triangle: "bd" },
            correct: ["be"],
            wrong: ["adbe"],
        },
    },
    {
        id: "basic-skills-atari-to-side-4",
        chapterId: "basic-skills",
        order: 4,
        title: { zh: "打吃至边 · 4/18", en: "Atari To Side · 4/18" },
        instruction: { zh: "黑先。选择落子点A或B，将带标记的白棋棋串推向棋盘边缘。", en: "Black to play. Choose the point to play to push the marked white chain to the side, A or B." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "dgegchdi", white: "fgggdheh" },
            marks: { A: "fh", B: "ei", triangle: "ehdh" },
            correct: ["fh"],
            wrong: ["eifh"],
        },
    },
    {
        id: "basic-skills-atari-to-side-5",
        chapterId: "basic-skills",
        order: 5,
        title: { zh: "打吃至边 · 5/18", en: "Atari To Side · 5/18" },
        instruction: { zh: "黑先。选择落子点A或B，将带标记的白棋棋串推向棋盘边缘。", en: "Black to play. Choose the point to play to push the marked white chain to the side, A or B." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "becfcgggdheh", white: "cdceeebfdfdg" },
            marks: { A: "af", B: "bg", triangle: "bf" },
            correct: ["bg"],
            wrong: ["afbgchbd"],
        },
    },
    {
        id: "basic-skills-atari-to-side-6",
        chapterId: "basic-skills",
        order: 6,
        title: { zh: "打吃至边 · 6/18", en: "Atari To Side · 6/18" },
        instruction: { zh: "黑先。选择落子点A或B，将带标记的白棋棋串推向棋盘边缘。", en: "Black to play. Choose the point to play to push the marked white chain to the side, A or B." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "dfcgegch", white: "dgfgggdh" },
            marks: { A: "eh", B: "di", triangle: "dhdg" },
            correct: ["eh"],
            wrong: ["dieheffh"],
        },
    },
    {
        id: "basic-skills-atari-to-side-7",
        chapterId: "basic-skills",
        order: 7,
        title: { zh: "打吃至边 · 7/18", en: "Atari To Side · 7/18" },
        instruction: { zh: "白先。吃掉带标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ccegfh", white: "fggh" },
            marks: { triangle: "fh" },
            correct: ["eh"],
            wrong: ["fieh"],
        },
    },
    {
        id: "basic-skills-atari-to-side-8",
        chapterId: "basic-skills",
        order: 8,
        title: { zh: "打吃至边 · 8/18", en: "Atari To Side · 8/18" },
        instruction: { zh: "白先。吃掉带标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "cccefgdhfh", white: "ffeggggh" },
            marks: { triangle: "fhfg" },
            correct: ["eh"],
            wrong: ["fieh"],
        },
    },
    {
        id: "basic-skills-atari-to-side-9",
        chapterId: "basic-skills",
        order: 9,
        title: { zh: "打吃至边 · 9/18", en: "Atari To Side · 9/18" },
        instruction: { zh: "白先。吃掉带标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gcddeecfdfffcgggdh", white: "bdbfefbgdgegbhch" },
            marks: { triangle: "dh" },
            correct: ["eh"],
            wrong: ["dieh"],
        },
    },
    {
        id: "basic-skills-atari-to-side-10",
        chapterId: "basic-skills",
        order: 10,
        title: { zh: "打吃至边 · 10/18", en: "Atari To Side · 10/18" },
        instruction: { zh: "白先。吃掉带标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "bfdfefcgegbhfhci", white: "geffdgfgchdheh" },
            marks: { triangle: "fh" },
            correct: ["gh"],
            wrong: ["figh"],
        },
    },
    {
        id: "basic-skills-atari-to-side-11",
        chapterId: "basic-skills",
        order: 11,
        title: { zh: "打吃至边 · 11/18", en: "Atari To Side · 11/18" },
        instruction: { zh: "白先。吃掉带标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "dbcdddcebfcgdgeg", white: "gcfdbedecfdfff" },
            marks: { triangle: "bf" },
            correct: ["bg"],
            wrong: ["afbg"],
        },
    },
    {
        id: "basic-skills-atari-to-side-12",
        chapterId: "basic-skills",
        order: 12,
        title: { zh: "打吃至边 · 12/18", en: "Atari To Side · 12/18" },
        instruction: { zh: "白先。吃掉带标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "cccfbgdgdh", white: "dfcgegeh" },
            marks: { triangle: "dhdg" },
            correct: ["ch"],
            wrong: ["dich"],
        },
    },
    {
        id: "basic-skills-atari-to-side-13",
        chapterId: "basic-skills",
        order: 13,
        title: { zh: "打吃至边 · 13/18", en: "Atari To Side · 13/18" },
        instruction: { zh: "白先。吃掉带标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ccdgegchfhgh", white: "fgggdhehfi" },
            marks: { triangle: "ghfh" },
            correct: ["hh"],
            wrong: ["gihhhgdi"],
        },
    },
    {
        id: "basic-skills-atari-to-side-14",
        chapterId: "basic-skills",
        order: 14,
        title: { zh: "打吃至边 · 14/18", en: "Atari To Side · 14/18" },
        instruction: { zh: "白先。吃掉带标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ccgcddbecfdfef", white: "bdbfbgcgdgfg" },
            marks: { triangle: "be" },
            correct: ["ce"],
            wrong: ["aece"],
        },
    },
    {
        id: "basic-skills-atari-to-side-15",
        chapterId: "basic-skills",
        order: 15,
        title: { zh: "打吃至边 · 15/18", en: "Atari To Side · 15/18" },
        instruction: { zh: "白先。吃掉带标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gchddfefbgcgegbheh", white: "eecfffdgfgchdhfh" },
            marks: { triangle: "ehegefdf" },
            correct: ["de"],
            wrong: ["eideddcebfbe"],
        },
    },
    {
        id: "basic-skills-atari-to-side-16",
        chapterId: "basic-skills",
        order: 16,
        title: { zh: "打吃至边 · 16/18", en: "Atari To Side · 16/18" },
        instruction: { zh: "白先。吃掉带标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "cdcecfdgeg", white: "dfefcgdh" },
            marks: { triangle: "egdg" },
            correct: ["fgehfh", "fgeheifhgh"],
            wrong: ["fgeheifhfigh", "ehfg"],
        },
    },
    {
        id: "basic-skills-atari-to-side-17",
        chapterId: "basic-skills",
        order: 17,
        title: { zh: "打吃至边 · 17/18", en: "Atari To Side · 17/18" },
        instruction: { zh: "白先。吃掉带标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "cccfdfcgeg", white: "eeefdgdh" },
            marks: { triangle: "eg" },
            correct: ["fgehfh", "fgeheifhgh"],
            wrong: ["fgeheifhfigh"],
        },
    },
    {
        id: "basic-skills-atari-to-side-18",
        chapterId: "basic-skills",
        order: 18,
        title: { zh: "打吃至边 · 18/18", en: "Atari To Side · 18/18" },
        instruction: { zh: "白先。吃掉带标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "bfdfdggg", white: "bebgcg" },
            marks: { triangle: "bf" },
            correct: ["cf"],
            wrong: ["afcf"],
        },
    },
];

const atariToStonesLevels: Level[] = [
    {
        id: "basic-skills-atari-to-stones-1",
        chapterId: "basic-skills",
        order: 19,
        title: { zh: "打吃棋子 · 1/6", en: "Atari to Stones · 1/6" },
        instruction: { zh: "黑先。将带标记的白棋驱向己方棋子，有助于吃掉这些棋子。对带标记的白棋进行打吃。", en: "Black to play. Driving the marked stones towards your own stones helps you capture these stones. Put the marked stones in atari." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "deeegecffffg", white: "cdfdcefedfef" },
            marks: { triangle: "dfef" },
            correct: ["dg"],
            wrong: ["egdgdhcgbgbf"],
        },
    },
    {
        id: "basic-skills-atari-to-stones-2",
        chapterId: "basic-skills",
        order: 20,
        title: { zh: "打吃棋子 · 2/6", en: "Atari to Stones · 2/6" },
        instruction: { zh: "黑先。向己方棋子方向打吃。", en: "Black to play. Put in atari towards your own stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "efffgfdgggdhdi", white: "cfdfcgegfgchci" },
            correct: ["fh"],
            wrong: ["ehfheifi"],
        },
    },
    {
        id: "basic-skills-atari-to-stones-3",
        chapterId: "basic-skills",
        order: 21,
        title: { zh: "打吃棋子 · 3/6", en: "Atari to Stones · 3/6" },
        instruction: { zh: "黑先。向己方棋子方向打吃。", en: "Black to play. Put in atari towards your own stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cefecfefdg", white: "ccdedfegfg" },
            correct: ["dd"],
            wrong: ["eedd"],
        },
    },
    {
        id: "basic-skills-atari-to-stones-4",
        chapterId: "basic-skills",
        order: 22,
        title: { zh: "打吃棋子 · 4/6", en: "Atari to Stones · 4/6" },
        instruction: { zh: "黑先。向己方棋子方向打吃。", en: "Black to play. Put in atari towards your own stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cdcfffdgeg", white: "dfefcgfggg" },
            correct: ["ee"],
            wrong: ["deeeedfe"],
        },
    },
    {
        id: "basic-skills-atari-to-stones-5",
        chapterId: "basic-skills",
        order: 23,
        title: { zh: "打吃棋子 · 5/6", en: "Atari to Stones · 5/6" },
        instruction: { zh: "黑先。向己方棋子方向打吃。", en: "Black to play. Put in atari towards your own stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cfdgggehfh", white: "gehfegfghg" },
            correct: ["ffefee"],
            wrong: ["effffegf"],
        },
    },
    {
        id: "basic-skills-atari-to-stones-6",
        chapterId: "basic-skills",
        order: 24,
        title: { zh: "打吃棋子 · 6/6", en: "Atari to Stones · 6/6" },
        instruction: { zh: "黑先。向己方棋子方向打吃。", en: "Black to play. Put in atari towards your own stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cfefffcgggfh", white: "gdhfegfgghhh" },
            correct: ["ehdgdh", "ehdgdfdhch", "ehdgdfdhdichbh"],
            wrong: ["ehdgdfdhdichcibh", "dgeh"],
        },
    },
];

const atariWithCutLevels: Level[] = [
    {
        id: "basic-skills-atari-with-cut-1",
        chapterId: "basic-skills",
        order: 25,
        title: { zh: "打吃并切断 · 1/18", en: "Atari with Cut · 1/18" },
        instruction: { zh: "黑先。白棋可以将带标记的棋子与其他白棋连接并逃脱被吃。通过切断来阻止，并吃掉带标记的白棋。", en: "Black to play. White can connect the marked stones to the other white stones and escape from being captured. Prevent this by cutting and capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cfffcgfgdhfhei", white: "dbcdcedfdgegeh" },
            marks: { triangle: "dfdgegeh" },
            correct: ["deefee"],
            wrong: ["efde"],
        },
    },
    {
        id: "basic-skills-atari-with-cut-2",
        chapterId: "basic-skills",
        order: 26,
        title: { zh: "打吃并切断 · 2/18", en: "Atari with Cut · 2/18" },
        instruction: { zh: "黑先。阻止白棋连接，并吃掉一颗或多颗白棋。", en: "Black to play. Prevent White from connecting and capture one or more white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "deeefegecfgfcgeg", white: "cdcedfefffggehgh" },
            correct: ["fgdgdh"],
            wrong: ["dgfg"],
        },
    },
    {
        id: "basic-skills-atari-with-cut-3",
        chapterId: "basic-skills",
        order: 27,
        title: { zh: "打吃并切断 · 3/18", en: "Atari with Cut · 3/18" },
        instruction: { zh: "黑先。阻止白棋连接，并吃掉一颗或多颗白棋。", en: "Black to play. Prevent White from connecting and capture one or more white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cedebfcgggbhdhehfh", white: "gcgdcfdfgfhfdgegfg" },
            correct: ["ffefee"],
            wrong: ["efff"],
        },
    },
    {
        id: "basic-skills-atari-with-cut-4",
        chapterId: "basic-skills",
        order: 28,
        title: { zh: "打吃并切断 · 4/18", en: "Atari with Cut · 4/18" },
        instruction: { zh: "黑先。阻止白棋连接，并吃掉一颗或多颗白棋。", en: "Black to play. Prevent White from connecting and capture one or more white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cebfffbgfgchdheh", white: "gcfegecfefcgdgeg" },
            correct: ["ee"],
        },
    },
    {
        id: "basic-skills-atari-with-cut-5",
        chapterId: "basic-skills",
        order: 29,
        title: { zh: "打吃并切断 · 5/18", en: "Atari with Cut · 5/18" },
        instruction: { zh: "黑先。阻止白棋连接，并吃掉一颗或多颗白棋。", en: "Black to play. Prevent White from connecting and capture one or more white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "ccegdhdi", white: "fffgehei" },
            correct: ["fhfigi"],
            wrong: ["fifh"],
        },
    },
    {
        id: "basic-skills-atari-with-cut-6",
        chapterId: "basic-skills",
        order: 30,
        title: { zh: "打吃并切断 · 6/18", en: "Atari with Cut · 6/18" },
        instruction: { zh: "黑先。阻止白棋连接，并吃掉一颗或多颗白棋。", en: "Black to play. Prevent White from connecting and capture one or more white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cddebfcgdg", white: "fecfdfegfg" },
            correct: ["efcebe"],
            wrong: ["ceef"],
        },
    },
    {
        id: "basic-skills-atari-with-cut-7",
        chapterId: "basic-skills",
        order: 31,
        title: { zh: "打吃并切断 · 7/18", en: "Atari with Cut · 7/18" },
        instruction: { zh: "黑先。阻止白棋连接，并吃掉一颗或多颗白棋。", en: "Black to play. Prevent White from connecting and capture one or more white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cedeeebfffcg", white: "cfdfefhffggg" },
            correct: ["egdgdh"],
            wrong: ["dgeg"],
        },
    },
    {
        id: "basic-skills-atari-with-cut-8",
        chapterId: "basic-skills",
        order: 32,
        title: { zh: "打吃并切断 · 8/18", en: "Atari with Cut · 8/18" },
        instruction: { zh: "黑先。阻止白棋连接，并吃掉一颗或多颗白棋。", en: "Black to play. Prevent White from connecting and capture one or more white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cdeefecfdgeg", white: "gcgedfefgffg" },
            correct: ["ffdedd"],
            wrong: ["deff"],
        },
    },
    {
        id: "basic-skills-atari-with-cut-9",
        chapterId: "basic-skills",
        order: 33,
        title: { zh: "打吃并切断 · 9/18", en: "Atari with Cut · 9/18" },
        instruction: { zh: "黑先。阻止白棋连接，并吃掉一颗或多颗白棋。", en: "Black to play. Prevent White from connecting and capture one or more white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "dgegfhei", white: "cfcgdheh" },
            correct: ["ch"],
            wrong: ["dich"],
        },
    },
    {
        id: "basic-skills-atari-with-cut-10",
        chapterId: "basic-skills",
        order: 34,
        title: { zh: "打吃并切断 · 10/18", en: "Atari with Cut · 10/18" },
        instruction: { zh: "黑先。阻止白棋连接，并吃掉一颗或多颗白棋。", en: "Black to play. Prevent White from connecting and capture one or more white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "gdcedeeefecfgfggehfh", white: "bdcdbebfdfefffbgcgfg" },
            correct: ["dg"],
            wrong: ["egdg"],
        },
    },
    {
        id: "basic-skills-atari-with-cut-11",
        chapterId: "basic-skills",
        order: 35,
        title: { zh: "打吃并切断 · 11/18", en: "Atari with Cut · 11/18" },
        instruction: { zh: "黑先。阻止白棋连接，并吃掉一颗或多颗白棋。", en: "Black to play. Prevent White from connecting and capture one or more white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "dfffdgehfhfi", white: "cccecfcgdhdiei" },
            correct: ["chcibi"],
            wrong: ["cich"],
        },
    },
    {
        id: "basic-skills-atari-with-cut-12",
        chapterId: "basic-skills",
        order: 36,
        title: { zh: "打吃并切断 · 12/18", en: "Atari with Cut · 12/18" },
        instruction: { zh: "黑先。阻止白棋连接，并吃掉一颗或多颗白棋。", en: "Black to play. Prevent White from connecting and capture one or more white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "fecfcgdgggehfh", white: "dbdccededfegfg" },
            correct: ["efffgf"],
            wrong: ["ffef"],
        },
    },
    {
        id: "basic-skills-atari-with-cut-13",
        chapterId: "basic-skills",
        order: 37,
        title: { zh: "打吃并切断 · 13/18", en: "Atari with Cut · 13/18" },
        instruction: { zh: "黑先。阻止白棋连接，并吃掉一颗或多颗白棋。", en: "Black to play. Prevent White from connecting and capture one or more white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "eefedfgfggchghdieifi", white: "cdcecfefffcgfgdhehfh" },
            correct: ["dg"],
        },
    },
    {
        id: "basic-skills-atari-with-cut-14",
        chapterId: "basic-skills",
        order: 38,
        title: { zh: "打吃并切断 · 14/18", en: "Atari with Cut · 14/18" },
        instruction: { zh: "黑先。阻止白棋连接，并吃掉一颗或多颗白棋。", en: "Black to play. Prevent White from connecting and capture one or more white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "gcdffffgchfhdiei", white: "dccdcecfcgegdheh" },
            correct: ["dg"],
            wrong: ["efdg"],
        },
    },
    {
        id: "basic-skills-atari-with-cut-15",
        chapterId: "basic-skills",
        order: 39,
        title: { zh: "打吃并切断 · 15/18", en: "Atari with Cut · 15/18" },
        instruction: { zh: "黑先。阻止白棋连接，并吃掉一颗或多颗白棋。", en: "Black to play. Prevent White from connecting and capture one or more white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cddeeefecfgffg", white: "dfefffbgcggghg" },
            correct: ["dgegeh"],
            wrong: ["egdg"],
        },
    },
    {
        id: "basic-skills-atari-with-cut-16",
        chapterId: "basic-skills",
        order: 40,
        title: { zh: "打吃并切断 · 16/18", en: "Atari with Cut · 16/18" },
        instruction: { zh: "黑先。阻止白棋连接，并吃掉一颗或多颗白棋。", en: "Black to play. Prevent White from connecting and capture one or more white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "becfdfegfggg", white: "ccbfcgdgehfh" },
            correct: ["bg"],
            wrong: ["afbg", "dhbhchbgghci"],
        },
    },
    {
        id: "basic-skills-atari-with-cut-17",
        chapterId: "basic-skills",
        order: 41,
        title: { zh: "打吃并切断 · 17/18", en: "Atari with Cut · 17/18" },
        instruction: { zh: "黑先。阻止白棋连接，并吃掉一颗或多颗白棋。", en: "Black to play. Prevent White from connecting and capture one or more white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cdddcebfbgcgdgfg", white: "bcdcedbedeeecfdf" },
            correct: ["bd"],
            wrong: ["aebd"],
        },
    },
    {
        id: "basic-skills-atari-with-cut-18",
        chapterId: "basic-skills",
        order: 42,
        title: { zh: "打吃并切断 · 18/18", en: "Atari with Cut · 18/18" },
        instruction: { zh: "黑先。阻止白棋连接，并吃掉一颗或多颗白棋。", en: "Black to play. Prevent White from connecting and capture one or more white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "gehfcgeggghgfh", white: "ecgchceeheffgf" },
            correct: ["hdgdie"],
            wrong: ["iehd", "fegdfdfc", "effe"],
        },
    },
];

const atariCorrectSideLevels: Level[] = [
    {
        id: "basic-skills-atari-correct-side-1",
        chapterId: "basic-skills",
        order: 43,
        title: { zh: "打吃正确方向 · 1/6", en: "Atari Correct Side · 1/6" },
        instruction: { zh: "白棋可以在A或B点落子，对带标记的黑棋进行打吃。在正确的一侧对带标记的黑棋进行打吃。", en: "White can put the marked stones in atari by playing at A or B. Put the marked stones in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ichdidfegeheefegfggg", white: "echcfdgdeeffgfhf" },
            marks: { A: "ib", B: "ie", triangle: "ichdidfegehe" },
            correct: ["ib"],
            wrong: ["ieif"],
        },
    },
    {
        id: "basic-skills-atari-correct-side-2",
        chapterId: "basic-skills",
        order: 44,
        title: { zh: "打吃正确方向 · 2/6", en: "Atari Correct Side · 2/6" },
        instruction: { zh: "白先。在正确的一侧对带标记的黑棋进行打吃。", en: "White to play. Put the marked stones in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "bcadcddeafbfcf", white: "acbecedfagcg" },
            marks: { triangle: "cfbfaf" },
            correct: ["bgaebd"],
            wrong: ["aebd"],
        },
    },
    {
        id: "basic-skills-atari-correct-side-3",
        chapterId: "basic-skills",
        order: 45,
        title: { zh: "打吃正确方向 · 3/6", en: "Atari Correct Side · 3/6" },
        instruction: { zh: "白先。在正确的一侧对带标记的黑棋进行打吃。", en: "White to play. Put the marked stones in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gchcfdidiehfhg", white: "hdgegfggighh" },
            marks: { triangle: "hghf" },
            correct: ["heific"],
            wrong: ["ifih"],
        },
    },
    {
        id: "basic-skills-atari-correct-side-4",
        chapterId: "basic-skills",
        order: 46,
        title: { zh: "打吃正确方向 · 4/6", en: "Atari Correct Side · 4/6" },
        instruction: { zh: "白先。在正确的一侧对带标记的黑棋进行打吃。", en: "White to play. Put the marked stones in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "dadbfbacbcccdcfcfddeeeff", white: "aaabbbcbebecadbdcddded" },
            marks: { triangle: "dcccbcacdbda" },
            correct: ["eacaba"],
            wrong: ["caba"],
        },
    },
    {
        id: "basic-skills-atari-correct-side-5",
        chapterId: "basic-skills",
        order: 47,
        title: { zh: "打吃正确方向 · 5/6", en: "Atari Correct Side · 5/6" },
        instruction: { zh: "白先。在正确的一侧对带标记的黑棋进行打吃。", en: "White to play. Put the marked stones in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "efffdgfgdhghdi", white: "dfcgegchehfh" },
            marks: { triangle: "didhdg" },
            correct: ["cieifi"],
            wrong: ["eifi"],
        },
    },
    {
        id: "basic-skills-atari-correct-side-6",
        chapterId: "basic-skills",
        order: 48,
        title: { zh: "打吃正确方向 · 6/6", en: "Atari Correct Side · 6/6" },
        instruction: { zh: "白先。在正确的一侧对带标记的黑棋进行打吃。", en: "White to play. Put the marked stones in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ccdedfegfgfhghgi", white: "efffcgdgggehhh" },
            marks: { triangle: "gighfhfgeg" },
            correct: ["hidhfi"],
            wrong: ["fiei"],
        },
    },
];

const escapePossibleLevels: Level[] = [
    {
        id: "basic-skills-escape-possible-1",
        chapterId: "basic-skills",
        order: 49,
        title: { zh: "可逃跑 · 1/18", en: "Escape Possible · 1/18" },
        instruction: { zh: "当你的棋子受到攻击时，你通常想要逃跑。在尝试逃跑之前，请确保你能救活这些棋子。如果不能，就不应再往已死的棋块中添加棋子。白先。白棋能否救出被标记的棋串？", en: "If your stones are under attack, you would like to escape. Before you try to escape, make sure you can save your stones. If not, you should not add stones to a lost group. White to play. Can White escape with the marked chain?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "egdhei", white: "ggeh" },
            marks: { triangle: "eh" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "当你的棋子受到攻击时，你通常想要逃跑。在尝试逃跑之前，请确保你能救活这些棋子。如果不能，就不应再往已死的棋块中添加棋子。白先。白棋能否救出被标记的棋串？", en: "If your stones are under attack, you would like to escape. Before you try to escape, make sure you can save your stones. If not, you should not add stones to a lost group. White to play. Can White escape with the marked chain?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "yes",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "egdhei", white: "ggeh" },
                marks: { triangle: "eh" },
            },
        },
    },
    {
        id: "basic-skills-escape-possible-2",
        chapterId: "basic-skills",
        order: 50,
        title: { zh: "可逃跑 · 2/18", en: "Escape Possible · 2/18" },
        instruction: { zh: "白先。白棋能否救出被标记的棋串？", en: "White to play. Can White escape with the marked chain?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "ccdgfgeh", white: "gfeggg" },
            marks: { triangle: "eg" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋能否救出被标记的棋串？", en: "White to play. Can White escape with the marked chain?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "yes",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "ccdgfgeh", white: "gfeggg" },
                marks: { triangle: "eg" },
            },
        },
    },
    {
        id: "basic-skills-escape-possible-3",
        chapterId: "basic-skills",
        order: 51,
        title: { zh: "可逃跑 · 3/18", en: "Escape Possible · 3/18" },
        instruction: { zh: "白先。白棋能否救出被标记的棋串？", en: "White to play. Can White escape with the marked chain?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "ccdgegdhfh", white: "fgggehhh" },
            marks: { triangle: "eh" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋能否救出被标记的棋串？", en: "White to play. Can White escape with the marked chain?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "no",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "ccdgegdhfh", white: "fgggehhh" },
                marks: { triangle: "eh" },
            },
        },
    },
    {
        id: "basic-skills-escape-possible-4",
        chapterId: "basic-skills",
        order: 52,
        title: { zh: "可逃跑 · 4/18", en: "Escape Possible · 4/18" },
        instruction: { zh: "白先。白棋能否救出被标记的棋串？", en: "White to play. Can White escape with the marked chain?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "ccdgegchfhdi", white: "fgggdhehhh" },
            marks: { triangle: "ehdh" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋能否救出被标记的棋串？", en: "White to play. Can White escape with the marked chain?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "no",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "ccdgegchfhdi", white: "fgggdhehhh" },
                marks: { triangle: "ehdh" },
            },
        },
    },
    {
        id: "basic-skills-escape-possible-5",
        chapterId: "basic-skills",
        order: 53,
        title: { zh: "可逃跑 · 5/18", en: "Escape Possible · 5/18" },
        instruction: { zh: "白先。白棋能否救出被标记的棋串？", en: "White to play. Can White escape with the marked chain?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "eigi", white: "fi" },
            marks: { triangle: "fi" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋能否救出被标记的棋串？", en: "White to play. Can White escape with the marked chain?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "yes",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "eigi", white: "fi" },
                marks: { triangle: "fi" },
            },
        },
    },
    {
        id: "basic-skills-escape-possible-6",
        chapterId: "basic-skills",
        order: 54,
        title: { zh: "可逃跑 · 6/18", en: "Escape Possible · 6/18" },
        instruction: { zh: "白先。白棋能否救出被标记的棋串？", en: "White to play. Can White escape with the marked chain?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "ccehfhei", white: "ggghfi" },
            marks: { triangle: "fi" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋能否救出被标记的棋串？", en: "White to play. Can White escape with the marked chain?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "yes",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "ccehfhei", white: "ggghfi" },
                marks: { triangle: "fi" },
            },
        },
    },
    {
        id: "basic-skills-escape-possible-7",
        chapterId: "basic-skills",
        order: 55,
        title: { zh: "可逃跑 · 7/18", en: "Escape Possible · 7/18" },
        instruction: { zh: "白先。白棋能否救出被标记的棋串？", en: "White to play. Can White escape with the marked chain?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "ccceehfhdi", white: "gggheifi" },
            marks: { triangle: "fiei" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋能否救出被标记的棋串？", en: "White to play. Can White escape with the marked chain?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "yes",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "ccceehfhdi", white: "gggheifi" },
                marks: { triangle: "fiei" },
            },
        },
    },
    {
        id: "basic-skills-escape-possible-8",
        chapterId: "basic-skills",
        order: 56,
        title: { zh: "可逃跑 · 8/18", en: "Escape Possible · 8/18" },
        instruction: { zh: "白先。白棋能否救出被标记的棋串？", en: "White to play. Can White escape with the marked chain?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "ccehfhdi", white: "ggeifi" },
            marks: { triangle: "fiei" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋能否救出被标记的棋串？", en: "White to play. Can White escape with the marked chain?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "no",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "ccehfhdi", white: "ggeifi" },
                marks: { triangle: "fiei" },
            },
        },
    },
    {
        id: "basic-skills-escape-possible-9",
        chapterId: "basic-skills",
        order: 57,
        title: { zh: "可逃跑 · 9/18", en: "Escape Possible · 9/18" },
        instruction: { zh: "白先。白棋能否救出被标记的棋串？", en: "White to play. Can White escape with the marked chain?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "ccefdgfgdhfh", white: "gfegggehgh" },
            marks: { triangle: "eheg" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋能否救出被标记的棋串？", en: "White to play. Can White escape with the marked chain?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "no",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "ccefdgfgdhfh", white: "gfegggehgh" },
                marks: { triangle: "eheg" },
            },
        },
    },
    {
        id: "basic-skills-escape-possible-10",
        chapterId: "basic-skills",
        order: 58,
        title: { zh: "可逃跑 · 10/18", en: "Escape Possible · 10/18" },
        instruction: { zh: "白先。白棋能否救出被标记的棋串？", en: "White to play. Can White escape with the marked chain?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "ecgceeffdgfgeh", white: "gegfegggfhgh" },
            marks: { triangle: "eg" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋能否救出被标记的棋串？", en: "White to play. Can White escape with the marked chain?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "no",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "ecgceeffdgfgeh", white: "gegfegggfhgh" },
                marks: { triangle: "eg" },
            },
        },
    },
    {
        id: "basic-skills-escape-possible-11",
        chapterId: "basic-skills",
        order: 59,
        title: { zh: "可逃跑 · 11/18", en: "Escape Possible · 11/18" },
        instruction: { zh: "白先。白棋能否救出被标记的棋串？", en: "White to play. Can White escape with the marked chain?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "egehgheigi", white: "gdgffhfi" },
            marks: { triangle: "fifh" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋能否救出被标记的棋串？", en: "White to play. Can White escape with the marked chain?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "yes",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "egehgheigi", white: "gdgffhfi" },
                marks: { triangle: "fifh" },
            },
        },
    },
    {
        id: "basic-skills-escape-possible-12",
        chapterId: "basic-skills",
        order: 60,
        title: { zh: "可逃跑 · 12/18", en: "Escape Possible · 12/18" },
        instruction: { zh: "白先。白棋能否救出被标记的棋串？", en: "White to play. Can White escape with the marked chain?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "egggehgheigi", white: "gcgdgffhfi" },
            marks: { triangle: "fifh" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋能否救出被标记的棋串？", en: "White to play. Can White escape with the marked chain?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "no",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "egggehgheigi", white: "gcgdgffhfi" },
                marks: { triangle: "fifh" },
            },
        },
    },
    {
        id: "basic-skills-escape-possible-13",
        chapterId: "basic-skills",
        order: 61,
        title: { zh: "可逃跑 · 13/18", en: "Escape Possible · 13/18" },
        instruction: { zh: "白先。白棋能否救出被标记的棋串？", en: "White to play. Can White escape with the marked chain?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "efdgfgdhfh", white: "gcgeegeh" },
            marks: { triangle: "eheg" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋能否救出被标记的棋串？", en: "White to play. Can White escape with the marked chain?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "no",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "efdgfgdhfh", white: "gcgeegeh" },
                marks: { triangle: "eheg" },
            },
        },
    },
    {
        id: "basic-skills-escape-possible-14",
        chapterId: "basic-skills",
        order: 62,
        title: { zh: "可逃跑 · 14/18", en: "Escape Possible · 14/18" },
        instruction: { zh: "白先。白棋能否救出被标记的棋串？", en: "White to play. Can White escape with the marked chain?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "eeefgfegggfh", white: "hdgeffhffg" },
            marks: { triangle: "fgff" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋能否救出被标记的棋串？", en: "White to play. Can White escape with the marked chain?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "yes",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "eeefgfegggfh", white: "hdgeffhffg" },
                marks: { triangle: "fgff" },
            },
        },
    },
    {
        id: "basic-skills-escape-possible-15",
        chapterId: "basic-skills",
        order: 63,
        title: { zh: "可逃跑 · 15/18", en: "Escape Possible · 15/18" },
        instruction: { zh: "白先。白棋能否救出被标记的棋串？", en: "White to play. Can White escape with the marked chain?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "ccefffdgggehgh", white: "gegfegfghghh" },
            marks: { triangle: "fgeg" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋能否救出被标记的棋串？", en: "White to play. Can White escape with the marked chain?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "no",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "ccefffdgggehgh", white: "gegfegfghghh" },
                marks: { triangle: "fgeg" },
            },
        },
    },
    {
        id: "basic-skills-escape-possible-16",
        chapterId: "basic-skills",
        order: 64,
        title: { zh: "可逃跑 · 16/18", en: "Escape Possible · 16/18" },
        instruction: { zh: "白先。白棋能否救出被标记的棋串？", en: "White to play. Can White escape with the marked chain?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "ccffdgggehfhgh", white: "eegegfegfghghh" },
            marks: { triangle: "fgeg" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋能否救出被标记的棋串？", en: "White to play. Can White escape with the marked chain?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "yes",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "ccffdgggehfhgh", white: "eegegfegfghghh" },
                marks: { triangle: "fgeg" },
            },
        },
    },
    {
        id: "basic-skills-escape-possible-17",
        chapterId: "basic-skills",
        order: 65,
        title: { zh: "可逃跑 · 17/18", en: "Escape Possible · 17/18" },
        instruction: { zh: "白先。白棋能否救出被标记的棋串？", en: "White to play. Can White escape with the marked chain?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "dfefcgfgggeh", white: "ffgfhfeghg" },
            marks: { triangle: "eg" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋能否救出被标记的棋串？", en: "White to play. Can White escape with the marked chain?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "no",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "dfefcgfgggeh", white: "ffgfhfeghg" },
                marks: { triangle: "eg" },
            },
        },
    },
    {
        id: "basic-skills-escape-possible-18",
        chapterId: "basic-skills",
        order: 66,
        title: { zh: "可逃跑 · 18/18", en: "Escape Possible · 18/18" },
        instruction: { zh: "白先。白棋能否救出被标记的棋串？", en: "White to play. Can White escape with the marked chain?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "dgfgdhfhei", white: "ecgcegeh" },
            marks: { triangle: "eheg" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白先。白棋能否救出被标记的棋串？", en: "White to play. Can White escape with the marked chain?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "yes",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "dgfgdhfhei", white: "ecgcegeh" },
                marks: { triangle: "eheg" },
            },
        },
    },
];

const makeKoLevels: Level[] = [
    {
        id: "basic-skills-make-ko-1",
        chapterId: "basic-skills",
        order: 67,
        title: { zh: "制造劫 · 1/12", en: "Make Ko · 1/12" },
        instruction: { zh: "白先。黑棋已下1。白棋可以在A点连接，但有时在B点制造劫争更好。制造劫争。", en: "White to play. Black has played 1. White can connect his stones by playing at A, but sometimes it is better to make a ko by playing at B. Make a ko." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gceegefd", white: "feefgf" },
            marks: { 1: "fd", A: "ff", B: "fg" },
            correct: ["fg"],
        },
    },
    {
        id: "basic-skills-make-ko-2",
        chapterId: "basic-skills",
        order: 68,
        title: { zh: "制造劫 · 2/12", en: "Make Ko · 2/12" },
        instruction: { zh: "白先。黑棋已下1。制造劫争。", en: "White to play. Black has played 1. Make a ko." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "efegdhei", white: "fgehgh" },
            marks: { 1: "ei" },
            correct: ["fi"],
        },
    },
    {
        id: "basic-skills-make-ko-3",
        chapterId: "basic-skills",
        order: 69,
        title: { zh: "制造劫 · 3/12", en: "Make Ko · 3/12" },
        instruction: { zh: "白先。黑棋已下1。制造劫争。", en: "White to play. Black has played 1. Make a ko." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ffgffgehhg", white: "ccggfhhh" },
            marks: { 1: "hg" },
            correct: ["gi"],
        },
    },
    {
        id: "basic-skills-make-ko-4",
        chapterId: "basic-skills",
        order: 70,
        title: { zh: "制造劫 · 4/12", en: "Make Ko · 4/12" },
        instruction: { zh: "白先。黑棋已下1。制造劫争。", en: "White to play. Black has played 1. Make a ko." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "heffgfdgfgehif", white: "ccgchfggfhhh" },
            marks: { 1: "if" },
            correct: ["ig"],
        },
    },
    {
        id: "basic-skills-make-ko-5",
        chapterId: "basic-skills",
        order: 71,
        title: { zh: "制造劫 · 5/12", en: "Make Ko · 5/12" },
        instruction: { zh: "白先。黑棋已下1。制造劫争。", en: "White to play. Black has played 1. Make a ko." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "hffgggig", white: "hgghhi" },
            marks: { 1: "ig" },
            correct: ["ih"],
        },
    },
    {
        id: "basic-skills-make-ko-6",
        chapterId: "basic-skills",
        order: 72,
        title: { zh: "制造劫 · 6/12", en: "Make Ko · 6/12" },
        instruction: { zh: "白先。黑棋已下1。制造劫争。", en: "White to play. Black has played 1. Make a ko." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "fegfgghhgi", white: "ccfgehgh" },
            marks: { 1: "gi" },
            correct: ["fi"],
        },
    },
    {
        id: "basic-skills-make-ko-7",
        chapterId: "basic-skills",
        order: 73,
        title: { zh: "制造劫 · 7/12", en: "Make Ko · 7/12" },
        instruction: { zh: "白先。黑棋已下1。制造劫争。", en: "White to play. Black has played 1. Make a ko." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "fegeheieffifdgfgih", white: "ccgcgfhfggigfhgh" },
            marks: { 1: "ih" },
            correct: ["hh"],
        },
    },
    {
        id: "basic-skills-make-ko-8",
        chapterId: "basic-skills",
        order: 74,
        title: { zh: "制造劫 · 8/12", en: "Make Ko · 8/12" },
        instruction: { zh: "白先。黑棋已下1。制造劫争。", en: "White to play. Black has played 1. Make a ko." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "dfefffcggghgbhhhci", white: "ccgcdgegfgchehgh" },
            marks: { 1: "ci" },
            correct: ["di"],
        },
    },
    {
        id: "basic-skills-make-ko-9",
        chapterId: "basic-skills",
        order: 75,
        title: { zh: "制造劫 · 9/12", en: "Make Ko · 9/12" },
        instruction: { zh: "白先。黑棋已下1。制造劫争。", en: "White to play. Black has played 1. Make a ko." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "heffgfegif", white: "cchfgghh" },
            marks: { 1: "if" },
            correct: ["ig"],
        },
    },
    {
        id: "basic-skills-make-ko-10",
        chapterId: "basic-skills",
        order: 76,
        title: { zh: "制造劫 · 10/12", en: "Make Ko · 10/12" },
        instruction: { zh: "白先。黑棋已下1。制造劫争。", en: "White to play. Black has played 1. Make a ko." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "geefffegeheifihi", white: "ccgcfggghgfhgi" },
            marks: { 1: "hi" },
            correct: ["hh"],
        },
    },
    {
        id: "basic-skills-make-ko-11",
        chapterId: "basic-skills",
        order: 77,
        title: { zh: "制造劫 · 11/12", en: "Make Ko · 11/12" },
        instruction: { zh: "白先。黑棋已下1。制造劫争。", en: "White to play. Black has played 1. Make a ko." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gdhedfefffgfdgdhdieigi", white: "fbcceccehfegfgggehfi" },
            marks: { 1: "gi" },
            correct: ["gh"],
        },
    },
    {
        id: "basic-skills-make-ko-12",
        chapterId: "basic-skills",
        order: 78,
        title: { zh: "制造劫 · 12/12", en: "Make Ko · 12/12" },
        instruction: { zh: "白先。黑棋已下1。制造劫争。", en: "White to play. Black has played 1. Make a ko." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "hfcgegfgggig", white: "gdhgfhghhi" },
            marks: { 1: "ig" },
            correct: ["ih"],
        },
    },
];

const playDoubleAtariLevels: Level[] = [
    {
        id: "basic-skills-play_double_atari-1",
        chapterId: "basic-skills",
        order: 79,
        title: { zh: "下双打吃 · 1/18", en: "Play Double-Atari · 1/18" },
        instruction: { zh: "白棋可以用一颗棋子同时对两颗带标记的黑棋进行打吃，这称为'双打吃'。黑棋只能防守其中一颗棋子。对带标记的黑棋进行双打吃。", en: "White can put both marked stones in atari with one stone. This is called 'double-atari'. Black can only defend one of the stones. Play double-atari on the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ccfecfefdg", white: "geffeggg" },
            marks: { triangle: "effe", cross: "ee" },
            correct: ["ee"],
        },
    },
    {
        id: "basic-skills-play_double_atari-2",
        chapterId: "basic-skills",
        order: 80,
        title: { zh: "下双打吃 · 2/18", en: "Play Double-Atari · 2/18" },
        instruction: { zh: "白先。对带标记的黑棋进行双打吃。", en: "White to play. Play double-atari on the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gcefdgfghgchdhgh", white: "dedfbgcgegehfh" },
            marks: { triangle: "fgef" },
            correct: ["ff"],
        },
    },
    {
        id: "basic-skills-play_double_atari-3",
        chapterId: "basic-skills",
        order: 81,
        title: { zh: "下双打吃 · 3/18", en: "Play Double-Atari · 3/18" },
        instruction: { zh: "白先。对带标记的黑棋进行双打吃。", en: "White to play. Play double-atari on the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ccgcdegeefff", white: "cedfgfegfg" },
            marks: { triangle: "ffefde" },
            correct: ["ee"],
        },
    },
    {
        id: "basic-skills-play_double_atari-4",
        chapterId: "basic-skills",
        order: 82,
        title: { zh: "下双打吃 · 4/18", en: "Play Double-Atari · 4/18" },
        instruction: { zh: "白先。对带标记的黑棋进行双打吃。", en: "White to play. Play double-atari on the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gcbegebfcgggdhci", white: "ccbdaececfdgeg" },
            marks: { triangle: "cgbfbe" },
            correct: ["bg"],
        },
    },
    {
        id: "basic-skills-play_double_atari-5",
        chapterId: "basic-skills",
        order: 83,
        title: { zh: "下双打吃 · 5/18", en: "Play Double-Atari · 5/18" },
        instruction: { zh: "白先。对带标记的黑棋进行双打吃。", en: "White to play. Play double-atari on the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gcgdffegggehfi", white: "eeefdgdhdiei" },
            marks: { triangle: "fieheg" },
            correct: ["fh"],
        },
    },
    {
        id: "basic-skills-play_double_atari-6",
        chapterId: "basic-skills",
        order: 84,
        title: { zh: "下双打吃 · 6/18", en: "Play Double-Atari · 6/18" },
        instruction: { zh: "白先。对带标记的黑棋进行双打吃。", en: "White to play. Play double-atari on the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "fceddegecfdggg", white: "ebccecddbece" },
            marks: { triangle: "deed" },
            correct: ["ee"],
        },
    },
    {
        id: "basic-skills-play_double_atari-7",
        chapterId: "basic-skills",
        order: 85,
        title: { zh: "下双打吃 · 7/18", en: "Play Double-Atari · 7/18" },
        instruction: { zh: "白先。对带标记的黑棋进行双打吃。", en: "White to play. Play double-atari on the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gcgedfefegfhgi", white: "cecfdgcheheifi" },
            marks: { triangle: "gifh" },
            correct: ["gh"],
        },
    },
    {
        id: "basic-skills-play_double_atari-8",
        chapterId: "basic-skills",
        order: 86,
        title: { zh: "下双打吃 · 8/18", en: "Play Double-Atari · 8/18" },
        instruction: { zh: "白先。对带标记的黑棋进行双打吃。", en: "White to play. Play double-atari on the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "hegfdgegfg", white: "hdgedfefff" },
            marks: { triangle: "gfhe" },
            correct: ["hf"],
        },
    },
    {
        id: "basic-skills-play_double_atari-9",
        chapterId: "basic-skills",
        order: 87,
        title: { zh: "下双打吃 · 9/18", en: "Play Double-Atari · 9/18" },
        instruction: { zh: "白先。对带标记的黑棋进行双打吃。", en: "White to play. Play double-atari on the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "cdeddefebfcfgf", white: "eedfefffbgcggg" },
            marks: { triangle: "gffe" },
            correct: ["ge"],
        },
    },
    {
        id: "basic-skills-play_double_atari-10",
        chapterId: "basic-skills",
        order: 88,
        title: { zh: "下双打吃 · 10/18", en: "Play Double-Atari · 10/18" },
        instruction: { zh: "黑先。对带标记的白棋进行双打吃。", en: "Black to play. Play double-atari on the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "eccdeddecfcgeg", white: "gbgcfdeedfffdg" },
            marks: { triangle: "dgdfee" },
            correct: ["ef"],
        },
    },
    {
        id: "basic-skills-play_double_atari-11",
        chapterId: "basic-skills",
        order: 89,
        title: { zh: "下双打吃 · 11/18", en: "Play Double-Atari · 11/18" },
        instruction: { zh: "黑先。对带标记的白棋进行双打吃。", en: "Black to play. Play double-atari on the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "bfdfbgcgdgegfh", white: "cedecfeffgehgh" },
            marks: { triangle: "fgef" },
            correct: ["ff"],
        },
    },
    {
        id: "basic-skills-play_double_atari-12",
        chapterId: "basic-skills",
        order: 90,
        title: { zh: "下双打吃 · 12/18", en: "Play Double-Atari · 12/18" },
        instruction: { zh: "黑先。对带标记的白棋进行双打吃。", en: "Black to play. Play double-atari on the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "fdgdeehedfdgeh", white: "fegeefhfegggfh" },
            marks: { triangle: "egefgefe" },
            correct: ["ff"],
        },
    },
    {
        id: "basic-skills-play_double_atari-13",
        chapterId: "basic-skills",
        order: 91,
        title: { zh: "下双打吃 · 13/18", en: "Play Double-Atari · 13/18" },
        instruction: { zh: "黑先。对带标记的白棋进行双打吃。", en: "Black to play. Play double-atari on the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "efffgfdggghh", white: "hfegfghgghih" },
            marks: { triangle: "ghfgeg" },
            correct: ["fh"],
        },
    },
    {
        id: "basic-skills-play_double_atari-14",
        chapterId: "basic-skills",
        order: 92,
        title: { zh: "下双打吃 · 14/18", en: "Play Double-Atari · 14/18" },
        instruction: { zh: "黑先。对带标记的白棋进行双打吃。", en: "Black to play. Play double-atari on the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "efffgfdghg", white: "egggdhfhhh" },
            marks: { triangle: "ggeg" },
            correct: ["fg"],
        },
    },
    {
        id: "basic-skills-play_double_atari-15",
        chapterId: "basic-skills",
        order: 93,
        title: { zh: "下双打吃 · 15/18", en: "Play Double-Atari · 15/18" },
        instruction: { zh: "黑先。对带标记的白棋进行双打吃。", en: "Black to play. Play double-atari on the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "efffgfeghgih", white: "dgfgggchehhh" },
            marks: { triangle: "hhggfg" },
            correct: ["gh"],
        },
    },
    {
        id: "basic-skills-play_double_atari-16",
        chapterId: "basic-skills",
        order: 94,
        title: { zh: "下双打吃 · 16/18", en: "Play Double-Atari · 16/18" },
        instruction: { zh: "黑先。对带标记的白棋进行双打吃。", en: "Black to play. Play double-atari on the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "efffgfhfeghgih", white: "dgfgggigchehhh" },
            marks: { triangle: "hhggfg" },
            correct: ["gh"],
        },
    },
    {
        id: "basic-skills-play_double_atari-17",
        chapterId: "basic-skills",
        order: 95,
        title: { zh: "下双打吃 · 17/18", en: "Play Double-Atari · 17/18" },
        instruction: { zh: "黑先。对带标记的白棋进行双打吃。", en: "Black to play. Play double-atari on the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "dfhfdgfgggeh", white: "defeheefgfeg" },
            marks: { triangle: "eggfef" },
            correct: ["ff"],
        },
    },
    {
        id: "basic-skills-play_double_atari-18",
        chapterId: "basic-skills",
        order: 96,
        title: { zh: "下双打吃 · 18/18", en: "Play Double-Atari · 18/18" },
        instruction: { zh: "黑先。对带标记的白棋进行双打吃。", en: "Black to play. Play double-atari on the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "deeefedfgfbgcgbh", white: "efffdggghgchfhdi" },
            marks: { triangle: "dgffef" },
            correct: ["eg"],
        },
    },
];

const preventDoubleAtariLevels: Level[] = [
    {
        id: "basic-skills-prevent_double_atari-1",
        chapterId: "basic-skills",
        order: 97,
        title: { zh: "防止双打吃 · 1/9", en: "Prevent Double-Atari · 1/9" },
        instruction: { zh: "白先。防止双打吃。", en: "White to play. Prevent a double-atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "enaobocoapdpepfpfqer", white: "bpcpaqdqeqhqbrfrgr" },
            correct: ["dr", "cr", "cq", "bq"],
        },
    },
    {
        id: "basic-skills-prevent_double_atari-2",
        chapterId: "basic-skills",
        order: 98,
        title: { zh: "防止双打吃 · 2/9", en: "Prevent Double-Atari · 2/9" },
        instruction: { zh: "白先。防止双打吃。", en: "White to play. Prevent a double-atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndnenfneoeq", white: "gnbocodofoepcq" },
            correct: ["fp", "fq", "gp"],
        },
    },
    {
        id: "basic-skills-prevent_double_atari-3",
        chapterId: "basic-skills",
        order: 99,
        title: { zh: "防止双打吃 · 3/9", en: "Prevent Double-Atari · 3/9" },
        instruction: { zh: "白先。防止双打吃。", en: "White to play. Prevent a double-atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cnencodpepeqerdses", white: "bmbnbocpdqbrdrcs" },
            correct: ["cq", "cr", "bq", "bp"],
        },
    },
    {
        id: "basic-skills-prevent_double_atari-4",
        chapterId: "basic-skills",
        order: 100,
        title: { zh: "防止双打吃 · 4/9", en: "Prevent Double-Atari · 4/9" },
        instruction: { zh: "白先。防止双打吃。", en: "White to play. Prevent a double-atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cobpcqdqer", white: "bocpdpeqfr" },
            correct: ["ep", "eo", "fp", "fq", "do"],
        },
    },
    {
        id: "basic-skills-prevent_double_atari-5",
        chapterId: "basic-skills",
        order: 101,
        title: { zh: "防止双打吃 · 5/9", en: "Prevent Double-Atari · 5/9" },
        instruction: { zh: "白先。防止双打吃。", en: "White to play. Prevent a double-atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "blclamcmemcndodpcqeqcrbs", white: "bmbncoapcpbqarbr" },
            correct: ["bo", "ao"],
            wrong: ["bpan"],
        },
    },
    {
        id: "basic-skills-prevent_double_atari-6",
        chapterId: "basic-skills",
        order: 102,
        title: { zh: "防止双打吃 · 6/9", en: "Prevent Double-Atari · 6/9" },
        instruction: { zh: "白先。防止双打吃。", en: "White to play. Prevent a double-atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "endoeoepeqcreres", white: "dmdncodpcqbrdr" },
            correct: ["cs", "dq", "cp"],
        },
    },
    {
        id: "basic-skills-prevent_double_atari-7",
        chapterId: "basic-skills",
        order: 103,
        title: { zh: "防止双打吃 · 7/9", en: "Prevent Double-Atari · 7/9" },
        instruction: { zh: "白先。防止双打吃。", en: "White to play. Prevent a double-atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bodoeofocpfpbqbrbscs", white: "dpepgpcqfqcrerds" },
            correct: ["dq", "dr", "eq"],
        },
    },
    {
        id: "basic-skills-prevent_double_atari-8",
        chapterId: "basic-skills",
        order: 104,
        title: { zh: "防止双打吃 · 8/9", en: "Prevent Double-Atari · 8/9" },
        instruction: { zh: "白先。防止双打吃。", en: "White to play. Prevent a double-atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "ambmbncncofodpepeq", white: "anaobocpdqbrcrer" },
            correct: ["bp", "bq", "ap"],
            wrong: ["cqbp"],
        },
    },
    {
        id: "basic-skills-prevent_double_atari-9",
        chapterId: "basic-skills",
        order: 105,
        title: { zh: "防止双打吃 · 9/9", en: "Prevent Double-Atari · 9/9" },
        instruction: { zh: "白先。防止双打吃。", en: "White to play. Prevent a double-atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cndndodpcqeqarcrbscs", white: "bmbnaococpbqbr" },
            correct: ["bp", "bo", "ap"],
        },
    },
];

const connectedShapeLevels: Level[] = [
    {
        id: "basic-skills-connected-shape-1",
        chapterId: "basic-skills",
        order: 106,
        title: { zh: "连接形状 · 1/15", en: "Connected Shape · 1/15" },
        instruction: { zh: "这三颗白棋没有形成一个棋串，但它们是连接的。如果黑棋试图在1点落子切断，白棋可以在A点落子防止切断。防止黑棋切断。", en: "The three white stones do not form a chain; still, they are connected. If Black tries to cut the stones by playing 1, White can prevent the cut by playing at A. Prevent Black from cutting." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "fdheffeb", white: "edeegd" },
            marks: { 1: "fd", A: "fe" },
            correct: ["fegefc"],
        },
    },
    {
        id: "basic-skills-connected-shape-2",
        chapterId: "basic-skills",
        order: 107,
        title: { zh: "连接形状 · 2/15", en: "Connected Shape · 2/15" },
        instruction: { zh: "这两颗白棋可以在A点连接。防止黑棋切断。", en: "The two white stones can be connected by playing at A. Prevent Black from cutting." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ddff", white: "dffd" },
            marks: { A: "ee" },
            correct: ["eeedfeefde"],
        },
    },
    {
        id: "basic-skills-connected-shape-3",
        chapterId: "basic-skills",
        order: 108,
        title: { zh: "连接形状 · 3/15", en: "Connected Shape · 3/15" },
        instruction: { zh: "这两颗白棋可以直接连接，或在A或B点连接；这称为'虎口'或'虎口连接'。通过下虎口来防止黑棋切断。", en: "The two white stones can be connected directly, or by playing at A or B; this is called a 'hanging connection' or 'tiger's mouth'. Prevent Black from cutting by playing a tiger's mouth." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "cgdg", white: "dfeg" },
            marks: { A: "ee", B: "ff" },
            correct: ["ee", "ff"],
        },
    },
    {
        id: "basic-skills-connected-shape-4",
        chapterId: "basic-skills",
        order: 109,
        title: { zh: "连接形状 · 4/15", en: "Connected Shape · 4/15" },
        instruction: { zh: "白先。确保黑棋无法再切断白棋。", en: "White to play. Make sure black can no longer cut the white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "cdcgdgch", white: "efegdh" },
            correct: ["eh", "fh", "di", "ei"],
            wrong: ["fiehdicieifh"],
        },
    },
    {
        id: "basic-skills-connected-shape-5",
        chapterId: "basic-skills",
        order: 110,
        title: { zh: "连接形状 · 5/15", en: "Connected Shape · 5/15" },
        instruction: { zh: "白先。确保黑棋无法再切断白棋。", en: "White to play. Make sure black can no longer cut the white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ebcdddffgg", white: "fdgddfdg" },
            correct: ["ee"],
            wrong: ["efee", "deee", "edee", "feee"],
        },
    },
    {
        id: "basic-skills-connected-shape-6",
        chapterId: "basic-skills",
        order: 111,
        title: { zh: "连接形状 · 6/15", en: "Connected Shape · 6/15" },
        instruction: { zh: "白先。确保黑棋无法再切断白棋。", en: "White to play. Make sure black can no longer cut the white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gcddgddegedfgf", white: "edfdfffggghg" },
            correct: ["ef", "fe", "ee"],
        },
    },
    {
        id: "basic-skills-connected-shape-7",
        chapterId: "basic-skills",
        order: 112,
        title: { zh: "连接形状 · 7/15", en: "Connected Shape · 7/15" },
        instruction: { zh: "白先。确保黑棋无法再切断白棋。", en: "White to play. Make sure black can no longer cut the white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "eceddfefff", white: "ddfddefe" },
            correct: ["ee"],
        },
    },
    {
        id: "basic-skills-connected-shape-8",
        chapterId: "basic-skills",
        order: 113,
        title: { zh: "连接形状 · 8/15", en: "Connected Shape · 8/15" },
        instruction: { zh: "白先。确保黑棋无法再切断白棋。", en: "White to play. Make sure black can no longer cut the white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "edeefggg", white: "dfffeg" },
            correct: ["ef"],
        },
    },
    {
        id: "basic-skills-connected-shape-9",
        chapterId: "basic-skills",
        order: 114,
        title: { zh: "连接形状 · 9/15", en: "Connected Shape · 9/15" },
        instruction: { zh: "白先。确保黑棋无法再切断白棋。", en: "White to play. Make sure black can no longer cut the white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "eedfgfcgegfggh", white: "dcedfdcedeff" },
            correct: ["fe", "ge"],
            wrong: ["effe"],
        },
    },
    {
        id: "basic-skills-connected-shape-10",
        chapterId: "basic-skills",
        order: 115,
        title: { zh: "连接形状 · 10/15", en: "Connected Shape · 10/15" },
        instruction: { zh: "白先。确保黑棋无法再切断白棋。", en: "White to play. Make sure black can no longer cut the white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ccceeggg", white: "fdeecg" },
            correct: ["df"],
        },
    },
    {
        id: "basic-skills-connected-shape-11",
        chapterId: "basic-skills",
        order: 116,
        title: { zh: "连接形状 · 11/15", en: "Connected Shape · 11/15" },
        instruction: { zh: "白先。确保黑棋无法再切断白棋。", en: "White to play. Make sure black can no longer cut the white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "efegggfhfi", white: "dfdgehei" },
            correct: ["dh", "ch", "di"],
            wrong: ["cidhdich"],
        },
    },
    {
        id: "basic-skills-connected-shape-12",
        chapterId: "basic-skills",
        order: 117,
        title: { zh: "连接形状 · 12/15", en: "Connected Shape · 12/15" },
        instruction: { zh: "白先。确保黑棋无法再切断白棋。", en: "White to play. Make sure black can no longer cut the white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ccfcddcecfdf", white: "deeecgdgeg" },
            correct: ["ef"],
        },
    },
    {
        id: "basic-skills-connected-shape-13",
        chapterId: "basic-skills",
        order: 118,
        title: { zh: "连接形状 · 13/15", en: "Connected Shape · 13/15" },
        instruction: { zh: "白先。确保黑棋无法再切断白棋。", en: "White to play. Make sure black can no longer cut the white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "fagagbecfchceeef", white: "eaebfbdcdddedf" },
            correct: ["db", "cb", "da"],
            wrong: ["cadbdacb"],
        },
    },
    {
        id: "basic-skills-connected-shape-14",
        chapterId: "basic-skills",
        order: 119,
        title: { zh: "连接形状 · 14/15", en: "Connected Shape · 14/15" },
        instruction: { zh: "白先。确保黑棋无法再切断白棋。", en: "White to play. Make sure black can no longer cut the white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "adbdcddeeeefagbgcgegeh", white: "aebecebfdfdgbhchdhdi" },
            correct: ["cf", "ah"],
        },
    },
    {
        id: "basic-skills-connected-shape-15",
        chapterId: "basic-skills",
        order: 120,
        title: { zh: "连接形状 · 15/15", en: "Connected Shape · 15/15" },
        instruction: { zh: "白先。确保黑棋无法再切断白棋。", en: "White to play. Make sure black can no longer cut the white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "cccddeefffbg", white: "bcbdbedgeg" },
            correct: ["cf"],
            wrong: ["cecf", "cgcf", "dfcf", "bfcgcfdf", "bfcgdfcf"],
        },
    },
];

const basicSkillsCutLevels: Level[] = [
    {
        id: "basic-skills-basic-skills-cut-1",
        chapterId: "basic-skills",
        order: 121,
        title: { zh: "切断 · 1/6", en: "Cut · 1/6" },
        instruction: { zh: "黑先。切断白棋。", en: "Black to play. Cut the white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "gcedffgfegeh", white: "hchdgeggfhhh" },
            correct: ["hf"],
            wrong: ["hehf", "hghf", "gdhf"],
        },
    },
    {
        id: "basic-skills-basic-skills-cut-2",
        chapterId: "basic-skills",
        order: 122,
        title: { zh: "切断 · 2/6", en: "Cut · 2/6" },
        instruction: { zh: "黑先。切断白棋。", en: "Black to play. Cut the white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "gcfegehefffg", white: "dddfgfeggggh" },
            correct: ["fh"],
        },
    },
    {
        id: "basic-skills-basic-skills-cut-3",
        chapterId: "basic-skills",
        order: 123,
        title: { zh: "切断 · 3/6", en: "Cut · 3/6" },
        instruction: { zh: "黑先。切断白棋。", en: "Black to play. Cut the white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cdfdgeefffeg", white: "fbgcgdgffggg" },
            correct: ["he"],
        },
    },
    {
        id: "basic-skills-basic-skills-cut-4",
        chapterId: "basic-skills",
        order: 124,
        title: { zh: "切断 · 4/6", en: "Cut · 4/6" },
        instruction: { zh: "黑先。切断白棋。", en: "Black to play. Cut the white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "hcfdfeffgf", white: "gbfcgdgecg" },
            correct: ["gc"],
        },
    },
    {
        id: "basic-skills-basic-skills-cut-5",
        chapterId: "basic-skills",
        order: 125,
        title: { zh: "切断 · 5/6", en: "Cut · 5/6" },
        instruction: { zh: "黑先。切断白棋。", en: "Black to play. Cut the white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "gbfcffgf", white: "edgddedg" },
            correct: ["fd"],
        },
    },
    {
        id: "basic-skills-basic-skills-cut-6",
        chapterId: "basic-skills",
        order: 126,
        title: { zh: "切断 · 6/6", en: "Cut · 6/6" },
        instruction: { zh: "黑先。切断白棋。", en: "Black to play. Cut the white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "gbecfegeefegggeh", white: "ccfdgddeeedfdgch" },
            correct: ["ed"],
        },
    },
];

const connectWithHangingConnectionLevels: Level[] = [
    {
        id: "basic-skills-connect_with_hanging_connection-1",
        chapterId: "basic-skills",
        order: 127,
        title: { zh: "虎口连接 · 1/6", en: "Hanging connection · 1/6" },
        instruction: { zh: "白先。用虎口连接白棋。", en: "White to play. Connect the white stones with a hanging connection." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ffcgfggg", white: "gdgfhg" },
            correct: ["he"],
        },
    },
    {
        id: "basic-skills-connect_with_hanging_connection-2",
        chapterId: "basic-skills",
        order: 128,
        title: { zh: "虎口连接 · 2/6", en: "Hanging connection · 2/6" },
        instruction: { zh: "白先。用虎口连接白棋。", en: "White to play. Connect the white stones with a hanging connection." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "cdcfdfcg", white: "efdgch" },
            correct: ["eh"],
        },
    },
    {
        id: "basic-skills-connect_with_hanging_connection-3",
        chapterId: "basic-skills",
        order: 129,
        title: { zh: "虎口连接 · 3/6", en: "Hanging connection · 3/6" },
        instruction: { zh: "白先。用虎口连接白棋。", en: "White to play. Connect the white stones with a hanging connection." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ddefdgfgfhgh", white: "feffgghhgi" },
            correct: ["hf"],
        },
    },
    {
        id: "basic-skills-connect_with_hanging_connection-4",
        chapterId: "basic-skills",
        order: 130,
        title: { zh: "虎口连接 · 4/6", en: "Hanging connection · 4/6" },
        instruction: { zh: "白先。用虎口连接白棋。", en: "White to play. Connect the white stones with a hanging connection." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "bececfdgegfgfh", white: "afbfdfcgdheh" },
            correct: ["bh"],
        },
    },
    {
        id: "basic-skills-connect_with_hanging_connection-5",
        chapterId: "basic-skills",
        order: 131,
        title: { zh: "虎口连接 · 5/6", en: "Hanging connection · 5/6" },
        instruction: { zh: "白先。用虎口连接白棋。", en: "White to play. Connect the white stones with a hanging connection." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gccedeeeffeggghg", white: "bdcdddedfegfhf" },
            correct: ["gd"],
        },
    },
    {
        id: "basic-skills-connect_with_hanging_connection-6",
        chapterId: "basic-skills",
        order: 132,
        title: { zh: "虎口连接 · 6/6", en: "Hanging connection · 6/6" },
        instruction: { zh: "白先。用虎口连接白棋。", en: "White to play. Connect the white stones with a hanging connection." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "edbedecfbgfgbh", white: "gceefedfcgch" },
            correct: ["eg"],
        },
    },
];

const ladderLevels: Level[] = [
    {
        id: "basic-skills-ladder-1",
        chapterId: "basic-skills",
        order: 133,
        title: { zh: "征子 · 1/24", en: "Ladder · 1/24" },
        instruction: { zh: "黑先。带标记的棋串只有两口气。通过反复在白棋棋串的头部落子，黑棋可以吃掉带标记的棋子，这称为'征子'。黑棋应阻止白棋获得三口气。用征子吃掉带标记的白棋。", en: "Black to play. The marked chain has only two liberties. By repeatedly playing at the head of the white chain, Black can capture the marked stones. This is called a 'ladder'. Black should prevent White from creating three liberties. Capture the marked stones in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "ecfcddgdeeheffgg", white: "edfdfegegfhf" },
            marks: { triangle: "hfgfgefefded" },
            correct: ["ifhghh", "hg"],
            wrong: ["ifhgighh"],
        },
    },
    {
        id: "basic-skills-ladder-2",
        chapterId: "basic-skills",
        order: 134,
        title: { zh: "征子 · 2/24", en: "Ladder · 2/24" },
        instruction: { zh: "黑先。用征子吃掉带标记的白棋。", en: "Black to play. Capture the marked stones in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "ecfcddgdeeheff", white: "edfdfegegf" },
            marks: { triangle: "gfgefefded" },
            correct: ["gghfhg", "gghfifhghh"],
            wrong: ["gghfifhgighh", "hfgg"],
        },
    },
    {
        id: "basic-skills-ladder-3",
        chapterId: "basic-skills",
        order: 135,
        title: { zh: "征子 · 3/24", en: "Ladder · 3/24" },
        instruction: { zh: "黑先。用征子吃掉带标记的白棋。", en: "Black to play. Capture the marked stones in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "ecfcddgdeeff", white: "edfdfege" },
            marks: { triangle: "gefefded" },
            correct: ["hegfgghfifhghh", "hegfgghfhg"],
            wrong: ["hegfgghfifhgighh", "hegfhfgg", "gfhe"],
        },
    },
    {
        id: "basic-skills-ladder-4",
        chapterId: "basic-skills",
        order: 136,
        title: { zh: "征子 · 4/24", en: "Ladder · 4/24" },
        instruction: { zh: "黑先。用征子吃掉带标记的白棋。", en: "Black to play. Capture the marked stones in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "ecfcddgdee", white: "edfdfe" },
            marks: { triangle: "fefded" },
            correct: ["ffgehegfgghfifhghh", "ffgehegfgghfhg"],
            wrong: ["ffgehegfgghfifhgighh", "ffgehegfhfgg", "ffgegfhe", "geff"],
        },
    },
    {
        id: "basic-skills-ladder-5",
        chapterId: "basic-skills",
        order: 137,
        title: { zh: "征子 · 5/24", en: "Ladder · 5/24" },
        instruction: { zh: "黑先。用征子吃掉带标记的白棋。", en: "Black to play. Capture the marked stones in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "ecfcddee", white: "edfd" },
            marks: { triangle: "fded" },
            correct: ["gdfeffgehegfgghfifhghh", "gdfeffgehegfgghfhg"],
            wrong: ["gdfeffgehegfgghfifhgighh", "gdfeffgehegfhfgg", "gdfeffgegfhe", "gdfegeff", "fegd"],
        },
    },
    {
        id: "basic-skills-ladder-6",
        chapterId: "basic-skills",
        order: 138,
        title: { zh: "征子 · 6/24", en: "Ladder · 6/24" },
        instruction: { zh: "黑先。用征子吃掉带标记的白棋。", en: "Black to play. Capture the marked stone in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "ecfcdd", white: "ed" },
            marks: { triangle: "ed" },
            correct: ["eefdgdfeffgehegfgghfifhghh", "eefdgdfeffgehegfgghfhg"],
            wrong: ["eefdgdfeffgehegfgghfifhgighh", "eefdgdfeffgehegfhfgg", "eefdgdfeffgegfhe", "eefdgdfegeff", "eefdfegd", "fdee"],
        },
    },
    {
        id: "basic-skills-ladder-7",
        chapterId: "basic-skills",
        order: 139,
        title: { zh: "征子 · 7/24", en: "Ladder · 7/24" },
        instruction: { zh: "黑先。用征子吃掉带标记的白棋。", en: "Black to play. Capture the marked stones in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "fdfeefgfegfh", white: "edeedffffggg" },
            marks: { triangle: "ggfgff" },
            correct: ["hgghgihhih", "hgghgihhhi", "hgghhh"],
            wrong: ["ghhg"],
        },
    },
    {
        id: "basic-skills-ladder-8",
        chapterId: "basic-skills",
        order: 140,
        title: { zh: "征子 · 8/24", en: "Ladder · 8/24" },
        instruction: { zh: "黑先。用征子吃掉带标记的白棋。", en: "Black to play. Capture the marked stones in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "fdfeefgfeg", white: "edeedffffg" },
            marks: { triangle: "fgff" },
            correct: ["fhgghgghgihhih", "fhgghgghgihhhi", "fhgghgghhh"],
            wrong: ["fhggghhg", "ggfh"],
        },
    },
    {
        id: "basic-skills-ladder-9",
        chapterId: "basic-skills",
        order: 141,
        title: { zh: "征子 · 9/24", en: "Ladder · 9/24" },
        instruction: { zh: "黑先。用征子吃掉带标记的白棋。", en: "Black to play. Capture the marked stone in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "fdfeefeg", white: "edeedfff" },
            marks: { triangle: "ff" },
            correct: ["gffgfhgghgghgihhih", "gffgfhgghgghgihhhi", "gffgfhgghgghhh"],
            wrong: ["gffgfhggghhg", "gffgggfh", "fggf"],
        },
    },
    {
        id: "basic-skills-ladder-10",
        chapterId: "basic-skills",
        order: 142,
        title: { zh: "征子 · 10/24", en: "Ladder · 10/24" },
        instruction: { zh: "黑先。用征子吃掉带标记的白棋。", en: "Black to play. Capture the marked stones in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "edfeefgfggfh", white: "ecgdgeffegfg" },
            marks: { triangle: "fgegff" },
            correct: ["dgeheidhch", "dgehdh"],
            wrong: ["dgeheidhdich", "ehdg"],
        },
    },
    {
        id: "basic-skills-ladder-11",
        chapterId: "basic-skills",
        order: 143,
        title: { zh: "征子 · 11/24", en: "Ladder · 11/24" },
        instruction: { zh: "黑先。用征子吃掉带标记的白棋。", en: "Black to play. Capture the marked stones in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "edfeefgfgg", white: "ecgdgefffg" },
            marks: { triangle: "fgff" },
            correct: ["fhegdgeheidhch", "fhegdgehdh"],
            wrong: ["fhegdgeheidhdich", "fhegehdg", "egfh"],
        },
    },
    {
        id: "basic-skills-ladder-12",
        chapterId: "basic-skills",
        order: 144,
        title: { zh: "征子 · 12/24", en: "Ladder · 12/24" },
        instruction: { zh: "黑先。用征子吃掉带标记的白棋。", en: "Black to play. Capture the marked stone in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "edfegfgg", white: "ecgdgeff" },
            marks: { triangle: "ff" },
            correct: ["effgfhegdgeheidhch", "effgfhegdgehdh"],
            wrong: ["effgfhegdgeheidhdich", "effgfhegehdg", "effgegfh", "fgef"],
        },
    },
    {
        id: "basic-skills-ladder-13",
        chapterId: "basic-skills",
        order: 145,
        title: { zh: "征子 · 13/24", en: "Ladder · 13/24" },
        instruction: { zh: "白先。用征子吃掉带标记的黑棋。", en: "White to play. Capture the marked stone in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "dcfdgdgeff", white: "bceefegf" },
            marks: { triangle: "ff" },
            correct: ["fgefdfegehdgcgdhdichbh", "fgefdfegehdgcgdhch"],
            wrong: ["fgefdfegehdgcgdhdichcibh", "fgefdfegehdgdhcg", "fgefdfegdgeh", "fgefegdf", "effg"],
        },
    },
    {
        id: "basic-skills-ladder-14",
        chapterId: "basic-skills",
        order: 146,
        title: { zh: "征子 · 14/24", en: "Ladder · 14/24" },
        instruction: { zh: "白先。用征子吃掉带标记的黑棋。", en: "White to play. Capture the marked stones in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ddeddefeffgf", white: "fdeegeeffg" },
            marks: { triangle: "gffffe" },
            correct: ["hfggghhgighhhi", "hfggghhgighhih", "hfggghhghh"],
            wrong: ["hfgghggh", "gghf"],
        },
    },
    {
        id: "basic-skills-ladder-15",
        chapterId: "basic-skills",
        order: 147,
        title: { zh: "征子 · 15/24", en: "Ladder · 15/24" },
        instruction: { zh: "白先。用征子吃掉带标记的黑棋。", en: "White to play. Capture the marked stones in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ecedcedeeffffg", white: "fdeefedfgfeg" },
            marks: { triangle: "fgffef" },
            correct: ["fhgghgghgihhih", "fhgghgghgihhhi", "fhgghgghhh"],
            wrong: ["fhggghhg", "ggfh"],
        },
    },
    {
        id: "basic-skills-ladder-16",
        chapterId: "basic-skills",
        order: 148,
        title: { zh: "征子 · 16/24", en: "Ladder · 16/24" },
        instruction: { zh: "白先。用征子吃掉带标记的黑棋。", en: "White to play. Capture the marked stones in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ecgdgeefff", white: "fedfgffg" },
            marks: { triangle: "ffef" },
            correct: ["eeegehdgcgdhdichbh", "eeegehdgcgdhch"],
            wrong: ["eeegehdgcgdhdichcibh", "eeegehdgdhcg", "eeegdgeh", "egee"],
        },
    },
    {
        id: "basic-skills-ladder-17",
        chapterId: "basic-skills",
        order: 149,
        title: { zh: "征子 · 17/24", en: "Ladder · 17/24" },
        instruction: { zh: "白先。用征子吃掉带标记的黑棋。", en: "White to play. Capture the marked stones in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gcgdfeefffeggggh", white: "fdeegedfgffgfh" },
            marks: { triangle: "egffeffe" },
            correct: ["ehdgcgdhdichbh", "ehdgcgdhch"],
            wrong: ["ehdgcgdhdichcibh", "ehdgdhcg", "dgeh"],
        },
    },
    {
        id: "basic-skills-ladder-18",
        chapterId: "basic-skills",
        order: 150,
        title: { zh: "征子 · 18/24", en: "Ladder · 18/24" },
        instruction: { zh: "白先。用征子吃掉带标记的黑棋。", en: "White to play. Capture the marked stones in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gcgdfeefffgggh", white: "fdeegegffgfh" },
            marks: { triangle: "ffeffe" },
            correct: ["dfegehdgcgdhdichbh", "dfegehdgcgdhch"],
            wrong: ["dfegehdgcgdhdichcibh", "dfegehdgdhcg", "dfegdgeh", "egdf"],
        },
    },
    {
        id: "basic-skills-ladder-19",
        chapterId: "basic-skills",
        order: 151,
        title: { zh: "征子 · 19/24", en: "Ladder · 19/24" },
        instruction: { zh: "白先。用征子吃掉带标记的黑棋。", en: "White to play. Capture the marked stones in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "dcddcedfef", white: "deeeffdg" },
            marks: { triangle: "efdf" },
            correct: ["cfegehfgggfhfighhh", "cfegehfgggfhgh"],
            wrong: ["cfegehfgggfhfighgihh", "cfegehfgfhgg", "cfegfgeh", "egcf"],
        },
    },
    {
        id: "basic-skills-ladder-20",
        chapterId: "basic-skills",
        order: 152,
        title: { zh: "征子 · 20/24", en: "Ladder · 20/24" },
        instruction: { zh: "白先。用征子吃掉带标记的黑棋。", en: "White to play. Capture the marked stones in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gcdecfdfeffggg", white: "ddceeebfdgeg" },
            marks: { triangle: "efdfcfde" },
            correct: ["ffcgchbgagbhbi", "ffcgchbgagbhah", "ffcgchbgbh"],
            wrong: ["ffcgbgch", "cgff"],
        },
    },
    {
        id: "basic-skills-ladder-21",
        chapterId: "basic-skills",
        order: 153,
        title: { zh: "征子 · 21/24", en: "Ladder · 21/24" },
        instruction: { zh: "白先。用征子吃掉带标记的黑棋。", en: "White to play. Capture the marked stone in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ecedeedf", white: "cededg" },
            marks: { triangle: "df" },
            correct: ["efcfbfcgchbgagbhbi", "efcfbfcgchbgagbhah", "efcfbfcgchbgbh"],
            wrong: ["efcfbfcgbgch", "efcfcgbf", "cfef"],
        },
    },
    {
        id: "basic-skills-ladder-22",
        chapterId: "basic-skills",
        order: 154,
        title: { zh: "征子 · 22/24", en: "Ladder · 22/24" },
        instruction: { zh: "白先。用征子吃掉带标记的黑棋。", en: "White to play. Capture the marked stone in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ecedeedf", white: "deefdh" },
            marks: { triangle: "df" },
            correct: ["cfdgegcgbgchcibhah", "cfdgegcgbgchcibhbi", "cfdgegcgbgchbh"],
            wrong: ["cfdgegcgchbg", "cfdgcgeg", "dgcf"],
        },
    },
    {
        id: "basic-skills-ladder-23",
        chapterId: "basic-skills",
        order: 155,
        title: { zh: "征子 · 23/24", en: "Ladder · 23/24" },
        instruction: { zh: "白先。用征子吃掉带标记的黑棋。", en: "White to play. Capture the marked stones in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "dbecedcededf", white: "cdddbeeeef" },
            marks: { triangle: "dfdece" },
            correct: ["dgcfbfcgchbgagbhbi", "dgcfbfcgchbgagbhah", "dgcfbfcgchbgbh", "dgcfcgbfafbgbh", "dgcfcgbfbg"],
            wrong: ["dgcfbfcgbgch", "dgcfcgbfafbgagbh", "cfdg"],
        },
    },
    {
        id: "basic-skills-ladder-24",
        chapterId: "basic-skills",
        order: 156,
        title: { zh: "征子 · 24/24", en: "Ladder · 24/24" },
        instruction: { zh: "白先。用征子吃掉带标记的黑棋。", en: "White to play. Capture the marked stones in a ladder." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "dcecdecfdfefdg", white: "ddceeeffegdh" },
            marks: { triangle: "dgefdfcfde" },
            correct: ["bfcgchbgagbhbi", "bfcgchbgagbhah", "bfcgchbgbh", "bfcgbgchcibhah", "bfcgbgchcibhbi", "bfcgbgchbh"],
            wrong: ["cgbf"],
        },
    },
];

const shortageLibertiesLevels: Level[] = [
    {
        id: "basic-skills-shortage-liberties-1",
        chapterId: "basic-skills",
        order: 157,
        title: { zh: "气不够 · 1/12", en: "Shortage Liberties · 1/12" },
        instruction: { zh: "黑棋可以在A点落子对带标记的白棋进行打吃。接下来，白棋可以在B点连接，但白棋仍然处于被打吃状态，这称为'气不够'。利用白棋气不够吃掉带标记的白棋。", en: "Black can put the marked stones in atari by playing at A. Next, White can connect at B, but the white stones will still be in atari. This is called 'shortage of liberties'. Capture the marked stones using a shortage of liberties for White." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "afbfagcgahai", white: "bgbhdhci" },
            marks: { triangle: "bhbg", A: "ch", B: "bi" },
            correct: ["chbidi"],
            wrong: ["bich"],
        },
    },
    {
        id: "basic-skills-shortage-liberties-2",
        chapterId: "basic-skills",
        order: 158,
        title: { zh: "气不够 · 2/12", en: "Shortage Liberties · 2/12" },
        instruction: { zh: "黑先。利用白棋气不够吃掉带标记的白棋。", en: "Black to play. Capture the marked stones using a shortage of liberties for White." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "gfdgegfgdhgh", white: "cfcgchehfhdi" },
            marks: { triangle: "fheh" },
            correct: ["fi", "eifigi"],
            wrong: ["gieifici"],
        },
    },
    {
        id: "basic-skills-shortage-liberties-3",
        chapterId: "basic-skills",
        order: 159,
        title: { zh: "气不够 · 3/12", en: "Shortage Liberties · 3/12" },
        instruction: { zh: "黑先。利用白棋气不够吃掉带标记的白棋。", en: "Black to play. Capture the marked stones using a shortage of liberties for White." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "dfcgegfgchdi", white: "dgggdhehghfi" },
            marks: { triangle: "ehdhdg" },
            correct: ["fh"],
            wrong: ["eici", "cifh"],
        },
    },
    {
        id: "basic-skills-shortage-liberties-4",
        chapterId: "basic-skills",
        order: 160,
        title: { zh: "气不够 · 4/12", en: "Shortage Liberties · 4/12" },
        instruction: { zh: "黑先。利用白棋气不够吃掉带标记的白棋。", en: "Black to play. Capture the marked stones using a shortage of liberties for White." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cccecgdgegfgbheh", white: "ffggchdhfhghciei" },
            marks: { triangle: "cidhch" },
            correct: ["bi"],
        },
    },
    {
        id: "basic-skills-shortage-liberties-5",
        chapterId: "basic-skills",
        order: 161,
        title: { zh: "气不够 · 5/12", en: "Shortage Liberties · 5/12" },
        instruction: { zh: "黑先。利用白棋气不够吃掉带标记的白棋。", en: "Black to play. Capture the marked stones using a shortage of liberties for White." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cedfagbgcgch", white: "dgfgbhdhaici" },
            marks: { triangle: "aibh" },
            correct: ["ah"],
        },
    },
    {
        id: "basic-skills-shortage-liberties-6",
        chapterId: "basic-skills",
        order: 162,
        title: { zh: "气不够 · 6/12", en: "Shortage Liberties · 6/12" },
        instruction: { zh: "黑先。利用白棋气不够吃掉带标记的白棋。", en: "Black to play. Capture the marked stones using a shortage of liberties for White." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "gfcgdgegfgchghgi", white: "cfbgbhdhehfhciei" },
            marks: { triangle: "eifhehdh" },
            correct: ["fi"],
        },
    },
    {
        id: "basic-skills-shortage-liberties-7",
        chapterId: "basic-skills",
        order: 163,
        title: { zh: "气不够 · 7/12", en: "Shortage Liberties · 7/12" },
        instruction: { zh: "黑先。利用白棋气不够吃掉带标记的白棋。", en: "Black to play. Capture the marked stones using a shortage of liberties for White." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "gfdgegfgchci", white: "ggdhehghdifi" },
            marks: { triangle: "diehdh" },
            correct: ["fh"],
        },
    },
    {
        id: "basic-skills-shortage-liberties-8",
        chapterId: "basic-skills",
        order: 164,
        title: { zh: "气不够 · 8/12", en: "Shortage Liberties · 8/12" },
        instruction: { zh: "黑先。利用白棋气不够吃掉带标记的白棋。", en: "Black to play. Capture the marked stones using a shortage of liberties for White." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cebfefffbgfgchdi", white: "dddecfcgegggdhfh" },
            marks: { triangle: "cgcf" },
            correct: ["df"],
            wrong: ["dgdf"],
        },
    },
    {
        id: "basic-skills-shortage-liberties-9",
        chapterId: "basic-skills",
        order: 165,
        title: { zh: "气不够 · 9/12", en: "Shortage Liberties · 9/12" },
        instruction: { zh: "黑先。利用白棋气不够吃掉带标记的白棋。", en: "Black to play. Capture the marked stones using a shortage of liberties for White." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "geefhffgggigfhih", white: "dfcgeghgehghhhfi" },
            marks: { triangle: "hhghhg" },
            correct: ["hi"],
            wrong: ["gihi"],
        },
    },
    {
        id: "basic-skills-shortage-liberties-10",
        chapterId: "basic-skills",
        order: 166,
        title: { zh: "气不够 · 10/12", en: "Shortage Liberties · 10/12" },
        instruction: { zh: "黑先。利用白棋气不够吃掉带标记的白棋。", en: "Black to play. Capture the marked stones using a shortage of liberties for White." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "edfdbecedegecfgfehfh", white: "eefeafbfdfffcgegbhdh" },
            marks: { triangle: "fffeee" },
            correct: ["fg"],
        },
    },
    {
        id: "basic-skills-shortage-liberties-11",
        chapterId: "basic-skills",
        order: 167,
        title: { zh: "气不够 · 11/12", en: "Shortage Liberties · 11/12" },
        instruction: { zh: "黑先。利用白棋气不够吃掉带标记的白棋。", en: "Black to play. Capture the marked stones using a shortage of liberties for White." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "dgegfgggchhhhi", white: "cgbhdhehghfigi" },
            marks: { triangle: "gifigh" },
            correct: ["fh"],
            wrong: ["dicifhei", "eidifhcieifi"],
        },
    },
    {
        id: "basic-skills-shortage-liberties-12",
        chapterId: "basic-skills",
        order: 168,
        title: { zh: "气不够 · 12/12", en: "Shortage Liberties · 12/12" },
        instruction: { zh: "黑先。利用白棋气不够吃掉带标记的白棋。", en: "Black to play. Capture the marked stones using a shortage of liberties for White." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "eddeefegfgchdhgh", white: "fdffgfggehfhcidi" },
            marks: { triangle: "ehfhcidi" },
            correct: ["fibheibibgagafcgah", "fibheibibgagah", "fibheibibgagai", "eifigibhbgagbiaiafcgeibiah", "eifigibheibibg"],
            wrong: ["bihheigi", "bihhgihieifi", "bihhgihifiei", "eifigibhbgagafcgdgbfeibi", "eifigibhbgagafcgeibfbicd"],
        },
    },
];

const falseEyeLevels: Level[] = [
    {
        id: "basic-skills-false-eye-1",
        chapterId: "basic-skills",
        order: 169,
        title: { zh: "假眼 · 1/18", en: "False Eye · 1/18" },
        instruction: { zh: "黑棋有两个眼，但A点的眼不安全。白先。使A点的眼成为假眼，从而吃掉黑棋棋块。", en: "Black has two eyes, but the eye at A is not safe. White to play. Make the eye at A false, capturing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "fhghhhihdieigi", white: "egfggghgigchdh" },
            marks: { A: "fi", cross: "eh" },
            correct: ["eh"],
            wrong: ["cieh"],
        },
    },
    {
        id: "basic-skills-false-eye-2",
        chapterId: "basic-skills",
        order: 170,
        title: { zh: "假眼 · 2/18", en: "False Eye · 2/18" },
        instruction: { zh: "白先。使A点的眼成为假眼，从而吃掉黑棋棋块。", en: "White to play. Make eye A false capturing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ceahbhdhehciei", white: "bgcgdgegggfh" },
            marks: { A: "di" },
            correct: ["ch"],
            wrong: ["fich", "agch"],
        },
    },
    {
        id: "basic-skills-false-eye-3",
        chapterId: "basic-skills",
        order: 171,
        title: { zh: "假眼 · 3/18", en: "False Eye · 3/18" },
        instruction: { zh: "白先。使A点的眼成为假眼，从而吃掉黑棋棋块。", en: "White to play. Make eye A false capturing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ccfhghhhihdieigi", white: "gehfiffgggchdh" },
            marks: { A: "fi" },
            correct: ["eh"],
            wrong: ["cieh"],
        },
    },
    {
        id: "basic-skills-false-eye-4",
        chapterId: "basic-skills",
        order: 172,
        title: { zh: "假眼 · 4/18", en: "False Eye · 4/18" },
        instruction: { zh: "白先。使A点的眼成为假眼，从而吃掉黑棋棋块。", en: "White to play. Make eye A false capturing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gcahbhchdhcieifi", white: "cebgcgegfhghgi" },
            marks: { A: "di" },
            correct: ["eh"],
            wrong: ["ageh", "dgeh"],
        },
    },
    {
        id: "basic-skills-false-eye-5",
        chapterId: "basic-skills",
        order: 173,
        title: { zh: "假眼 · 5/18", en: "False Eye · 5/18" },
        instruction: { zh: "白先。使A点的眼成为假眼，从而吃掉黑棋棋块。", en: "White to play. Make eye A false capturing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ahbhchdhehdifigi", white: "bgcgdgegggghbi" },
            marks: { A: "ei" },
            correct: ["fh"],
            wrong: ["hifh", "agfh"],
        },
    },
    {
        id: "basic-skills-false-eye-6",
        chapterId: "basic-skills",
        order: 174,
        title: { zh: "假眼 · 6/18", en: "False Eye · 6/18" },
        instruction: { zh: "白先。使A点的眼成为假眼，从而吃掉黑棋棋块。", en: "White to play. Make eye A false capturing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gcafbgahbhchdh", white: "bdcecgdgegeh" },
            marks: { A: "ag" },
            correct: ["bf"],
            wrong: ["dibf"],
        },
    },
    {
        id: "basic-skills-false-eye-7",
        chapterId: "basic-skills",
        order: 175,
        title: { zh: "假眼 · 7/18", en: "False Eye · 7/18" },
        instruction: { zh: "白先。使A点的眼成为假眼，从而吃掉黑棋棋块。", en: "White to play. Make eye A false capturing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "afbfbgbhchbidieifi", white: "bececfcgegggahgh" },
            marks: { A: "ci" },
            correct: ["dh"],
        },
    },
    {
        id: "basic-skills-false-eye-8",
        chapterId: "basic-skills",
        order: 176,
        title: { zh: "假眼 · 8/18", en: "False Eye · 8/18" },
        instruction: { zh: "白先。使A点的眼成为假眼，从而吃掉黑棋棋块。", en: "White to play. Make eye A false capturing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ebfchddfcgegchdhehciei", white: "ddeebfcfffbgfgbhfhbi" },
            marks: { A: "dg" },
            correct: ["ef"],
            wrong: ["deef"],
        },
    },
    {
        id: "basic-skills-false-eye-9",
        chapterId: "basic-skills",
        order: 177,
        title: { zh: "假眼 · 9/18", en: "False Eye · 9/18" },
        instruction: { zh: "白先。使A点的眼成为假眼，从而吃掉黑棋棋块。", en: "White to play. Make eye A false capturing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gcahbhdhehciei", white: "dfefbgcgfgfh" },
            marks: { A: "bi" },
            correct: ["ch"],
            wrong: ["bich", "dgch"],
        },
    },
    {
        id: "basic-skills-false-eye-10",
        chapterId: "basic-skills",
        order: 178,
        title: { zh: "假眼 · 10/18", en: "False Eye · 10/18" },
        instruction: { zh: "白先。使A点的眼成为假眼，从而吃掉黑棋棋块。", en: "White to play. Make eye A false capturing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "dccddgegahbhchehcidi", white: "febfdfefbgfgfheifi" },
            marks: { A: "dh" },
            correct: ["cg"],
        },
    },
    {
        id: "basic-skills-false-eye-11",
        chapterId: "basic-skills",
        order: 179,
        title: { zh: "假眼 · 11/18", en: "False Eye · 11/18" },
        instruction: { zh: "白先。使A点的眼成为假眼，从而吃掉黑棋棋块。", en: "White to play. Make eye A false capturing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ecgdahbhdhehfhei", white: "cfbgdgegfggggh" },
            marks: { A: "bi" },
            correct: ["ch"],
            wrong: ["cgch", "gich"],
        },
    },
    {
        id: "basic-skills-false-eye-12",
        chapterId: "basic-skills",
        order: 180,
        title: { zh: "假眼 · 12/18", en: "False Eye · 12/18" },
        instruction: { zh: "白先。使A点的眼成为假眼，从而吃掉黑棋棋块。", en: "White to play. Make eye A false capturing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gcgdcedebfdfgfbgcgbhdhbicidi", white: "ecbdcdddbeeeafefagegahehei" },
            marks: { A: "cf" },
            correct: ["dg"],
        },
    },
    {
        id: "basic-skills-false-eye-13",
        chapterId: "basic-skills",
        order: 181,
        title: { zh: "假眼 · 13/18", en: "False Eye · 13/18" },
        instruction: { zh: "白先。阻止黑棋将白棋的眼做成假眼。", en: "White to play. Prevent Black from making a white eye false." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "deeegecfffbgggbhghbieifigi", white: "ebccgcdfefdgfgchehfhcidi" },
            correct: ["cg"],
        },
    },
    {
        id: "basic-skills-false-eye-14",
        chapterId: "basic-skills",
        order: 182,
        title: { zh: "假眼 · 14/18", en: "False Eye · 14/18" },
        instruction: { zh: "白先。阻止黑棋将白棋的眼做成假眼。", en: "White to play. Prevent Black from making a white eye false." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "bebgcgdgehfh", white: "ahbhchbidi" },
            correct: ["dh"],
        },
    },
    {
        id: "basic-skills-false-eye-15",
        chapterId: "basic-skills",
        order: 183,
        title: { zh: "假眼 · 15/18", en: "False Eye · 15/18" },
        instruction: { zh: "白先。阻止黑棋将白棋的眼做成假眼。", en: "White to play. Prevent Black from making a white eye false." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ddedcefecfffbgfgbhfhbi", white: "dedfcgegchdhehciei" },
            correct: ["ef"],
        },
    },
    {
        id: "basic-skills-false-eye-16",
        chapterId: "basic-skills",
        order: 184,
        title: { zh: "假眼 · 16/18", en: "False Eye · 16/18" },
        instruction: { zh: "白先。阻止黑棋将白棋的眼做成假眼。", en: "White to play. Prevent Black from making a white eye false." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "bfffcgdgegfhdieifi", white: "ecgdbgahchdhehbi" },
            correct: ["ci"],
            wrong: ["agci"],
        },
    },
    {
        id: "basic-skills-false-eye-17",
        chapterId: "basic-skills",
        order: 185,
        title: { zh: "假眼 · 17/18", en: "False Eye · 17/18" },
        instruction: { zh: "白先。阻止黑棋将白棋的眼做成假眼。", en: "White to play. Prevent Black from making a white eye false." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "cfffbgdgegfhfi", white: "ahchdhehbiei" },
            correct: ["bh"],
            wrong: ["cibh"],
        },
    },
    {
        id: "basic-skills-false-eye-18",
        chapterId: "basic-skills",
        order: 186,
        title: { zh: "假眼 · 18/18", en: "False Eye · 18/18" },
        instruction: { zh: "白先。阻止黑棋将白棋的眼做成假眼。", en: "White to play. Prevent Black from making a white eye false." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ddedfdcegecfgfbgggbhfhghcidi", white: "ebfbgchcdeeedfffcgegfgdheh" },
            correct: ["ch"],
            wrong: ["fech"],
        },
    },
];

const largeEyeLevels: Level[] = [
    {
        id: "basic-skills-large-eye-1",
        chapterId: "basic-skills",
        order: 187,
        title: { zh: "大眼 · 1/29", en: "Large Eye · 1/29" },
        instruction: { zh: "黑棋有一个3目的大眼。为确保棋块安全，黑棋需要两个眼。黑先。通过落子于'要点'来做成两个眼。", en: "Black has a large eye of 3 points. For a safe group, Black needs two eyes. Black to play. Make two eyes, by playing at the 'vital point'." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "agbgbhchci", white: "afbfcfcgdgdhdi" },
            marks: { cross: "ai" },
            correct: ["ai"],
        },
    },
    {
        id: "basic-skills-large-eye-2",
        chapterId: "basic-skills",
        order: 188,
        title: { zh: "大眼 · 2/29", en: "Large Eye · 2/29" },
        instruction: { zh: "黑棋又有一个3目的眼形。黑先。通过落子于要点来做成两个眼。", en: "Again, Black has a 3-points eye shape. Black to play. Make two eyes, by playing at the vital point." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "afbfbgbhbi", white: "aebececfcgchci" },
            marks: { cross: "ah" },
            correct: ["ah"],
        },
    },
    {
        id: "basic-skills-large-eye-3",
        chapterId: "basic-skills",
        order: 189,
        title: { zh: "大眼 · 3/29", en: "Large Eye · 3/29" },
        instruction: { zh: "黑棋有一个4目的眼形。黑先。通过落子于要点来做成两个眼。", en: "Black has a 4-points eye shape. Black to play. Make two eyes, by playing at the vital point." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cichdhdgegfgfhghgi", white: "bibhbgcgcfdfefffgfgghghhhi" },
            marks: { cross: "ei" },
            correct: ["ei"],
        },
    },
    {
        id: "basic-skills-large-eye-4",
        chapterId: "basic-skills",
        order: 190,
        title: { zh: "大眼 · 4/29", en: "Large Eye · 4/29" },
        instruction: { zh: "黑棋有一个5目的眼形。黑先。通过落子于要点来做成两个或更多眼。", en: "Black has a 5-points eye shape. Black to play. Make two (or more) eyes, by playing at the vital point." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cdcecfdcdddfdgecegfcfdfffggdgegf", white: "bcbdbebfbgcbcccgchdbdhebehfbfhgbgcggghhchdhehfhg" },
            marks: { cross: "ee" },
            correct: ["ee"],
        },
    },
    {
        id: "basic-skills-large-eye-5",
        chapterId: "basic-skills",
        order: 191,
        title: { zh: "大眼 · 5/29", en: "Large Eye · 5/29" },
        instruction: { zh: "黑棋有一个5目的眼形。黑先。通过落子于要点来做成两个眼。", en: "Black has a 5-points eye shape. Black to play. Make two eyes, by playing at the vital point." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cdcecfdcdddfeceffcffgdgegf", white: "bcbdbebfbgcbcccgdbdgebegfbfggbgcgghchdhehfhg" },
            marks: { cross: "ee" },
            correct: ["ee"],
        },
    },
    {
        id: "basic-skills-large-eye-6",
        chapterId: "basic-skills",
        order: 192,
        title: { zh: "大眼 · 6/29", en: "Large Eye · 6/29" },
        instruction: { zh: "白先。做成两个眼，使白棋块活棋。", en: "White to play. Make two eyes so the white group lives." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gbhcfdgdfefffgghhh", white: "hdgeiegfcggghgig" },
            correct: ["hf"],
        },
    },
    {
        id: "basic-skills-large-eye-7",
        chapterId: "basic-skills",
        order: 193,
        title: { zh: "大眼 · 7/29", en: "Large Eye · 7/29" },
        instruction: { zh: "白先。做成两个眼，使白棋块活棋。", en: "White to play. Make two eyes so the white group lives." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "hcgehegfifegggfh", white: "cchfhgigghihgi" },
            correct: ["hi"],
        },
    },
    {
        id: "basic-skills-large-eye-8",
        chapterId: "basic-skills",
        order: 194,
        title: { zh: "大眼 · 8/29", en: "Large Eye · 8/29" },
        instruction: { zh: "白先。做成两个眼，使白棋块活棋。", en: "White to play. Make two eyes so the white group lives." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gehffgggdhfh", white: "hgigghfihi" },
            correct: ["ih"],
        },
    },
    {
        id: "basic-skills-large-eye-9",
        chapterId: "basic-skills",
        order: 195,
        title: { zh: "大眼 · 9/29", en: "Large Eye · 9/29" },
        instruction: { zh: "白先。做成两个眼，使白棋块活棋。", en: "White to play. Make two eyes so the white group lives." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "fdheffhffgfhfigi", white: "ccifgghgigghhi" },
            correct: ["ih"],
        },
    },
    {
        id: "basic-skills-large-eye-10",
        chapterId: "basic-skills",
        order: 196,
        title: { zh: "大眼 · 10/29", en: "Large Eye · 10/29" },
        instruction: { zh: "白先。做成两个眼，使白棋块活棋。", en: "White to play. Make two eyes so the white group lives." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "eefegeheefhfdgigdhihdi", white: "ccffgffghgehhheifihi" },
            correct: ["gh"],
        },
    },
    {
        id: "basic-skills-large-eye-11",
        chapterId: "basic-skills",
        order: 197,
        title: { zh: "大眼 · 11/29", en: "Large Eye · 11/29" },
        instruction: { zh: "白先。做成两个眼，使白棋块活棋。", en: "White to play. Make two eyes so the white group lives." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "geheieefgffgfhfi", white: "hfifgghgghgihi" },
            correct: ["ih"],
        },
    },
    {
        id: "basic-skills-large-eye-12",
        chapterId: "basic-skills",
        order: 198,
        title: { zh: "大眼 · 12/29", en: "Large Eye · 12/29" },
        instruction: { zh: "白先。做成两个眼，使白棋块活棋。", en: "White to play. Make two eyes so the white group lives." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ebfbgbbcccdchcadcdhdcehehfbgcgdghgehfhgh", white: "ecfcgcbdddedgdbedegeafbfcfdfefgfegfggg" },
            correct: ["fe"],
        },
    },
    {
        id: "basic-skills-large-eye-13",
        chapterId: "basic-skills",
        order: 199,
        title: { zh: "大眼 · 13/29", en: "Large Eye · 13/29" },
        instruction: { zh: "白先。做成两个眼，使白棋块活棋。", en: "White to play. Make two eyes so the white group lives." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "fbgbhbibfcicedeefffggghgig", white: "ccgchcfdgdidcefegfhfifcg" },
            correct: ["he"],
        },
    },
    {
        id: "basic-skills-large-eye-14",
        chapterId: "basic-skills",
        order: 200,
        title: { zh: "大眼 · 14/29", en: "Large Eye · 14/29" },
        instruction: { zh: "白先。做成两个眼，使白棋块活棋。", en: "White to play. Make two eyes so the white group lives." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gbhbibgcfdfefffgggghhh", white: "cchcicgdcegegfifcghg" },
            correct: ["he"],
            wrong: ["hdieheih"],
        },
    },
    {
        id: "basic-skills-large-eye-15",
        chapterId: "basic-skills",
        order: 201,
        title: { zh: "大眼 · 15/29", en: "Large Eye · 15/29" },
        instruction: { zh: "白先。做成两个眼，使白棋块活棋。", en: "White to play. Make two eyes so the white group lives." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "geheiegffgfh", white: "hfifggghhi" },
            correct: ["ih"],
            wrong: ["hhig"],
        },
    },
    {
        id: "basic-skills-large-eye-16",
        chapterId: "basic-skills",
        order: 202,
        title: { zh: "大眼 · 16/29", en: "Large Eye · 16/29" },
        instruction: { zh: "白先。做成两个眼，使白棋块活棋。", en: "White to play. Make two eyes so the white group lives." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gbhbgcfdfeffggghhhih", white: "cchcicgdhdgegfhgig" },
            correct: ["ie"],
            wrong: ["heif"],
        },
    },
    {
        id: "basic-skills-large-eye-17",
        chapterId: "basic-skills",
        order: 203,
        title: { zh: "大眼 · 17/29", en: "Large Eye · 17/29" },
        instruction: { zh: "白先。做成两个眼，使白棋块活棋。", en: "White to play. Make two eyes so the white group lives." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "fdcedeeecfffgfbgcghgbhhh", white: "dfefdgfgggchghcidifigi" },
            correct: ["eh"],
        },
    },
    {
        id: "basic-skills-large-eye-18",
        chapterId: "basic-skills",
        order: 204,
        title: { zh: "大眼 · 18/29", en: "Large Eye · 18/29" },
        instruction: { zh: "白先。阻止黑棋做成两个眼，从而吃掉黑棋块。", en: "White to play. Prevent two eyes, capturing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "fdgdeegeefgfegggehfhgheifigi", white: "ecfcgcedhddehedfhfdghgdhhh" },
            correct: ["ff"],
        },
    },
    {
        id: "basic-skills-large-eye-19",
        chapterId: "basic-skills",
        order: 205,
        title: { zh: "大眼 · 19/29", en: "Large Eye · 19/29" },
        instruction: { zh: "白先。阻止黑棋做成两个眼，从而吃掉黑棋块。", en: "White to play. Prevent two eyes, capturing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "cchdcegeiegfcggghgig", white: "gbhcfdgdfefffgghhh" },
            correct: ["hf"],
        },
    },
    {
        id: "basic-skills-large-eye-20",
        chapterId: "basic-skills",
        order: 206,
        title: { zh: "大眼 · 20/29", en: "Large Eye · 20/29" },
        instruction: { zh: "白先。阻止黑棋做成两个眼，从而吃掉黑棋块。", en: "White to play. Prevent two eyes, capturing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "eccdifhgiggheifihi", white: "hdgehffgggdhfhdi" },
            correct: ["ih"],
        },
    },
    {
        id: "basic-skills-large-eye-21",
        chapterId: "basic-skills",
        order: 207,
        title: { zh: "大眼 · 21/29", en: "Large Eye · 21/29" },
        instruction: { zh: "白先。阻止黑棋做成两个眼，从而吃掉黑棋块。", en: "White to play. Prevent two eyes, capturing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "cchcichdhehfcghgighh", white: "gbhbgcgdgegfggghhi" },
            correct: ["ie"],
        },
    },
    {
        id: "basic-skills-large-eye-22",
        chapterId: "basic-skills",
        order: 208,
        title: { zh: "大眼 · 22/29", en: "Large Eye · 22/29" },
        instruction: { zh: "白先。阻止黑棋做成两个眼，从而吃掉黑棋块。", en: "White to play. Prevent two eyes, capturing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "cchcicddgdhdgedfhfcghgig", white: "gbhbibgcfdfegfggfhhhih" },
            correct: ["ie"],
        },
    },
    {
        id: "basic-skills-large-eye-23",
        chapterId: "basic-skills",
        order: 209,
        title: { zh: "大眼 · 23/29", en: "Large Eye · 23/29" },
        instruction: { zh: "白先。阻止黑棋做成两个眼，从而吃掉黑棋块。", en: "White to play. Prevent two eyes, capturing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ebbcbdedfdgdhdiddeheiedfefgffg", white: "dcecfcgchccdcecfhfdghgehfhgh" },
            correct: ["fe"],
        },
    },
    {
        id: "basic-skills-large-eye-24",
        chapterId: "basic-skills",
        order: 210,
        title: { zh: "大眼 · 24/29", en: "Large Eye · 24/29" },
        instruction: { zh: "白先。阻止黑棋做成两个眼，从而吃掉黑棋块。", en: "White to play. Prevent two eyes, capturing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "hfifcgggigghgi", white: "gcgehegffgfh" },
            correct: ["hh"],
        },
    },
    {
        id: "basic-skills-large-eye-25",
        chapterId: "basic-skills",
        order: 211,
        title: { zh: "大眼 · 25/29", en: "Large Eye · 25/29" },
        instruction: { zh: "白先。阻止黑棋做成两个眼，从而吃掉黑棋块。", en: "White to play. Prevent two eyes, capturing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "hcicfdgdidcefegfifgghg", white: "hbfcgcedeefffgfhghhh" },
            correct: ["he"],
        },
    },
    {
        id: "basic-skills-large-eye-26",
        chapterId: "basic-skills",
        order: 212,
        title: { zh: "大眼 · 26/29", en: "Large Eye · 26/29" },
        instruction: { zh: "白先。阻止黑棋做成两个眼，从而吃掉黑棋块。", en: "White to play. Prevent two eyes, capturing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "hcichdgegfhfhgigih", white: "hbgcgdfeffggfhhh" },
            correct: ["ie"],
        },
    },
    {
        id: "basic-skills-large-eye-27",
        chapterId: "basic-skills",
        order: 213,
        title: { zh: "大眼 · 27/29", en: "Large Eye · 27/29" },
        instruction: { zh: "白先。阻止黑棋做成两个眼，从而吃掉黑棋块。", en: "White to play. Prevent two eyes, capturing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ccecgghgfhghihfi", white: "fegfhfifegfgeh" },
            correct: ["hi"],
        },
    },
    {
        id: "basic-skills-large-eye-28",
        chapterId: "basic-skills",
        order: 214,
        title: { zh: "大眼 · 28/29", en: "Large Eye · 28/29" },
        instruction: { zh: "白先。阻止黑棋做成两个眼，从而吃掉黑棋块。", en: "White to play. Prevent two eyes, capturing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "hdidgeiegfgghgigih", white: "gchcgdfefffgghhh" },
            correct: ["hf"],
        },
    },
    {
        id: "basic-skills-large-eye-29",
        chapterId: "basic-skills",
        order: 215,
        title: { zh: "大眼 · 29/29", en: "Large Eye · 29/29" },
        instruction: { zh: "白先。阻止黑棋做成两个眼，从而吃掉黑棋块。", en: "White to play. Prevent two eyes, capturing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "fggghgdhehhhaibicidihi", white: "ffgfhfcgdgegigbhchih" },
            correct: ["fi"],
        },
    },
];

const bsGroupAliveLevels: Level[] = [
    {
        id: "basic-skills-bs-group-alive-1",
        chapterId: "basic-skills",
        order: 216,
        title: { zh: "棋块活棋 · 1/12", en: "Group Alive · 1/12" },
        instruction: { zh: "黑棋的这个棋块活了吗？", en: "Is the black group alive?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "fcgdhdceeebfcfefbgahchci", white: "ccbdbedeafdfcgdgggdhfhbi" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋的这个棋块活了吗？", en: "Is the black group alive?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "no",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "fcgdhdceeebfcfefbgahchci", white: "ccbdbedeafdfcgdgggdhfhbi" },
            },
        },
    },
    {
        id: "basic-skills-bs-group-alive-2",
        chapterId: "basic-skills",
        order: 217,
        title: { zh: "棋块活棋 · 2/12", en: "Group Alive · 2/12" },
        instruction: { zh: "黑棋的这个棋块活了吗？", en: "Is the black group alive?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "gbfdgdhddeeeafcfagbgcgchdhdi", white: "bcdcddaebecebfdfhfdgegggehbi" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋的这个棋块活了吗？", en: "Is the black group alive?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "no",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "gbfdgdhddeeeafcfagbgcgchdhdi", white: "bcdcddaebecebfdfhfdgegggehbi" },
            },
        },
    },
    {
        id: "basic-skills-bs-group-alive-3",
        chapterId: "basic-skills",
        order: 218,
        title: { zh: "棋块活棋 · 3/12", en: "Group Alive · 3/12" },
        instruction: { zh: "黑棋的这个棋块活了吗？", en: "Is the black group alive?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "ecgdbgcgdgahdhbidi", white: "eeafbfcfdfagegehei" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋的这个棋块活了吗？", en: "Is the black group alive?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "yes",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "ecgdbgcgdgahdhbidi", white: "eeafbfcfdfagegehei" },
            },
        },
    },
    {
        id: "basic-skills-bs-group-alive-4",
        chapterId: "basic-skills",
        order: 219,
        title: { zh: "棋块活棋 · 4/12", en: "Group Alive · 4/12" },
        instruction: { zh: "黑棋的这个棋块活了吗？", en: "Is the black group alive?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "ebfcgdhddgegfgchdhfhghcigi", white: "dccdcedfefffbgcggghgbhhhei" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋的这个棋块活了吗？", en: "Is the black group alive?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "no",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "ebfcgdhddgegfgchdhfhghcigi", white: "dccdcedfefffbgcggghgbhhhei" },
            },
        },
    },
    {
        id: "basic-skills-bs-group-alive-5",
        chapterId: "basic-skills",
        order: 220,
        title: { zh: "棋块活棋 · 5/12", en: "Group Alive · 5/12" },
        instruction: { zh: "黑棋的这个棋块活了吗？", en: "Is the black group alive?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "ecgcagbgcgdgbhdhci", white: "eeafbfcfdfegggehei" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋的这个棋块活了吗？", en: "Is the black group alive?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "yes",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "ecgcagbgcgdgbhdhci", white: "eeafbfcfdfegggehei" },
            },
        },
    },
    {
        id: "basic-skills-bs-group-alive-6",
        chapterId: "basic-skills",
        order: 221,
        title: { zh: "棋块活棋 · 6/12", en: "Group Alive · 6/12" },
        instruction: { zh: "黑棋的这个棋块活了吗？", en: "Is the black group alive?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "gcbfcfagcgdgbhdhdi", white: "aebeceeeafdfegggeh" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋的这个棋块活了吗？", en: "Is the black group alive?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "yes",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "gcbfcfagcgdgbhdhdi", white: "aebeceeeafdfegggeh" },
            },
        },
    },
    {
        id: "basic-skills-bs-group-alive-7",
        chapterId: "basic-skills",
        order: 222,
        title: { zh: "棋块活棋 · 7/12", en: "Group Alive · 7/12" },
        instruction: { zh: "黑棋的这个棋块活了吗？", en: "Is the black group alive?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "ecgdafbfgfcgbhchbi", white: "ddbecedfagdgahdhai" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋的这个棋块活了吗？", en: "Is the black group alive?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "no",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "ecgdafbfgfcgbhchbi", white: "ddbecedfagdgahdhai" },
            },
        },
    },
    {
        id: "basic-skills-bs-group-alive-8",
        chapterId: "basic-skills",
        order: 223,
        title: { zh: "棋块活棋 · 8/12", en: "Group Alive · 8/12" },
        instruction: { zh: "黑棋的这个棋块活了吗？", en: "Is the black group alive?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "agbgcgchdhdi", white: "bfcfefdgehbi" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋的这个棋块活了吗？", en: "Is the black group alive?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "no",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "agbgcgchdhdi", white: "bfcfefdgehbi" },
            },
        },
    },
    {
        id: "basic-skills-bs-group-alive-9",
        chapterId: "basic-skills",
        order: 224,
        title: { zh: "棋块活棋 · 9/12", en: "Group Alive · 9/12" },
        instruction: { zh: "黑棋的这个棋块活了吗？", en: "Is the black group alive?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "beceafcfagcgdgdhaibicidi", white: "bdcddddebfdfffbgegbhcheh" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋的这个棋块活了吗？", en: "Is the black group alive?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "yes",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "beceafcfagcgdgdhaibicidi", white: "bdcddddebfdfffbgegbhcheh" },
            },
        },
    },
    {
        id: "basic-skills-bs-group-alive-10",
        chapterId: "basic-skills",
        order: 225,
        title: { zh: "棋块活棋 · 10/12", en: "Group Alive · 10/12" },
        instruction: { zh: "黑棋的这个棋块活了吗？", en: "Is the black group alive?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "egfgggchdhghbicieigi", white: "bfefffgfcgdghgbhfhhh" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋的这个棋块活了吗？", en: "Is the black group alive?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "yes",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "egfgggchdhghbicieigi", white: "bfefffgfcgdghgbhfhhh" },
            },
        },
    },
    {
        id: "basic-skills-bs-group-alive-11",
        chapterId: "basic-skills",
        order: 226,
        title: { zh: "棋块活棋 · 11/12", en: "Group Alive · 11/12" },
        instruction: { zh: "黑棋的这个棋块活了吗？", en: "Is the black group alive?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "dcfcgdagbgcgdgahdhdi", white: "eebfcfdfegbhchehbici" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋的这个棋块活了吗？", en: "Is the black group alive?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "no",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "dcfcgdagbgcgdgahdhdi", white: "eebfcfdfegbhchehbici" },
            },
        },
    },
    {
        id: "basic-skills-bs-group-alive-12",
        chapterId: "basic-skills",
        order: 227,
        title: { zh: "棋块活棋 · 12/12", en: "Group Alive · 12/12" },
        instruction: { zh: "黑棋的这个棋块活了吗？", en: "Is the black group alive?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "agbgcgdgahdhcidi", white: "bfcfdfffegbhehbi" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋的这个棋块活了吗？", en: "Is the black group alive?" },
            options: [{ value: "yes", label: { zh: "能", en: "Yes" } }, { value: "no", label: { zh: "不能", en: "No" } }],
            correctValue: "no",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "agbgcgdgahdhcidi", white: "bfcfdfffegbhehbi" },
            },
        },
    },
];

const snapbackLevels: Level[] = [
    {
        id: "basic-skills-snapback-1",
        chapterId: "basic-skills",
        order: 228,
        title: { zh: "倒扑 · 1/25", en: "Snapback · 1/25" },
        instruction: { zh: "黑棋可以吃掉被标记的两个白棋。黑棋不应在A点打吃，因为白棋可以通过落子于B点来防守。黑棋应先通过落子于B点使自己处于打吃状态。白棋可以通过落子于A点吃掉这颗黑棋。但随后三个白棋将处于打吃状态。这种吃掉白棋的方式称为'倒扑'。吃掉被标记的白棋。", en: "Black can capture the two marked white stones. Black should not give atari at A, because white would defend by playing at B. Black should first put himself in atari by playing at B. White can take this stone, by playing at A. But then the three white stones are in atari. Capturing the white stones this way is called a 'snapback'. Capture the marked white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "dfdgeeehfegegf", white: "efffhfggfhhh" },
            marks: { triangle: "efff", A: "eg", B: "fg" },
            correct: ["fgegfg"],
            wrong: ["egfg"],
        },
    },
    {
        id: "basic-skills-snapback-2",
        chapterId: "basic-skills",
        order: 229,
        title: { zh: "倒扑 · 2/25", en: "Snapback · 2/25" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "fegeefhfhgghhh", white: "cfgfcgegggdhfh" },
            marks: { triangle: "gggf" },
            correct: ["fg"],
            wrong: ["fffg"],
        },
    },
    {
        id: "basic-skills-snapback-3",
        chapterId: "basic-skills",
        order: 230,
        title: { zh: "倒扑 · 3/25", en: "Snapback · 3/25" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "geffegehhhfigihi", white: "gchdhegfhgfhghih" },
            marks: { triangle: "ghfh" },
            correct: ["gg"],
            wrong: ["fggg"],
        },
    },
    {
        id: "basic-skills-snapback-4",
        chapterId: "basic-skills",
        order: 231,
        title: { zh: "倒扑 · 4/25", en: "Snapback · 4/25" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "gcgeffgghgiggh", white: "dgfgfhhhihfigi" },
            marks: { triangle: "ihhh" },
            correct: ["hi"],
            wrong: ["iihi"],
        },
    },
    {
        id: "basic-skills-snapback-5",
        chapterId: "basic-skills",
        order: 232,
        title: { zh: "倒扑 · 5/25", en: "Snapback · 5/25" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "fegeegfgggehhhhi", white: "cedfdgdhfhghdiei" },
            marks: { triangle: "ghfh" },
            correct: ["fi"],
            wrong: ["gifi"],
        },
    },
    {
        id: "basic-skills-snapback-6",
        chapterId: "basic-skills",
        order: 233,
        title: { zh: "倒扑 · 6/25", en: "Snapback · 6/25" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "fdgfgghheihi", white: "cgfgchehghgi" },
            marks: { triangle: "gigh" },
            correct: ["fh"],
            wrong: ["fifh"],
        },
    },
    {
        id: "basic-skills-snapback-7",
        chapterId: "basic-skills",
        order: 234,
        title: { zh: "倒扑 · 7/25", en: "Snapback · 7/25" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "eeegfgeheihi", white: "gegfggfhhhfi" },
            marks: { triangle: "fifh" },
            correct: ["gh"],
            wrong: ["gigh"],
        },
    },
    {
        id: "basic-skills-snapback-8",
        chapterId: "basic-skills",
        order: 235,
        title: { zh: "倒扑 · 8/25", en: "Snapback · 8/25" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "fegeefhfegfh", white: "eeffgfhgghih" },
            marks: { triangle: "gfff" },
            correct: ["gg"],
            wrong: ["fggg"],
        },
    },
    {
        id: "basic-skills-snapback-9",
        chapterId: "basic-skills",
        order: 236,
        title: { zh: "倒扑 · 9/25", en: "Snapback · 9/25" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "fegeheffifighh", white: "eeefgfhfdgfggh" },
            marks: { triangle: "hfgf" },
            correct: ["gg"],
            wrong: ["hggg"],
        },
    },
    {
        id: "basic-skills-snapback-10",
        chapterId: "basic-skills",
        order: 237,
        title: { zh: "倒扑 · 10/25", en: "Snapback · 10/25" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "decfefbgcgegchci", white: "bdcdceafbfagbhbi" },
            marks: { triangle: "bibh" },
            correct: ["ah"],
            wrong: ["aiah"],
        },
    },
    {
        id: "basic-skills-snapback-11",
        chapterId: "basic-skills",
        order: 238,
        title: { zh: "倒扑 · 11/25", en: "Snapback · 11/25" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "gcdefegecgdgegbhehbi", white: "cccebfbgahchdhfheifi" },
            marks: { triangle: "dhch" },
            correct: ["di"],
            wrong: ["cidi"],
        },
    },
    {
        id: "basic-skills-snapback-12",
        chapterId: "basic-skills",
        order: 239,
        title: { zh: "倒扑 · 12/25", en: "Snapback · 12/25" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cededfagdgbhch", white: "bccdedbeafcfcg" },
            marks: { triangle: "cgcf" },
            correct: ["bf"],
            wrong: ["bgbf"],
        },
    },
    {
        id: "basic-skills-snapback-13",
        chapterId: "basic-skills",
        order: 240,
        title: { zh: "倒扑 · 13/25", en: "Snapback · 13/25" },
        instruction: { zh: "黑先。吃掉被标记的棋子。", en: "Black to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "gcbdcdcecfgfagcgggbhbi", white: "acbcccdcadbebfbgegchdh" },
            marks: { triangle: "bgbfbe" },
            correct: ["ae"],
            wrong: ["afae"],
        },
    },
    {
        id: "basic-skills-snapback-14",
        chapterId: "basic-skills",
        order: 241,
        title: { zh: "倒扑 · 14/25", en: "Snapback · 14/25" },
        instruction: { zh: "白先。吃掉带标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "dfefffbgcgggdhgh", white: "deeefecfgffgeh" },
            marks: { triangle: "ffefdf" },
            correct: ["dg"],
            wrong: ["egdg"],
        },
    },
    {
        id: "basic-skills-snapback-15",
        chapterId: "basic-skills",
        order: 242,
        title: { zh: "倒扑 · 15/25", en: "Snapback · 15/25" },
        instruction: { zh: "白先。吃掉带标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "cfcgchehfhghcidi", white: "dgegfgggdhhhgi" },
            marks: { triangle: "ghfheh" },
            correct: ["ei"],
            wrong: ["fiei"],
        },
    },
    {
        id: "basic-skills-snapback-16",
        chapterId: "basic-skills",
        order: 243,
        title: { zh: "倒扑 · 16/25", en: "Snapback · 16/25" },
        instruction: { zh: "白先。吃掉带标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ffgfhfcgegigehhhhi", white: "fegeheieefiffggh" },
            marks: { triangle: "hfgfff" },
            correct: ["hg"],
            wrong: ["gghg"],
        },
    },
    {
        id: "basic-skills-snapback-17",
        chapterId: "basic-skills",
        order: 244,
        title: { zh: "倒扑 · 17/25", en: "Snapback · 17/25" },
        instruction: { zh: "白先。吃掉带标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "efffdgggdhghdieigi", white: "gcgegffghgehhhhi" },
            marks: { triangle: "gighgg" },
            correct: ["fi"],
            wrong: ["fhfi"],
        },
    },
    {
        id: "basic-skills-snapback-18",
        chapterId: "basic-skills",
        order: 245,
        title: { zh: "倒扑 · 18/25", en: "Snapback · 18/25" },
        instruction: { zh: "白先。吃掉带标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "cfcgchehfhghcidigi", white: "gddgegfgggdhhhhi" },
            marks: { triangle: "gighfheh" },
            correct: ["ei"],
            wrong: ["fiei"],
        },
    },
    {
        id: "basic-skills-snapback-19",
        chapterId: "basic-skills",
        order: 246,
        title: { zh: "倒扑 · 19/25", en: "Snapback · 19/25" },
        instruction: { zh: "白先。吃掉带标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "cfcgchehfhcidigi", white: "dgegfgdhghhhhi" },
            marks: { triangle: "gifheh" },
            correct: ["ei"],
            wrong: ["fiei"],
        },
    },
    {
        id: "basic-skills-snapback-20",
        chapterId: "basic-skills",
        order: 247,
        title: { zh: "倒扑 · 20/25", en: "Snapback · 20/25" },
        instruction: { zh: "白先。吃掉带标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "dcfcgcedfedfef", white: "ddceeecfdgeg" },
            marks: { triangle: "efdf" },
            correct: ["ff"],
            wrong: ["deff"],
        },
    },
    {
        id: "basic-skills-snapback-21",
        chapterId: "basic-skills",
        order: 248,
        title: { zh: "倒扑 · 21/25", en: "Snapback · 21/25" },
        instruction: { zh: "白先。吃掉带标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gcgffgbhchdhfheifi", white: "cdbgcgdgegahehbi" },
            marks: { triangle: "dhchbh" },
            correct: ["di"],
            wrong: ["cidi"],
        },
    },
    {
        id: "basic-skills-snapback-22",
        chapterId: "basic-skills",
        order: 249,
        title: { zh: "倒扑 · 22/25", en: "Snapback · 22/25" },
        instruction: { zh: "白先。吃掉带标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ccdcgcedgdeedfdgegfg", white: "defecfgfcgggdhehfh" },
            marks: { triangle: "fgegdgdf" },
            correct: ["ef"],
            wrong: ["ffef"],
        },
    },
    {
        id: "basic-skills-snapback-23",
        chapterId: "basic-skills",
        order: 250,
        title: { zh: "倒扑 · 23/25", en: "Snapback · 23/25" },
        instruction: { zh: "白先。吃掉带标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "cecfcgegfgchdhfhfi", white: "dfefffdgggghdigi" },
            marks: { triangle: "fifhfgeg" },
            correct: ["eh"],
            wrong: ["eieh"],
        },
    },
    {
        id: "basic-skills-snapback-24",
        chapterId: "basic-skills",
        order: 251,
        title: { zh: "倒扑 · 24/25", en: "Snapback · 24/25" },
        instruction: { zh: "白先。吃掉带标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ccaebeceafbgbhaibi", white: "eebfcfefgfcgchci" },
            marks: { triangle: "biaibhbg" },
            correct: ["ag"],
            wrong: ["ahag"],
        },
    },
    {
        id: "basic-skills-snapback-25",
        chapterId: "basic-skills",
        order: 252,
        title: { zh: "倒扑 · 25/25", en: "Snapback · 25/25" },
        instruction: { zh: "白先。吃掉带标记的棋子。", en: "White to play. Capture the marked stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ecfccdfdcegebfdfefffbg", white: "eddecfgfhfcgdgegfgbh" },
            marks: { triangle: "ffefdf" },
            correct: ["fe"],
            wrong: ["eefe"],
        },
    },
];

const netLevels: Level[] = [
    {
        id: "basic-skills-net-1",
        chapterId: "basic-skills",
        order: 253,
        title: { zh: "罩 · 1/13", en: "Net · 1/13" },
        instruction: { zh: "如果黑棋试图通过连续打吃来吃掉被标记的白棋，白棋可以逃脱。但黑棋可以通过落子于A点，用'罩'的方式吃掉这颗棋子。用罩的方式吃掉被标记的棋子。", en: "If Black tries to capture the marked white stone by playing a series of ataris, White can escape. But Black can capture the stone in a 'net' by playing at A. Capture the marked stone in a net." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "egehfggegfhe", white: "edfhgghhhfff" },
            marks: { triangle: "ff", A: "ee" },
            correct: ["eefefdefdf"],
            wrong: ["effe", "feef"],
        },
    },
    {
        id: "basic-skills-net-2",
        chapterId: "basic-skills",
        order: 254,
        title: { zh: "罩 · 2/13", en: "Net · 2/13" },
        instruction: { zh: "白先。用罩的方式吃掉被标记的棋子。", en: "White to play. Capture the marked stones in a net." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gbgchdheefff", white: "deeedfegfggg" },
            marks: { triangle: "ffef" },
            correct: ["ge"],
            wrong: ["gffefdge", "gffegefd", "fegfhfge", "fegfgehf"],
        },
    },
    {
        id: "basic-skills-net-3",
        chapterId: "basic-skills",
        order: 255,
        title: { zh: "罩 · 3/13", en: "Net · 3/13" },
        instruction: { zh: "白先。用罩的方式吃掉被标记的棋子。", en: "White to play. Capture the marked stones in a net." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ccdfefbgcgdh", white: "cecfdgegfg" },
            marks: { triangle: "efdf" },
            correct: ["fe"],
            wrong: ["eeffgffefddeeddd", "eeffgffefddegedd", "eeffgffegefd", "eefffegf", "ffeeedfegefdfcdd", "defeffee"],
        },
    },
    {
        id: "basic-skills-net-4",
        chapterId: "basic-skills",
        order: 256,
        title: { zh: "罩 · 4/13", en: "Net · 4/13" },
        instruction: { zh: "白先。用罩的方式吃掉被标记的棋子。", en: "White to play. Capture the marked stones in a net." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gfghcidi", white: "bhchbi" },
            marks: { triangle: "dici" },
            correct: ["eheifi"],
            wrong: ["eheidhfi", "dheiehfifhgi", "eidhdgehfhegeffg"],
        },
    },
    {
        id: "basic-skills-net-5",
        chapterId: "basic-skills",
        order: 257,
        title: { zh: "罩 · 5/13", en: "Net · 5/13" },
        instruction: { zh: "白先。用罩的方式吃掉被标记的棋子。", en: "White to play. Capture the marked stones in a net." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gccedecfdfegfggg", white: "bdbebfefffcgdg" },
            marks: { triangle: "dfcfdece" },
            correct: ["eddddc"],
            wrong: ["ddeefeedecfd", "ddeefeedfdec", "ddeeedfe", "eedddcedfdecebfc", "cdedddeeecfd"],
        },
    },
    {
        id: "basic-skills-net-6",
        chapterId: "basic-skills",
        order: 258,
        title: { zh: "罩 · 6/13", en: "Net · 6/13" },
        instruction: { zh: "白先。用罩的方式吃掉被标记的棋子。", en: "White to play. Capture the marked stone in a net." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gcbddfegfggg", white: "feefffcgdg" },
            marks: { triangle: "df" },
            correct: ["cededd"],
            wrong: ["cfdeddcebecd", "decfbfcecdbe"],
        },
    },
    {
        id: "basic-skills-net-7",
        chapterId: "basic-skills",
        order: 259,
        title: { zh: "罩 · 7/13", en: "Net · 7/13" },
        instruction: { zh: "白先。用罩的方式吃掉被标记的棋子。", en: "White to play. Capture the marked stone in a net." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gdefbgdgchdhehgh", white: "bccecfdfcgegfg" },
            marks: { triangle: "ef" },
            correct: ["feeeed"],
            wrong: ["eeffgffe", "ffeeedfe", "ffeefdfegegfhegg"],
        },
    },
    {
        id: "basic-skills-net-8",
        chapterId: "basic-skills",
        order: 260,
        title: { zh: "罩 · 8/13", en: "Net · 8/13" },
        instruction: { zh: "白先。用罩的方式吃掉被标记的棋子。", en: "White to play. Capture the marked stones in a net." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "dedfbgcgbhdhfh", white: "cdbfcfefdgeg" },
            marks: { triangle: "dfde" },
            correct: ["ed"],
            wrong: ["ddeefeedecfdgdfcfbffgefg", "eedddcedfdecebccdbcebdbe", "ceedddeeecfffdfe"],
        },
    },
    {
        id: "basic-skills-net-9",
        chapterId: "basic-skills",
        order: 261,
        title: { zh: "罩 · 9/13", en: "Net · 9/13" },
        instruction: { zh: "白先。用罩的方式吃掉被标记的棋子。", en: "White to play. Capture the marked stones in a net." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gcfddfgfcgdggg", white: "cebfbgegfgchdh" },
            marks: { triangle: "dgcgdf" },
            correct: ["eededd"],
            wrong: ["deefffee", "deefeeff", "efdeddee", "cfee"],
        },
    },
    {
        id: "basic-skills-net-10",
        chapterId: "basic-skills",
        order: 262,
        title: { zh: "罩 · 10/13", en: "Net · 10/13" },
        instruction: { zh: "白先。用罩的方式吃掉被标记的棋子。", en: "White to play. Capture the marked stones in a net." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "dbccgcgddfdggg", white: "cecgegbhdheh" },
            marks: { triangle: "dgdf" },
            correct: ["ee"],
            wrong: ["deefffeeedfe", "efdeddeefeedecfd", "cfeedeefedfe"],
        },
    },
    {
        id: "basic-skills-net-11",
        chapterId: "basic-skills",
        order: 263,
        title: { zh: "罩 · 11/13", en: "Net · 11/13" },
        instruction: { zh: "白先。用罩的方式吃掉被标记的棋子。", en: "White to play. Capture the marked stone in a net." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "fddfbgcgbhdh", white: "cdbfcfdgeg" },
            marks: { triangle: "df" },
            correct: ["eededd"],
            wrong: ["deefffee", "efdeddee", "efdeeedddced"],
        },
    },
    {
        id: "basic-skills-net-12",
        chapterId: "basic-skills",
        order: 264,
        title: { zh: "罩 · 12/13", en: "Net · 12/13" },
        instruction: { zh: "白先。用罩的方式吃掉被标记的棋子。", en: "White to play. Capture the marked stones in a net." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gcfdgedfdgeggggh", white: "cecgfgbhdhehfh" },
            marks: { triangle: "egdgdf" },
            correct: ["eededd"],
            wrong: ["deee", "efdeddee", "cfee"],
        },
    },
    {
        id: "basic-skills-net-13",
        chapterId: "basic-skills",
        order: 265,
        title: { zh: "罩 · 13/13", en: "Net · 13/13" },
        instruction: { zh: "白先。用罩的方式吃掉被标记的棋子。", en: "White to play. Capture the marked stones in a net." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "dbecgcgddfef", white: "decfdgeggg" },
            marks: { triangle: "efdf" },
            correct: ["feffgf"],
            wrong: ["geeeedfd", "eeffgffe", "ffeeedfe"],
        },
    },
];

const countTerritoryLevels: Level[] = [
    {
        id: "basic-skills-count-territory-1",
        chapterId: "basic-skills",
        order: 266,
        title: { zh: "领地 · 1/12", en: "Territory · 1/12" },
        instruction: { zh: "白棋的地盘有多少目？注意：一个死子算两目。", en: "How many points is the white territory? Note: a dead stone counts for two." },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "aebedecfdgdhcidi", white: "afbfbgcgahchbi" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋的地盘有多少目？注意：一个死子算两目。", en: "How many points is the white territory? Note: a dead stone counts for two." },
            options: [{ value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }, { value: "4", label: { zh: "4", en: "4" } }],
            correctValue: "3",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "aebedecfdgdhcidi", white: "afbfbgcgahchbi" },
            },
        },
    },
    {
        id: "basic-skills-count-territory-2",
        chapterId: "basic-skills",
        order: 267,
        title: { zh: "领地 · 2/12", en: "Territory · 2/12" },
        instruction: { zh: "白棋的地盘有多少目？注意：一个死子算两目。", en: "How many points is the white territory? Note: a dead stone counts for two." },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "aebecedeeeafefegeh", white: "bfcfdfagdgbhdhcidi" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋的地盘有多少目？注意：一个死子算两目。", en: "How many points is the white territory? Note: a dead stone counts for two." },
            options: [{ value: "3", label: { zh: "3", en: "3" } }, { value: "6", label: { zh: "6", en: "6" } }, { value: "7", label: { zh: "7", en: "7" } }],
            correctValue: "6",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "aebecedeeeafefegeh", white: "bfcfdfagdgbhdhcidi" },
            },
        },
    },
    {
        id: "basic-skills-count-territory-3",
        chapterId: "basic-skills",
        order: 268,
        title: { zh: "领地 · 3/12", en: "Territory · 3/12" },
        instruction: { zh: "白棋的地盘有多少目？注意：一个死子算两目。", en: "How many points is the white territory? Note: a dead stone counts for two." },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "efffgfcgdghgbhhhbi", white: "egfgggchdhghcieigi" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋的地盘有多少目？注意：一个死子算两目。", en: "How many points is the white territory? Note: a dead stone counts for two." },
            options: [{ value: "3", label: { zh: "3", en: "3" } }, { value: "4", label: { zh: "4", en: "4" } }, { value: "5", label: { zh: "5", en: "5" } }],
            correctValue: "4",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "efffgfcgdghgbhhhbi", white: "egfgggchdhghcieigi" },
            },
        },
    },
    {
        id: "basic-skills-count-territory-4",
        chapterId: "basic-skills",
        order: 269,
        title: { zh: "领地 · 4/12", en: "Territory · 4/12" },
        instruction: { zh: "白棋的地盘有多少目？注意：一个死子算两目。", en: "How many points is the white territory? Note: a dead stone counts for two." },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "adbdcddebfdfbgdgdhdi", white: "aebececfcgbhchci" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋的地盘有多少目？注意：一个死子算两目。", en: "How many points is the white territory? Note: a dead stone counts for two." },
            options: [{ value: "5", label: { zh: "5", en: "5" } }, { value: "7", label: { zh: "7", en: "7" } }, { value: "9", label: { zh: "9", en: "9" } }],
            correctValue: "9",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "adbdcddebfdfbgdgdhdi", white: "aebececfcgbhchci" },
            },
        },
    },
    {
        id: "basic-skills-count-territory-5",
        chapterId: "basic-skills",
        order: 270,
        title: { zh: "领地 · 5/12", en: "Territory · 5/12" },
        instruction: { zh: "白棋的地盘有多少目？注意：一个死子算两目。", en: "How many points is the white territory? Note: a dead stone counts for two." },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "aebecedeeefegfgggh", white: "afbfcfdfeffffgfhfi" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋的地盘有多少目？注意：一个死子算两目。", en: "How many points is the white territory? Note: a dead stone counts for two." },
            options: [{ value: "12", label: { zh: "12", en: "12" } }, { value: "15", label: { zh: "15", en: "15" } }, { value: "18", label: { zh: "18", en: "18" } }],
            correctValue: "15",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "aebecedeeefegfgggh", white: "afbfcfdfeffffgfhfi" },
            },
        },
    },
    {
        id: "basic-skills-count-territory-6",
        chapterId: "basic-skills",
        order: 271,
        title: { zh: "领地 · 6/12", en: "Territory · 6/12" },
        instruction: { zh: "白棋的地盘有多少目？注意：一个死子算两目。", en: "How many points is the white territory? Note: a dead stone counts for two." },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "acbcccddbedebfdfdgchdh", white: "adbdcdcecfagbgcgbhbi" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋的地盘有多少目？注意：一个死子算两目。", en: "How many points is the white territory? Note: a dead stone counts for two." },
            options: [{ value: "4", label: { zh: "4", en: "4" } }, { value: "6", label: { zh: "6", en: "6" } }, { value: "8", label: { zh: "8", en: "8" } }],
            correctValue: "8",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "acbcccddbedebfdfdgchdh", white: "adbdcdcecfagbgcgbhbi" },
            },
        },
    },
    {
        id: "basic-skills-count-territory-7",
        chapterId: "basic-skills",
        order: 272,
        title: { zh: "领地 · 7/12", en: "Territory · 7/12" },
        instruction: { zh: "白棋的地盘有多少目？注意：一个死子算两目。", en: "How many points is the white territory? Note: a dead stone counts for two." },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "aebecedeeefegeafgfbgcgdgggghgi", white: "bfcfdfefffagfgahbhchdhfhfi" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋的地盘有多少目？注意：一个死子算两目。", en: "How many points is the white territory? Note: a dead stone counts for two." },
            options: [{ value: "7", label: { zh: "7", en: "7" } }, { value: "10", label: { zh: "10", en: "10" } }, { value: "13", label: { zh: "13", en: "13" } }],
            correctValue: "13",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "aebecedeeefegeafgfbgcgdgggghgi", white: "bfcfdfefffagfgahbhchdhfhfi" },
            },
        },
    },
    {
        id: "basic-skills-count-territory-8",
        chapterId: "basic-skills",
        order: 273,
        title: { zh: "领地 · 8/12", en: "Territory · 8/12" },
        instruction: { zh: "白棋的地盘有多少目？注意：一个死子算两目。", en: "How many points is the white territory? Note: a dead stone counts for two." },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "acbcccddbedebfdfbgdgdhdi", white: "adbdcdcecfagcgbhchci" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋的地盘有多少目？注意：一个死子算两目。", en: "How many points is the white territory? Note: a dead stone counts for two." },
            options: [{ value: "5", label: { zh: "5", en: "5" } }, { value: "8", label: { zh: "8", en: "8" } }, { value: "11", label: { zh: "11", en: "11" } }],
            correctValue: "11",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "acbcccddbedebfdfbgdgdhdi", white: "adbdcdcecfagcgbhchci" },
            },
        },
    },
    {
        id: "basic-skills-count-territory-9",
        chapterId: "basic-skills",
        order: 274,
        title: { zh: "领地 · 9/12", en: "Territory · 9/12" },
        instruction: { zh: "白棋的地盘有多少目？注意：一个死子算两目。", en: "How many points is the white territory? Note: a dead stone counts for two." },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "cdddedfdgdhdidcecfhfifcghgchhhihcihi", white: "deeefegeheiedfgfdgggdhghdigi" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋的地盘有多少目？注意：一个死子算两目。", en: "How many points is the white territory? Note: a dead stone counts for two." },
            options: [{ value: "8", label: { zh: "8", en: "8" } }, { value: "10", label: { zh: "10", en: "10" } }, { value: "22", label: { zh: "22", en: "22" } }],
            correctValue: "8",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "cdddedfdgdhdidcecfhfifcghgchhhihcihi", white: "deeefegeheiedfgfdgggdhghdigi" },
            },
        },
    },
    {
        id: "basic-skills-count-territory-10",
        chapterId: "basic-skills",
        order: 275,
        title: { zh: "领地 · 10/12", en: "Territory · 10/12" },
        instruction: { zh: "白棋的地盘有多少目？注意：一个死子算两目。", en: "How many points is the white territory? Note: a dead stone counts for two." },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "bdbfcfdfffdhehei", white: "agbgcgahchbidi" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋的地盘有多少目？注意：一个死子算两目。", en: "How many points is the white territory? Note: a dead stone counts for two." },
            options: [{ value: "1", label: { zh: "1", en: "1" } }, { value: "2", label: { zh: "2", en: "2" } }, { value: "3", label: { zh: "3", en: "3" } }],
            correctValue: "2",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "bdbfcfdfffdhehei", white: "agbgcgahchbidi" },
            },
        },
    },
    {
        id: "basic-skills-count-territory-11",
        chapterId: "basic-skills",
        order: 276,
        title: { zh: "领地 · 11/12", en: "Territory · 11/12" },
        instruction: { zh: "白棋的地盘有多少目？注意：一个死子算两目。", en: "How many points is the white territory? Note: a dead stone counts for two." },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "dbbcbdedcedeefegfggghgehghhi", white: "adbeafbfcfdfdgbhdhfhdieigi" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋的地盘有多少目？注意：一个死子算两目。", en: "How many points is the white territory? Note: a dead stone counts for two." },
            options: [{ value: "8", label: { zh: "8", en: "8" } }, { value: "9", label: { zh: "9", en: "9" } }, { value: "10", label: { zh: "10", en: "10" } }],
            correctValue: "8",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "dbbcbdedcedeefegfggghgehghhi", white: "adbeafbfcfdfdgbhdhfhdieigi" },
            },
        },
    },
    {
        id: "basic-skills-count-territory-12",
        chapterId: "basic-skills",
        order: 277,
        title: { zh: "领地 · 12/12", en: "Territory · 12/12" },
        instruction: { zh: "白棋的地盘有多少目？注意：一个死子算两目。", en: "How many points is the white territory? Note: a dead stone counts for two." },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "bbdcechcbdcdeegecfdfffggfhgh", white: "aebebfefagbgcgdgfgdhehbidi" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "白棋的地盘有多少目？注意：一个死子算两目。", en: "How many points is the white territory? Note: a dead stone counts for two." },
            options: [{ value: "5", label: { zh: "5", en: "5" } }, { value: "6", label: { zh: "6", en: "6" } }, { value: "7", label: { zh: "7", en: "7" } }],
            correctValue: "6",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "bbdcechcbdcdeegecfdfffggfhgh", white: "aebebfefagbgcgdgfgdhehbidi" },
            },
        },
    },
];

const determineWinnerLevels: Level[] = [
    {
        id: "basic-skills-determine-winner-1",
        chapterId: "basic-skills",
        order: 278,
        title: { zh: "胜者 · 1/12", en: "Winner · 1/12" },
        instruction: { zh: "棋局结束了。谁赢了？", en: "The game is over. Who has won?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "dadbdccdedceeeefdgegdhdi", white: "eaebecfcfdfefffgehgheifi" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "棋局结束了。谁赢了？", en: "The game is over. Who has won?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "same", label: { zh: "平局", en: "Same" } }],
            correctValue: "White",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "dadbdccdedceeeefdgegdhdi", white: "eaebecfcfdfefffgehgheifi" },
            },
        },
    },
    {
        id: "basic-skills-determine-winner-2",
        chapterId: "basic-skills",
        order: 279,
        title: { zh: "胜者 · 2/12", en: "Winner · 2/12" },
        instruction: { zh: "棋局结束了。谁赢了？", en: "The game is over. Who has won?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "caeacbebacbcccdcecffgfhfiffgfhhhfi", white: "fafbfcadbdcdddedfdfegeheieefegehei" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "棋局结束了。谁赢了？", en: "The game is over. Who has won?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "same", label: { zh: "平局", en: "Same" } }],
            correctValue: "White",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "caeacbebacbcccdcecffgfhfiffgfhhhfi", white: "fafbfcadbdcdddedfdfegeheieefegehei" },
            },
        },
    },
    {
        id: "basic-skills-determine-winner-3",
        chapterId: "basic-skills",
        order: 280,
        title: { zh: "胜者 · 3/12", en: "Winner · 3/12" },
        instruction: { zh: "棋局结束了。谁赢了？", en: "The game is over. Who has won?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "caeacbebfbgbccgcicadcdgdhdbeceheiebfbgbhbi", white: "dbdcecfcddfddefegecfdfgfhfifcgegfgggchci" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "棋局结束了。谁赢了？", en: "The game is over. Who has won?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "same", label: { zh: "平局", en: "Same" } }],
            correctValue: "Black",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "caeacbebfbgbccgcicadcdgdhdbeceheiebfbgbhbi", white: "dbdcecfcddfddefegecfdfgfhfifcgegfgggchci" },
            },
        },
    },
    {
        id: "basic-skills-determine-winner-4",
        chapterId: "basic-skills",
        order: 281,
        title: { zh: "胜者 · 4/12", en: "Winner · 4/12" },
        instruction: { zh: "棋局结束了。谁赢了？", en: "The game is over. Who has won?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "eabbebbcecedfdgdhdidaebebfbgcgdgahdhdi", white: "cacbccadbdcdddceeefegeheiecfdfefagegehei" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "棋局结束了。谁赢了？", en: "The game is over. Who has won?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "same", label: { zh: "平局", en: "Same" } }],
            correctValue: "White",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "eabbebbcecedfdgdhdidaebebfbgcgdgahdhdi", white: "cacbccadbdcdddceeefegeheiecfdfefagegehei" },
            },
        },
    },
    {
        id: "basic-skills-determine-winner-5",
        chapterId: "basic-skills",
        order: 282,
        title: { zh: "胜者 · 5/12", en: "Winner · 5/12" },
        instruction: { zh: "棋局结束了。谁赢了？", en: "The game is over. Who has won?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "bacagaabcbgbibacbcgchcedhdidefffgfhfifcgdgeghgdhfhhheifi", white: "eafahadbfbccdcfcadbdcdgddeeefegeheiebfcfdfbgggbhghbicigi" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "棋局结束了。谁赢了？", en: "The game is over. Who has won?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "same", label: { zh: "平局", en: "Same" } }],
            correctValue: "Black",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "bacagaabcbgbibacbcgchcedhdidefffgfhfifcgdgeghgdhfhhheifi", white: "eafahadbfbccdcfcadbdcdgddeeefegeheiebfcfdfbgggbhghbicigi" },
            },
        },
    },
    {
        id: "basic-skills-determine-winner-6",
        chapterId: "basic-skills",
        order: 283,
        title: { zh: "胜者 · 6/12", en: "Winner · 6/12" },
        instruction: { zh: "棋局结束了。谁赢了？", en: "The game is over. Who has won?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "cacbccdcecadbdcdedfdgdbedegeheiebfdfbgcgdgegehhhei", white: "baeagabbebfbhbacbcfcgchdideefeefffgfhfiffghgfhghgi" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "棋局结束了。谁赢了？", en: "The game is over. Who has won?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "same", label: { zh: "平局", en: "Same" } }],
            correctValue: "Black",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "cacbccdcecadbdcdedfdgdbedegeheiebfdfbgcgdgegehhhei", white: "baeagabbebfbhbacbcfcgchdideefeefffgfhfiffghgfhghgi" },
            },
        },
    },
    {
        id: "basic-skills-determine-winner-7",
        chapterId: "basic-skills",
        order: 284,
        title: { zh: "胜者 · 7/12", en: "Winner · 7/12" },
        instruction: { zh: "棋局结束了。谁赢了？", en: "The game is over. Who has won?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "gahagbhbdchcadbdddedhdidbeceeeheiecfefcgdgdhehfhghgi", white: "baeacbdbebfbibacbcccecgccdfdgdfegeffhfifegfgggighhhi" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "棋局结束了。谁赢了？", en: "The game is over. Who has won?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "same", label: { zh: "平局", en: "Same" } }],
            correctValue: "White",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "gahagbhbdchcadbdddedhdidbeceeeheiecfefcgdgdhehfhghgi", white: "baeacbdbebfbibacbcccecgccdfdgdfegeffhfifegfgggighhhi" },
            },
        },
    },
    {
        id: "basic-skills-determine-winner-8",
        chapterId: "basic-skills",
        order: 285,
        title: { zh: "胜者 · 8/12", en: "Winner · 8/12" },
        instruction: { zh: "棋局结束了。谁赢了？", en: "The game is over. Who has won?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "baabbbebfbbcadcedeeefeafbfcfffhfifdgfghgbhchdhfhghhhbi", white: "cafacbgbccfchcbdcdddedfdgdhdidaebegeheiegfggcidi" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "棋局结束了。谁赢了？", en: "The game is over. Who has won?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "same", label: { zh: "平局", en: "Same" } }],
            correctValue: "White",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "baabbbebfbbcadcedeeefeafbfcfffhfifdgfghgbhchdhfhghhhbi", white: "cafacbgbccfchcbdcdddedfdgdhdidaebegeheiegfggcidi" },
            },
        },
    },
    {
        id: "basic-skills-determine-winner-9",
        chapterId: "basic-skills",
        order: 286,
        title: { zh: "胜者 · 9/12", en: "Winner · 9/12" },
        instruction: { zh: "棋局结束了。谁赢了？", en: "The game is over. Who has won?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "caeadbebacbcccdcddcedecfdfefffcgfgchfhci", white: "fafbecgcedgdeefegeheiegfdgggdhghdieifigi" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "棋局结束了。谁赢了？", en: "The game is over. Who has won?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "same", label: { zh: "平局", en: "Same" } }],
            correctValue: "White",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "caeadbebacbcccdcddcedecfdfefffcgfgchfhci", white: "fafbecgcedgdeefegeheiegfdgggdhghdieifigi" },
            },
        },
    },
    {
        id: "basic-skills-determine-winner-10",
        chapterId: "basic-skills",
        order: 287,
        title: { zh: "胜者 · 10/12", en: "Winner · 10/12" },
        instruction: { zh: "棋局结束了。谁赢了？", en: "The game is over. Who has won?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "bagabbgbibbchcicddedaebecedefecfdfefffgfhfifbgfhgh", white: "cafahacbfbccdcecfcgcadbdcdfdgdidgeheiebfhgighhhi" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "棋局结束了。谁赢了？", en: "The game is over. Who has won?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "same", label: { zh: "平局", en: "Same" } }],
            correctValue: "Black",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "bagabbgbibbchcicddedaebecedefecfdfefffgfhfifbgfhgh", white: "cafahacbfbccdcecfcgcadbdcdfdgdidgeheiebfhgighhhi" },
            },
        },
    },
    {
        id: "basic-skills-determine-winner-11",
        chapterId: "basic-skills",
        order: 288,
        title: { zh: "胜者 · 11/12", en: "Winner · 11/12" },
        instruction: { zh: "棋局结束了。谁赢了？", en: "The game is over. Who has won?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "dafahabbcbdbebfbgbhbibacdcfcddfdaebecededfffhfdgegfghgahbh", white: "bacabcccecgchciccdedgdeefegeheafbfcfefgfcgggchdhehfhghaidi" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "棋局结束了。谁赢了？", en: "The game is over. Who has won?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "same", label: { zh: "平局", en: "Same" } }],
            correctValue: "White",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "dafahabbcbdbebfbgbhbibacdcfcddfdaebecededfffhfdgegfghgahbh", white: "bacabcccecgchciccdedgdeefegeheafbfcfefgfcgggchdhehfhghaidi" },
            },
        },
    },
    {
        id: "basic-skills-determine-winner-12",
        chapterId: "basic-skills",
        order: 289,
        title: { zh: "胜者 · 12/12", en: "Winner · 12/12" },
        instruction: { zh: "棋局结束了。谁赢了？", en: "The game is over. Who has won?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "dagabbcbdbgbacbcgchcbdfdgdbegeheafbfgfhfifagigahchdhehfhihdifi", white: "baeaabebfbccdcecfccdedhdidceeefecfffbgcgdgegfggghgbhghhhbihi" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "棋局结束了。谁赢了？", en: "The game is over. Who has won?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "same", label: { zh: "平局", en: "Same" } }],
            correctValue: "White",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "dagabbcbdbgbacbcgchcbdfdgdbegeheafbfgfhfifagigahchdhehfhihdifi", white: "baeaabebfbccdcecfccdedhdidceeefecfffbgcgdgegfggghgbhghhhbihi" },
            },
        },
    },
];

const closeTerritoryLevels: Level[] = [
    {
        id: "basic-skills-close_territory-1",
        chapterId: "basic-skills",
        order: 290,
        title: { zh: "封锁领地 · 1/12", en: "Close Territory · 1/12" },
        instruction: { zh: "黑棋领地较小，但白棋可以通过落子于A点来缩减它。黑先。通过一手棋封闭领地，阻止这种缩减。", en: "Black has a small territory, but White can reduce it by playing at A. Black to play. Prevent this reduction by closing the territory with one move." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "afbfcfdfdhbhdg", white: "aebecedeeeefegehei" },
            marks: { A: "di" },
            correct: ["di"],
        },
    },
    {
        id: "basic-skills-close_territory-2",
        chapterId: "basic-skills",
        order: 291,
        title: { zh: "封锁领地 · 2/12", en: "Close Territory · 2/12" },
        instruction: { zh: "黑先。通过一手棋封闭黑棋领地。", en: "Black to play. Close the black territory with one move." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cdddedfdgdcegecfgfcgdgfggg", white: "ccdcecfcgcbdhdbehebfhfbgeghgchdhehfhgh" },
            correct: ["ef"],
        },
    },
    {
        id: "basic-skills-close_territory-3",
        chapterId: "basic-skills",
        order: 292,
        title: { zh: "封锁领地 · 3/12", en: "Close Territory · 3/12" },
        instruction: { zh: "黑先。通过一手棋封闭黑棋领地。", en: "Black to play. Close the black territory with one move." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "dfefffgfcgggchehghci", white: "deeefegebfcfhfbghgbhhhbigihi" },
            correct: ["fi"],
        },
    },
    {
        id: "basic-skills-close_territory-4",
        chapterId: "basic-skills",
        order: 293,
        title: { zh: "封锁领地 · 4/12", en: "Close Territory · 4/12" },
        instruction: { zh: "黑先。通过一手棋封闭黑棋领地。", en: "Black to play. Close the black territory with one move." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "adbdcdcecgbhchci", white: "acbcccdcdddecfdfdgdhdi" },
            correct: ["bf"],
        },
    },
    {
        id: "basic-skills-close_territory-5",
        chapterId: "basic-skills",
        order: 294,
        title: { zh: "封锁领地 · 5/12", en: "Close Territory · 5/12" },
        instruction: { zh: "黑先。通过一手棋封闭黑棋领地。", en: "Black to play. Close the black territory with one move." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cfdfefffgfcgggghbicigi", white: "bdcedeeefegebfhfbghgbhhhhi" },
            correct: ["ch"],
        },
    },
    {
        id: "basic-skills-close_territory-6",
        chapterId: "basic-skills",
        order: 295,
        title: { zh: "封锁领地 · 6/12", en: "Close Territory · 6/12" },
        instruction: { zh: "黑先。通过一手棋封闭黑棋领地。", en: "Black to play. Close the black territory with one move." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "afbfcfdfbhdhehei", white: "aebecedeeeefegggfhfi" },
            correct: ["dg"],
        },
    },
    {
        id: "basic-skills-close_territory-7",
        chapterId: "basic-skills",
        order: 296,
        title: { zh: "封锁领地 · 7/12", en: "Close Territory · 7/12" },
        instruction: { zh: "黑先。通过一手棋封闭黑棋领地。", en: "Black to play. Close the black territory with one move." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "agbgdgegbhehei", white: "afbfcfdfefffcgfgfhfi" },
            correct: ["ch"],
        },
    },
    {
        id: "basic-skills-close_territory-8",
        chapterId: "basic-skills",
        order: 297,
        title: { zh: "封锁领地 · 8/12", en: "Close Territory · 8/12" },
        instruction: { zh: "黑先。通过一手棋封闭黑棋领地。", en: "Black to play. Close the black territory with one move." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cgdgahbhdhfhghgi", white: "bfcfdfagbgegfggghghhhi" },
            correct: ["eh"],
        },
    },
    {
        id: "basic-skills-close_territory-9",
        chapterId: "basic-skills",
        order: 298,
        title: { zh: "封锁领地 · 9/12", en: "Close Territory · 9/12" },
        instruction: { zh: "黑先。通过一手棋封闭黑棋领地。", en: "Black to play. Close the black territory with one move." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "agbgcgdgbidi", white: "afbfcfdfefegehei" },
            correct: ["dh"],
        },
    },
    {
        id: "basic-skills-close_territory-10",
        chapterId: "basic-skills",
        order: 299,
        title: { zh: "封锁领地 · 10/12", en: "Close Territory · 10/12" },
        instruction: { zh: "黑先。通过一手棋封闭黑棋领地。", en: "Black to play. Close the black territory with one move." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "bfcfagahchdhbi", white: "aebecedeafdfdgehdiei" },
            correct: ["cg"],
            wrong: ["cicg"],
        },
    },
    {
        id: "basic-skills-close_territory-11",
        chapterId: "basic-skills",
        order: 300,
        title: { zh: "封锁领地 · 11/12", en: "Close Territory · 11/12" },
        instruction: { zh: "黑先。通过一手棋封闭黑棋领地。", en: "Black to play. Close the black territory with one move." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "bgcgdgegahehei", white: "afbfcfdfefffagfgfhfi" },
            correct: ["bh", "bi", "ch"],
            wrong: ["aibhchbi", "aibhbici"],
        },
    },
    {
        id: "basic-skills-close_territory-12",
        chapterId: "basic-skills",
        order: 301,
        title: { zh: "封锁领地 · 12/12", en: "Close Territory · 12/12" },
        instruction: { zh: "黑先。通过一手棋封闭黑棋领地。", en: "Black to play. Close the black territory with one move." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "aeafbfbgcgegahdhehdi", white: "adcdbecfdfefffdgfgfheifi" },
            correct: ["ch", "bh", "ci", "bichci"],
            wrong: ["bichbhci"],
        },
    },
];

const compareLibertiesLevels: Level[] = [
    {
        id: "basic-skills-compare-liberties-1",
        chapterId: "basic-skills",
        order: 302,
        title: { zh: "比较气数 · 1/12", en: "Compare Liberties · 1/12" },
        instruction: { zh: "黑棋和白棋的哪个棋串气更多？", en: "Which chain has most liberties, black or white?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "dgcheh", white: "egdhfh" },
            marks: { triangle: "ehdh" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋和白棋的哪个棋串气更多？", en: "Which chain has most liberties, black or white?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "same", label: { zh: "一样多", en: "same" } }],
            correctValue: "same",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "dgcheh", white: "egdhfh" },
                marks: { triangle: "ehdh" },
            },
        },
    },
    {
        id: "basic-skills-compare-liberties-2",
        chapterId: "basic-skills",
        order: 303,
        title: { zh: "比较气数 · 2/12", en: "Compare Liberties · 2/12" },
        instruction: { zh: "黑棋和白棋的哪个棋串气更多？", en: "Which chain has most liberties, black or white?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "hcgdgehfhg", white: "hdhegfgghh" },
            marks: { triangle: "hghfhehd" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋和白棋的哪个棋串气更多？", en: "Which chain has most liberties, black or white?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "same", label: { zh: "一样多", en: "same" } }],
            correctValue: "same",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "hcgdgehfhg", white: "hdhegfgghh" },
                marks: { triangle: "hghfhehd" },
            },
        },
    },
    {
        id: "basic-skills-compare-liberties-3",
        chapterId: "basic-skills",
        order: 304,
        title: { zh: "比较气数 · 3/12", en: "Compare Liberties · 3/12" },
        instruction: { zh: "黑棋和白棋的哪个棋串气更多？", en: "Which chain has most liberties, black or white?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "cbdbhbecfcgc", white: "bbebfbgbccdc" },
            marks: { triangle: "gbfbebdbcb" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋和白棋的哪个棋串气更多？", en: "Which chain has most liberties, black or white?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "same", label: { zh: "一样多", en: "same" } }],
            correctValue: "White",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "cbdbhbecfcgc", white: "bbebfbgbccdc" },
                marks: { triangle: "gbfbebdbcb" },
            },
        },
    },
    {
        id: "basic-skills-compare-liberties-4",
        chapterId: "basic-skills",
        order: 305,
        title: { zh: "比较气数 · 4/12", en: "Compare Liberties · 4/12" },
        instruction: { zh: "黑棋和白棋的哪个棋串气更多？", en: "Which chain has most liberties, black or white?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "bccdbebf", white: "bdcecfbg" },
            marks: { triangle: "bfbebd" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋和白棋的哪个棋串气更多？", en: "Which chain has most liberties, black or white?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "same", label: { zh: "一样多", en: "same" } }],
            correctValue: "Black",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "bccdbebf", white: "bdcecfbg" },
                marks: { triangle: "bfbebd" },
            },
        },
    },
    {
        id: "basic-skills-compare-liberties-5",
        chapterId: "basic-skills",
        order: 306,
        title: { zh: "比较气数 · 5/12", en: "Compare Liberties · 5/12" },
        instruction: { zh: "黑棋和白棋的哪个棋串气更多？", en: "Which chain has most liberties, black or white?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "bgcgdgegfgbhghhhihgi", white: "gdgegghgigchdhehfhfi" },
            marks: { triangle: "gifiihhhghfhehdhch" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋和白棋的哪个棋串气更多？", en: "Which chain has most liberties, black or white?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "same", label: { zh: "一样多", en: "same" } }],
            correctValue: "White",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "bgcgdgegfgbhghhhihgi", white: "gdgegghgigchdhehfhfi" },
                marks: { triangle: "gifiihhhghfhehdhch" },
            },
        },
    },
    {
        id: "basic-skills-compare-liberties-6",
        chapterId: "basic-skills",
        order: 307,
        title: { zh: "比较气数 · 6/12", en: "Compare Liberties · 6/12" },
        instruction: { zh: "黑棋和白棋的哪个棋串气更多？", en: "Which chain has most liberties, black or white?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "dehedfhfegfggg", white: "efffgfcgdghgehhh" },
            marks: { triangle: "ggfgeggfffef" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋和白棋的哪个棋串气更多？", en: "Which chain has most liberties, black or white?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "same", label: { zh: "一样多", en: "same" } }],
            correctValue: "White",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "dehedfhfegfggg", white: "efffgfcgdghgehhh" },
                marks: { triangle: "ggfgeggfffef" },
            },
        },
    },
    {
        id: "basic-skills-compare-liberties-7",
        chapterId: "basic-skills",
        order: 308,
        title: { zh: "比较气数 · 7/12", en: "Compare Liberties · 7/12" },
        instruction: { zh: "黑棋和白棋的哪个棋串气更多？", en: "Which chain has most liberties, black or white?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "fafbfcdded", white: "eaebecfdgd" },
            marks: { triangle: "fcecfbebfaea" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋和白棋的哪个棋串气更多？", en: "Which chain has most liberties, black or white?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "same", label: { zh: "一样多", en: "same" } }],
            correctValue: "same",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "fafbfcdded", white: "eaebecfdgd" },
                marks: { triangle: "fcecfbebfaea" },
            },
        },
    },
    {
        id: "basic-skills-compare-liberties-8",
        chapterId: "basic-skills",
        order: 309,
        title: { zh: "比较气数 · 8/12", en: "Compare Liberties · 8/12" },
        instruction: { zh: "黑棋和白棋的哪个棋串气更多？", en: "Which chain has most liberties, black or white?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "bccceccdbebfcf", white: "adbdcededfbgcg" },
            marks: { triangle: "cfbfbebdad" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋和白棋的哪个棋串气更多？", en: "Which chain has most liberties, black or white?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "same", label: { zh: "一样多", en: "same" } }],
            correctValue: "same",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "bccceccdbebfcf", white: "adbdcededfbgcg" },
                marks: { triangle: "cfbfbebdad" },
            },
        },
    },
    {
        id: "basic-skills-compare-liberties-9",
        chapterId: "basic-skills",
        order: 310,
        title: { zh: "比较气数 · 9/12", en: "Compare Liberties · 9/12" },
        instruction: { zh: "黑棋和白棋的哪个棋串气更多？", en: "Which chain has most liberties, black or white?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "fegehefffghgfhhhhi", white: "ccecgcgfhfggghfigi" },
            marks: { triangle: "higifihhghhggghfgf" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋和白棋的哪个棋串气更多？", en: "Which chain has most liberties, black or white?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "same", label: { zh: "一样多", en: "same" } }],
            correctValue: "Black",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "fegehefffghgfhhhhi", white: "ccecgcgfhfggghfigi" },
                marks: { triangle: "higifihhghhggghfgf" },
            },
        },
    },
    {
        id: "basic-skills-compare-liberties-10",
        chapterId: "basic-skills",
        order: 311,
        title: { zh: "比较气数 · 10/12", en: "Compare Liberties · 10/12" },
        instruction: { zh: "黑棋和白棋的哪个棋串气更多？", en: "Which chain has most liberties, black or white?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "dfefcgegbhcheh", white: "bfcfbgdgahdhfh" },
            marks: { triangle: "dhchbhdgcg" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋和白棋的哪个棋串气更多？", en: "Which chain has most liberties, black or white?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "same", label: { zh: "一样多", en: "same" } }],
            correctValue: "Black",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "dfefcgegbhcheh", white: "bfcfbgdgahdhfh" },
                marks: { triangle: "dhchbhdgcg" },
            },
        },
    },
    {
        id: "basic-skills-compare-liberties-11",
        chapterId: "basic-skills",
        order: 312,
        title: { zh: "比较气数 · 11/12", en: "Compare Liberties · 11/12" },
        instruction: { zh: "黑棋和白棋的哪个棋串气更多？", en: "Which chain has most liberties, black or white?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "bfcgdgbhehfhgh", white: "egfgggchdhhhgi" },
            marks: { triangle: "ghfhehdhch" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋和白棋的哪个棋串气更多？", en: "Which chain has most liberties, black or white?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "same", label: { zh: "一样多", en: "same" } }],
            correctValue: "same",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "bfcgdgbhehfhgh", white: "egfgggchdhhhgi" },
                marks: { triangle: "ghfhehdhch" },
            },
        },
    },
    {
        id: "basic-skills-compare-liberties-12",
        chapterId: "basic-skills",
        order: 313,
        title: { zh: "比较气数 · 12/12", en: "Compare Liberties · 12/12" },
        instruction: { zh: "黑棋和白棋的哪个棋串气更多？", en: "Which chain has most liberties, black or white?" },
        kind: "multipleChoice",
        puzzle: {
            width: 9,
            height: 9,
            initial_state: { black: "cfhfdgegfghgchghhhihgiii", white: "ecgcgeheiegfifggdhehfhfi" },
            marks: { triangle: "iigifiihhhghfhehdhhghf" },
            correct: [],
        },
        multipleChoice: {
            question: { zh: "黑棋和白棋的哪个棋串气更多？", en: "Which chain has most liberties, black or white?" },
            options: [{ value: "Black", label: { zh: "黑棋", en: "Black" } }, { value: "White", label: { zh: "白棋", en: "White" } }, { value: "same", label: { zh: "一样多", en: "same" } }],
            correctValue: "same",
            board: {
                width: 9,
                height: 9,
                initial_state: { black: "cfhfdgegfghgchghhhihgiii", white: "ecgcgeheiegfifggdhehfhfi" },
                marks: { triangle: "iigifiihhhghfhehdhhghf" },
            },
        },
    },
];

const capturingRaceLevels: Level[] = [
    {
        id: "basic-skills-capturing_race-1",
        chapterId: "basic-skills",
        order: 314,
        title: { zh: "对杀 · 1/18", en: "Capturing Race · 1/18" },
        instruction: { zh: "被标记的两个棋串都有两口气。白棋可以通过减少黑棋串的气来吃掉它。如果轮到黑棋走，黑棋也可以做同样的事情。这被称为'对杀'。如果双方气数相同，先落子的一方将赢得对杀。白先。赢得对杀。", en: "The two marked chains both have two liberties. White can capture the black chain by reducing its liberties. Black can do the same if it was Black's turn to play. This is called a 'capturing race'. If both players have the same number of liberties, the player that plays first will win the capturing race. White to play. Win the capturing race." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "hcgdgehfhg", white: "hdhegfgghh" },
            marks: { triangle: "hghfhehd" },
            correct: ["igieif", "ifidig"],
            wrong: ["igieidic", "ifidieig"],
        },
    },
    {
        id: "basic-skills-capturing_race-2",
        chapterId: "basic-skills",
        order: 315,
        title: { zh: "对杀 · 2/18", en: "Capturing Race · 2/18" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "dfefdgfgchfh", white: "cecfcgegdheh" },
            marks: { triangle: "ehdhcheg" },
            correct: ["bhdici"],
            wrong: ["bhdieifi", "cibhbgei", "cibhbiei", "cibhahei"],
        },
    },
    {
        id: "basic-skills-capturing_race-3",
        chapterId: "basic-skills",
        order: 316,
        title: { zh: "对杀 · 3/18", en: "Capturing Race · 3/18" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gfegfgdhgh", white: "cgdgehfh" },
            marks: { triangle: "fhehdh" },
            correct: ["cheidi", "dichbhfici"],
            wrong: ["cheifigi", "dichbhfieici", "dichcibh"],
        },
    },
    {
        id: "basic-skills-capturing_race-4",
        chapterId: "basic-skills",
        order: 317,
        title: { zh: "对杀 · 4/18", en: "Capturing Race · 4/18" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "bbcccdaebe", white: "adbdcecf" },
            marks: { triangle: "beaebdad" },
            correct: ["bfbcaf", "afbcbf"],
            wrong: ["bfbcacab", "afbcacab", "acabbfbc"],
        },
    },
    {
        id: "basic-skills-capturing_race-5",
        chapterId: "basic-skills",
        order: 318,
        title: { zh: "对杀 · 5/18", en: "Capturing Race · 5/18" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "efffdgfgdh", white: "dfcgegeh" },
            marks: { triangle: "ehdhegdg" },
            correct: ["chfhdi", "dichbhfhci"],
            wrong: ["dichcibh", "fhchbhcf", "fhchghcf", "fhchcfgh"],
        },
    },
    {
        id: "basic-skills-capturing_race-6",
        chapterId: "basic-skills",
        order: 319,
        title: { zh: "对杀 · 6/18", en: "Capturing Race · 6/18" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "egfgggchdhghci", white: "bfcgdgbhehfh" },
            marks: { triangle: "cifhehdhch" },
            correct: ["bifidi", "eibiahagbggiaifidi"],
            wrong: ["bifieidi", "diei", "eibiaiah", "eibiahagafgibgfi", "eibiahagbggiaffi", "eibidifi", "figi"],
        },
    },
    {
        id: "basic-skills-capturing_race-7",
        chapterId: "basic-skills",
        order: 320,
        title: { zh: "对杀 · 7/18", en: "Capturing Race · 7/18" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "adbdcededfbgcgeg", white: "bccceccdbebfcf" },
            marks: { triangle: "cfbfbebdad" },
            correct: ["acafae"],
            wrong: ["aeaf", "afag"],
        },
    },
    {
        id: "basic-skills-capturing_race-8",
        chapterId: "basic-skills",
        order: 321,
        title: { zh: "对杀 · 8/18", en: "Capturing Race · 8/18" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "bfefcgdgbhehfhghei", white: "egfgggchdhhhgihi" },
            marks: { triangle: "eighfhehdhch" },
            correct: ["ficidi"],
            wrong: ["dici", "cibi"],
        },
    },
    {
        id: "basic-skills-capturing_race-9",
        chapterId: "basic-skills",
        order: 322,
        title: { zh: "对杀 · 9/18", en: "Capturing Race · 9/18" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "fabbebfbgbccdcde", white: "hacbdbhbecfcgc" },
            marks: { triangle: "gbfbebdbcbfa" },
            correct: ["gadaea", "dabagacaea"],
            wrong: ["gadacaba", "eada", "dabaeaca", "caba"],
        },
    },
    {
        id: "basic-skills-capturing_race-10",
        chapterId: "basic-skills",
        order: 323,
        title: { zh: "对杀 · 10/18", en: "Capturing Race · 10/18" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "dgegfgchghhhihgi", white: "gghgigdhehfhfi" },
            marks: { triangle: "gifiihhhghfhehdh" },
            correct: ["iidihi", "hiiihi", "hiiidicihi"],
            wrong: ["hiiicieidibi", "dici", "cieidibi"],
        },
    },
    {
        id: "basic-skills-capturing_race-11",
        chapterId: "basic-skills",
        order: 324,
        title: { zh: "对杀 · 11/18", en: "Capturing Race · 11/18" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "dehedfhfegfggg", white: "efffgfcgdghghh" },
            marks: { triangle: "ggfgeggfffef" },
            correct: ["ehgegheefh", "ehgefheegh", "ghdhehfhfi", "ghdhfhehchcidieifi", "fhehghdhchcieieedi", "fhehghdhchcieieefefddi", "fhehghdhchcieieegegddi", "fhehghdhchcibigedieeei", "fhehghdhchcibigeeieedi", "fhehdhgheifidi", "fhehdhghfieidigihigefifhfi"],
            wrong: ["ehgefefd", "ghdhfheheichbhbgcfbfcecd", "fhehdhghgifihieedige", "fhehdhghgifihieefefd", "fhehdhghgifihieegegd", "fhehdhghgifihieeeidi", "fhehdhghgifidihieiig", "fhehdhghgifieidihici", "fhehdhghfieigihi"],
        },
    },
    {
        id: "basic-skills-capturing_race-12",
        chapterId: "basic-skills",
        order: 325,
        title: { zh: "对杀 · 12/18", en: "Capturing Race · 12/18" },
        instruction: { zh: "白先。赢得对杀。", en: "White to play. Win the capturing race." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "fafbfcdded", white: "eaebecfdgd" },
            marks: { triangle: "fcecfbebfaea" },
            correct: ["gcdcgbdbga", "gbgchchbga", "gagbhbhagchcga", "gagbhbhahcdcgcdbga"],
            wrong: ["gagbgchbhchaibdciaic", "gagbgchbhchaibdcicdb"],
        },
    },
    {
        id: "basic-skills-capturing_race-13",
        chapterId: "basic-skills",
        order: 326,
        title: { zh: "对杀 · 13/18", en: "Capturing Race · 13/18" },
        instruction: { zh: "黑先。赢得对杀并吃掉被标记的棋子，同时避免使自己处于打吃状态。", en: "Black to play. Win the capturing race and capture the marked stones without putting yourself in atari." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "becfdfbgegbhehei", white: "efffcgdgfgchfhfi" },
            marks: { triangle: "chdgcg" },
            correct: ["ci"],
            wrong: ["dhdi"],
        },
    },
    {
        id: "basic-skills-capturing_race-14",
        chapterId: "basic-skills",
        order: 327,
        title: { zh: "对杀 · 14/18", en: "Capturing Race · 14/18" },
        instruction: { zh: "黑先。赢得对杀并吃掉被标记的棋子，同时避免使自己处于打吃状态。", en: "Black to play. Win the capturing race and capture the marked stones without putting yourself in atari." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "egfgggchdhhhgihi", white: "bfcgdgbhehfhghei" },
            marks: { triangle: "eighfheh" },
            correct: ["fi"],
            wrong: ["dici", "bidi"],
        },
    },
    {
        id: "basic-skills-capturing_race-15",
        chapterId: "basic-skills",
        order: 328,
        title: { zh: "对杀 · 15/18", en: "Capturing Race · 15/18" },
        instruction: { zh: "黑先。赢得对杀并吃掉被标记的棋子，同时避免使自己处于打吃状态。", en: "Black to play. Win the capturing race and capture the marked stones without putting yourself in atari." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "becebfagcgahch", white: "cfdfbgdgbhehbi" },
            marks: { triangle: "bibhbg" },
            correct: ["ci"],
            wrong: ["aiaf"],
        },
    },
    {
        id: "basic-skills-capturing_race-16",
        chapterId: "basic-skills",
        order: 329,
        title: { zh: "对杀 · 16/18", en: "Capturing Race · 16/18" },
        instruction: { zh: "黑先。赢得对杀并吃掉被标记的棋子，同时避免使自己处于打吃状态。", en: "Black to play. Win the capturing race and capture the marked stones without putting yourself in atari." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "hfegfgggchdhhhdihi", white: "ccbfcgdgbhehfhghfi" },
            marks: { triangle: "fighfheh" },
            correct: ["gi"],
            wrong: ["eici"],
        },
    },
    {
        id: "basic-skills-capturing_race-17",
        chapterId: "basic-skills",
        order: 330,
        title: { zh: "对杀 · 17/18", en: "Capturing Race · 17/18" },
        instruction: { zh: "黑先。赢得对杀并吃掉被标记的棋子，同时避免使自己处于打吃状态。", en: "Black to play. Win the capturing race and capture the marked stones without putting yourself in atari." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "fedfefcgfgchfhci", white: "cecfbgdgegbhdhei" },
            marks: { triangle: "eidhegdg" },
            correct: ["eh"],
            wrong: ["dibi"],
        },
    },
    {
        id: "basic-skills-capturing_race-18",
        chapterId: "basic-skills",
        order: 331,
        title: { zh: "对杀 · 18/18", en: "Capturing Race · 18/18" },
        instruction: { zh: "黑先。赢得对杀并吃掉被标记的棋子，同时避免使自己处于打吃状态。", en: "Black to play. Win the capturing race and capture the marked stones without putting yourself in atari." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "bdbfcfagdgbhdhai", white: "dedfefbgcgegchci" },
            marks: { triangle: "cichcgbg" },
            correct: ["di"],
            wrong: ["biah"],
        },
    },
];

const correctSideLevels: Level[] = [
    {
        id: "basic-skills-correct-side-1",
        chapterId: "basic-skills",
        order: 332,
        title: { zh: "正确方向 · 1/24", en: "Correct Side · 1/24" },
        instruction: { zh: "黑先。通过正确方向的打吃来吃掉白棋串。", en: "Black to play. Capture a white chain by putting it in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "gchecfdfgfegfggh", white: "ccefcgdgchehfhdi" },
            correct: ["ee"],
            wrong: ["fiee"],
        },
    },
    {
        id: "basic-skills-correct-side-2",
        chapterId: "basic-skills",
        order: 333,
        title: { zh: "正确方向 · 2/24", en: "Correct Side · 2/24" },
        instruction: { zh: "黑先。通过正确方向的打吃来吃掉白棋串。", en: "Black to play. Capture a white chain by putting it in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "dfefcgfgfh", white: "ffgfeggggh" },
            correct: ["eh"],
            wrong: ["dgeh"],
        },
    },
    {
        id: "basic-skills-correct-side-3",
        chapterId: "basic-skills",
        order: 334,
        title: { zh: "正确方向 · 3/24", en: "Correct Side · 3/24" },
        instruction: { zh: "黑先。通过正确方向的打吃来吃掉白棋串。", en: "Black to play. Capture a white chain by putting it in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cfdfbgegfg", white: "efffhfdggg" },
            correct: ["dh"],
            wrong: ["cgdhehfh", "cgdhcheh"],
        },
    },
    {
        id: "basic-skills-correct-side-4",
        chapterId: "basic-skills",
        order: 335,
        title: { zh: "正确方向 · 4/24", en: "Correct Side · 4/24" },
        instruction: { zh: "黑先。通过正确方向的打吃来吃掉白棋串。", en: "Black to play. Capture a white chain by putting it in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "bbcbacdcecfddeeeff", white: "dadbbccccdddedbfcg" },
            correct: ["cebdbe"],
            wrong: ["cebdadbe", "bdce"],
        },
    },
    {
        id: "basic-skills-correct-side-5",
        chapterId: "basic-skills",
        order: 336,
        title: { zh: "正确方向 · 5/24", en: "Correct Side · 5/24" },
        instruction: { zh: "黑先。通过正确方向的打吃来吃掉白棋串。", en: "Black to play. Capture a white chain by putting it in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "fbdcfcfddeeecg", white: "ecgcddedgdfege" },
            correct: ["cdebdb", "cdebeadbcbccda"],
            wrong: ["cdebeadbcbccbcgb", "cdebeadbdacb", "cdebeadbccgb", "ebcd"],
        },
    },
    {
        id: "basic-skills-correct-side-6",
        chapterId: "basic-skills",
        order: 337,
        title: { zh: "正确方向 · 6/24", en: "Correct Side · 6/24" },
        instruction: { zh: "黑先。通过正确方向的打吃来吃掉白棋串。", en: "Black to play. Capture a white chain by putting it in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "ddedcefefffg", white: "ecfdgddeeedg" },
            correct: ["df"],
            wrong: ["efdf"],
        },
    },
    {
        id: "basic-skills-correct-side-7",
        chapterId: "basic-skills",
        order: 338,
        title: { zh: "正确方向 · 7/24", en: "Correct Side · 7/24" },
        instruction: { zh: "黑先。通过正确方向的打吃来吃掉白棋串。", en: "Black to play. Capture a white chain by putting it in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cfgfdgegfg", white: "cccddfbgcg" },
            correct: ["deefee", "deefffeeedfefdgehe", "deefffeeedfegefdfcgdhdgcgb"],
            wrong: ["deefffeeedfefdgegdhe", "deefffeeedfegefdfcgdhdgchcgb", "deefffeeedfegefdfcgdgchd", "deefffeeedfegefdgdfc", "deefffeefeed", "efde"],
        },
    },
    {
        id: "basic-skills-correct-side-8",
        chapterId: "basic-skills",
        order: 339,
        title: { zh: "正确方向 · 8/24", en: "Correct Side · 8/24" },
        instruction: { zh: "黑先。通过正确方向的打吃来吃掉白棋串。", en: "Black to play. Capture a white chain by putting it in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cfffdgeg", white: "gceffggg" },
            correct: ["ee"],
            wrong: ["dfee"],
        },
    },
    {
        id: "basic-skills-correct-side-9",
        chapterId: "basic-skills",
        order: 340,
        title: { zh: "正确方向 · 9/24", en: "Correct Side · 9/24" },
        instruction: { zh: "黑先。通过正确方向的打吃来吃掉白棋串。", en: "Black to play. Capture a white chain by putting it in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "gcfffgghgi", white: "dgegchfhfi" },
            correct: ["eh"],
            wrong: ["eieh"],
        },
    },
    {
        id: "basic-skills-correct-side-10",
        chapterId: "basic-skills",
        order: 341,
        title: { zh: "正确方向 · 10/24", en: "Correct Side · 10/24" },
        instruction: { zh: "黑先。通过正确方向的打吃来吃掉白棋串。", en: "Black to play. Capture a white chain by putting it in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "gcfffgdhehgh", white: "cfdgegchfhfi" },
            correct: ["gi"],
            wrong: ["eidi"],
        },
    },
    {
        id: "basic-skills-correct-side-11",
        chapterId: "basic-skills",
        order: 342,
        title: { zh: "正确方向 · 11/24", en: "Correct Side · 11/24" },
        instruction: { zh: "黑先。通过正确方向的打吃来吃掉白棋串。", en: "Black to play. Capture a white chain by putting it in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "feffeggggh", white: "dfefcgfgfh" },
            correct: ["eh"],
            wrong: ["fieh"],
        },
    },
    {
        id: "basic-skills-correct-side-12",
        chapterId: "basic-skills",
        order: 343,
        title: { zh: "正确方向 · 12/24", en: "Correct Side · 12/24" },
        instruction: { zh: "黑先。通过正确方向的打吃来吃掉白棋串。", en: "Black to play. Capture a white chain by putting it in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "gccegeafcfbgbhch", white: "cccdbeeebfcgdgeg" },
            correct: ["bd"],
            wrong: ["aebd"],
        },
    },
    {
        id: "basic-skills-correct-side-13",
        chapterId: "basic-skills",
        order: 344,
        title: { zh: "正确方向 · 13/24", en: "Correct Side · 13/24" },
        instruction: { zh: "白先。通过正确方向的打吃来吃掉黑棋串。", en: "White to play. Capture a black chain by putting it in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "cccecfdgeg", white: "dfeffgeh" },
            correct: ["cgdhch"],
            wrong: ["cgdhdichcibg", "cgdhdichbhbg", "cgdhdichbgbh", "dhcg"],
        },
    },
    {
        id: "basic-skills-correct-side-14",
        chapterId: "basic-skills",
        order: 345,
        title: { zh: "正确方向 · 14/24", en: "Correct Side · 14/24" },
        instruction: { zh: "白先。通过正确方向的打吃来吃掉黑棋串。", en: "White to play. Capture a black chain by putting it in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "eccdfddeeegegfegfg", white: "ebfcddgdcedfefff" },
            correct: ["fe"],
            wrong: ["eddc", "dcfe", "bdfe", "ccfe"],
        },
    },
    {
        id: "basic-skills-correct-side-15",
        chapterId: "basic-skills",
        order: 346,
        title: { zh: "正确方向 · 15/24", en: "Correct Side · 15/24" },
        instruction: { zh: "白先。通过正确方向的打吃来吃掉黑棋串。", en: "White to play. Capture a black chain by putting it in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "cbccdddedgeg", white: "eecgfgdheh" },
            correct: ["df"],
            wrong: ["efdf"],
        },
    },
    {
        id: "basic-skills-correct-side-16",
        chapterId: "basic-skills",
        order: 347,
        title: { zh: "正确方向 · 16/24", en: "Correct Side · 16/24" },
        instruction: { zh: "白先。通过正确方向的打吃来吃掉黑棋串。", en: "White to play. Capture a black chain by putting it in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "egahbhdhfhaibidi", white: "ccbedfagbgdgeh" },
            correct: ["chciei"],
            wrong: ["chcicgei", "cicheifi", "cichcgei", "eifi"],
        },
    },
    {
        id: "basic-skills-correct-side-17",
        chapterId: "basic-skills",
        order: 348,
        title: { zh: "正确方向 · 17/24", en: "Correct Side · 17/24" },
        instruction: { zh: "白先。通过正确方向的打吃来吃掉黑棋串。", en: "White to play. Capture a black chain by putting it in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "cccddefedfgfgg", white: "ddedcecfdgeg" },
            correct: ["ee"],
            wrong: ["efee"],
        },
    },
    {
        id: "basic-skills-correct-side-18",
        chapterId: "basic-skills",
        order: 349,
        title: { zh: "正确方向 · 18/24", en: "Correct Side · 18/24" },
        instruction: { zh: "白先。通过正确方向的打吃来吃掉黑棋串。", en: "White to play. Capture a black chain by putting it in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ddcfdfcgegbhbi", white: "gceeefdgchdh" },
            correct: ["fgehfh", "fgeheifhgh"],
            wrong: ["fgeheifhfigh", "ehfg"],
        },
    },
    {
        id: "basic-skills-correct-side-19",
        chapterId: "basic-skills",
        order: 350,
        title: { zh: "正确方向 · 19/24", en: "Correct Side · 19/24" },
        instruction: { zh: "白先。通过正确方向的打吃来吃掉黑棋串。", en: "White to play. Capture a black chain by putting it in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "eddefecfdfbgdgdh", white: "dcbdddcebfcgch" },
            correct: ["bh"],
            wrong: ["agbh"],
        },
    },
    {
        id: "basic-skills-correct-side-20",
        chapterId: "basic-skills",
        order: 351,
        title: { zh: "正确方向 · 20/24", en: "Correct Side · 20/24" },
        instruction: { zh: "白先。通过正确方向的打吃来吃掉黑棋串。", en: "White to play. Capture a black chain by putting it in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ddefbgcgdgahdhbi", white: "feafbfcfdfgfagegggehgh" },
            correct: ["ee"],
            wrong: ["ffee"],
        },
    },
    {
        id: "basic-skills-correct-side-21",
        chapterId: "basic-skills",
        order: 352,
        title: { zh: "正确方向 · 21/24", en: "Correct Side · 21/24" },
        instruction: { zh: "白先。通过正确方向的打吃来吃掉黑棋串。", en: "White to play. Capture a black chain by putting it in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "eeffgfeggghhgi", white: "dfefcgfgfhgh" },
            correct: ["eh"],
            wrong: ["dgeh"],
        },
    },
    {
        id: "basic-skills-correct-side-22",
        chapterId: "basic-skills",
        order: 353,
        title: { zh: "正确方向 · 22/24", en: "Correct Side · 22/24" },
        instruction: { zh: "白先。通过正确方向的打吃来吃掉黑棋串。", en: "White to play. Capture a black chain by putting it in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gdffgfeghghh", white: "dfefcgfggggh" },
            correct: ["eh"],
            wrong: ["dgehdhfh", "dgehfhfi"],
        },
    },
    {
        id: "basic-skills-correct-side-23",
        chapterId: "basic-skills",
        order: 354,
        title: { zh: "正确方向 · 23/24", en: "Correct Side · 23/24" },
        instruction: { zh: "白先。通过正确方向的打吃来吃掉黑棋串。", en: "White to play. Capture a black chain by putting it in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "fcgebfbgcgdgehfhbi", white: "cdbecfdfegfgggghfi" },
            correct: ["dh"],
            wrong: ["eidh"],
        },
    },
    {
        id: "basic-skills-correct-side-24",
        chapterId: "basic-skills",
        order: 355,
        title: { zh: "正确方向 · 24/24", en: "Correct Side · 24/24" },
        instruction: { zh: "白先。通过正确方向的打吃来吃掉黑棋串。", en: "White to play. Capture a black chain by putting it in atari at the correct side." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "dddebfdfcgegahbhehgh", white: "gceeefgfdgfgchdhbi" },
            correct: ["fh"],
            wrong: ["eifh"],
        },
    },
];

const captureLevels: Level[] = [
    {
        id: "basic-skills-capture-1",
        chapterId: "basic-skills",
        order: 356,
        title: { zh: "提子 · 1/21", en: "Capture · 1/21" },
        instruction: { zh: "黑先。吃掉被标记的白棋。", en: "Black to play. Capture the marked white stone." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "ie", white: "id" },
            marks: { triangle: "id" },
            correct: ["hdichcibhbiaha", "hdichcibiahbgbhaga"],
            wrong: ["hdicibhc"],
        },
    },
    {
        id: "basic-skills-capture-2",
        chapterId: "basic-skills",
        order: 357,
        title: { zh: "提子 · 2/21", en: "Capture · 2/21" },
        instruction: { zh: "黑先。吃掉被标记的白棋。", en: "Black to play. Capture the marked white stone." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "gcfeffdgegchdh", white: "ccdfefbgcgfgbh" },
            marks: { triangle: "fg" },
            correct: ["ggfhghehfi", "ggfhghehei"],
            wrong: ["ggfhfighhhhggfhi", "ggfhfighhhhggigf", "ggfhfighgihg", "ggfhehghhhhg", "fhgg"],
        },
    },
    {
        id: "basic-skills-capture-3",
        chapterId: "basic-skills",
        order: 358,
        title: { zh: "提子 · 3/21", en: "Capture · 3/21" },
        instruction: { zh: "黑先。吃掉被标记的白棋。", en: "Black to play. Capture the marked white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "ccdcbddddedfcgdggg", white: "bbcbbccdcecfbgbhch" },
            marks: { triangle: "cfcecd" },
            correct: ["bf"],
            wrong: ["bebf"],
        },
    },
    {
        id: "basic-skills-capture-4",
        chapterId: "basic-skills",
        order: 359,
        title: { zh: "提子 · 4/21", en: "Capture · 4/21" },
        instruction: { zh: "黑先。吃掉被标记的白棋。", en: "Black to play. Capture the marked white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cbebdccdedcecfdgdh", white: "ddfddebfdfcgegfgch" },
            marks: { triangle: "dfdedd" },
            correct: ["ef"],
            wrong: ["eeef"],
        },
    },
    {
        id: "basic-skills-capture-5",
        chapterId: "basic-skills",
        order: 360,
        title: { zh: "提子 · 5/21", en: "Capture · 5/21" },
        instruction: { zh: "黑先。吃掉被标记的白棋。", en: "Black to play. Capture the marked white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "ecgcbecefebfdfffbgdgeg", white: "bdcddeeecfefgfcgfgggch" },
            marks: { triangle: "efeede" },
            correct: ["dd"],
            wrong: ["eddd"],
        },
    },
    {
        id: "basic-skills-capture-6",
        chapterId: "basic-skills",
        order: 361,
        title: { zh: "提子 · 6/21", en: "Capture · 6/21" },
        instruction: { zh: "黑先。吃掉被标记的白棋。", en: "Black to play. Capture the marked white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "fdeeefcgfg", white: "ddeddefeff" },
            marks: { triangle: "fffe" },
            correct: ["gegfhfggghhghh", "gegfhfggghhgig"],
            wrong: ["gegfhfgghggh", "gegfgghf", "gfgehegdgcfc", "gfgehegdhdgc", "gfgegdhe"],
        },
    },
    {
        id: "basic-skills-capture-7",
        chapterId: "basic-skills",
        order: 362,
        title: { zh: "提子 · 7/21", en: "Capture · 7/21" },
        instruction: { zh: "黑先。吃掉被标记的白棋。", en: "Black to play. Capture the marked white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cccecgfgggehgh", white: "gchfhgfhhhfihi" },
            marks: { triangle: "fifh" },
            correct: ["gi"],
            wrong: ["eigi"],
        },
    },
    {
        id: "basic-skills-capture-8",
        chapterId: "basic-skills",
        order: 363,
        title: { zh: "提子 · 8/21", en: "Capture · 8/21" },
        instruction: { zh: "黑先。吃掉被标记的白棋。", en: "Black to play. Capture the marked white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "bcbdcddedfagbggg", white: "bbcbdcddaebecebf" },
            marks: { triangle: "bfcebeae" },
            correct: ["cfacafadab", "afaccfadab"],
            wrong: ["cfacadcc", "adcc", "afacadcc"],
        },
    },
    {
        id: "basic-skills-capture-9",
        chapterId: "basic-skills",
        order: 364,
        title: { zh: "提子 · 9/21", en: "Capture · 9/21" },
        instruction: { zh: "黑先。吃掉被标记的白棋。", en: "Black to play. Capture the marked white stones." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "ccdcgcbdedeegeefcgdghg", white: "ebeccdddbedecfdfegfgdh" },
            marks: { triangle: "dfcfdebeddcd" },
            correct: ["bf"],
            wrong: ["aebg", "bgbc", "adbg"],
        },
    },
    {
        id: "basic-skills-capture-10",
        chapterId: "basic-skills",
        order: 365,
        title: { zh: "提子 · 10/21", en: "Capture · 10/21" },
        instruction: { zh: "黑先。吃掉被标记的白棋。", en: "Black to play. Capture the marked white stone." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "gcffgfdgeg", white: "eecfefcgfg" },
            marks: { triangle: "fg" },
            correct: ["fhgghgghhh", "fhgghgghgi", "ggfhghehdhdifi", "ggfhghehdhdieifigi", "ggfhehghhheigi", "ggfhehghhheidi"],
            wrong: ["fhggghhg", "ggfhghehfidhchbh", "ggfhehghfihh"],
        },
    },
    {
        id: "basic-skills-capture-11",
        chapterId: "basic-skills",
        order: 366,
        title: { zh: "提子 · 11/21", en: "Capture · 11/21" },
        instruction: { zh: "黑先。吃掉被标记的白棋。", en: "Black to play. Capture the marked white stone." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "cfffdg", white: "ccecdf" },
            marks: { triangle: "df" },
            correct: ["deefeeegehfgggfhgh", "deefeeegehfgggfhfighhh", "deefeeegfgehfhdhcgchbh", "deefeeegfgehfhdhchcgbgdgdi", "deefeeegfgehfhdhchcgbgdgei", "deefeeegfgehdhfhgh"],
            wrong: ["deefeeegehfgggfhfighgihh", "deefeeegehfgfhgg", "deefegeefeed", "deefegeeedfefdge", "deefegeeedfegefdfcdd", "deefegeeedfegefdgddd", "efde"],
        },
    },
    {
        id: "basic-skills-capture-12",
        chapterId: "basic-skills",
        order: 367,
        title: { zh: "提子 · 12/21", en: "Capture · 12/21" },
        instruction: { zh: "黑先。吃掉被标记的白棋。", en: "Black to play. Capture the marked white stone." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "black",
            initial_state: { black: "gccdeecfff", white: "fegeefhfgg" },
            marks: { triangle: "ef" },
            correct: ["egdfdedgdhcgbgchbh", "egdfdedgdhcgbgchci"],
            wrong: ["egdfdedgdhcgchbg", "egdfdedgcgdh", "egdfdgdedded", "egdfdgdeedfg", "egdfdgdeceed", "dfegfgfh", "dfegdgfg"],
        },
    },
    {
        id: "basic-skills-capture-13",
        chapterId: "basic-skills",
        order: 368,
        title: { zh: "提子 · 13/21", en: "Capture · 13/21" },
        instruction: { zh: "黑先。在不使自己处于打吃状态的情况下吃掉白棋。", en: "Black to play. Capture white stones without putting yourself into atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "godpepcqfqcrfrcs", white: "cmcocpbqdqeqbrdres" },
            correct: ["er"],
            wrong: ["dsbs", "fsbs"],
        },
    },
    {
        id: "basic-skills-capture-14",
        chapterId: "basic-skills",
        order: 369,
        title: { zh: "提子 · 14/21", en: "Capture · 14/21" },
        instruction: { zh: "黑先。在不使自己处于打吃状态的情况下吃掉白棋。", en: "Black to play. Capture white stones without putting yourself into atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "gmepfphpdqgqcrdrgrbsgs", white: "dmdodpbqcqeqfqarbrfrdsesfs" },
            correct: ["cs"],
            wrong: ["ercs"],
        },
    },
    {
        id: "basic-skills-capture-15",
        chapterId: "basic-skills",
        order: 370,
        title: { zh: "提子 · 15/21", en: "Capture · 15/21" },
        instruction: { zh: "黑先。在不使自己处于打吃状态的情况下吃掉白棋。", en: "Black to play. Capture white stones without putting yourself into atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cncpdpbqeqbreres", white: "eohoepcqdqfqcrfrfs" },
            correct: ["cs"],
            wrong: ["drds"],
        },
    },
    {
        id: "basic-skills-capture-16",
        chapterId: "basic-skills",
        order: 371,
        title: { zh: "提子 · 16/21", en: "Capture · 16/21" },
        instruction: { zh: "黑先。在不使自己处于打吃状态的情况下吃掉白棋。", en: "Black to play. Capture white stones without putting yourself into atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "doeofohocpgpcqfqcrercs", white: "dmcncobpdpepfpbqdqgqiqdrgrdses" },
            correct: ["fs"],
            wrong: ["eqfr", "brar", "frfs"],
        },
    },
    {
        id: "basic-skills-capture-17",
        chapterId: "basic-skills",
        order: 372,
        title: { zh: "提子 · 17/21", en: "Capture · 17/21" },
        instruction: { zh: "黑先。在不使自己处于打吃状态的情况下吃掉白棋。", en: "Black to play. Capture white stones without putting yourself into atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dobpbqarcr", white: "cqdqfqbrbs" },
            correct: ["cs"],
            wrong: ["asaq", "drer"],
        },
    },
    {
        id: "basic-skills-capture-18",
        chapterId: "basic-skills",
        order: 373,
        title: { zh: "提子 · 18/21", en: "Capture · 18/21" },
        instruction: { zh: "黑先。在不使自己处于打吃状态的情况下吃掉白棋。", en: "Black to play. Capture white stones without putting yourself into atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "hpdqeqcrdrfrgr", white: "cncpdpepfpbqfqbrercses" },
            correct: ["fs"],
            wrong: ["dscq", "bscqdscs"],
        },
    },
    {
        id: "basic-skills-capture-19",
        chapterId: "basic-skills",
        order: 374,
        title: { zh: "提子 · 19/21", en: "Capture · 19/21" },
        instruction: { zh: "黑先。在不使自己处于打吃状态的情况下吃掉白棋。", en: "Black to play. Capture white stones without putting yourself into atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "eneocpdpeqcreres", white: "gnepfpdqfqdrfrcs" },
            correct: ["cq"],
            wrong: ["bsfsdscs", "dsfs"],
        },
    },
    {
        id: "basic-skills-capture-20",
        chapterId: "basic-skills",
        order: 375,
        title: { zh: "提子 · 20/21", en: "Capture · 20/21" },
        instruction: { zh: "黑先。在不使自己处于打吃状态的情况下吃掉白棋。", en: "Black to play. Capture white stones without putting yourself into atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cncpcqbrdrerfr", white: "dqeqfqhqcrgrcsfs" },
            correct: ["bs"],
            wrong: ["dses", "esds"],
        },
    },
    {
        id: "basic-skills-capture-21",
        chapterId: "basic-skills",
        order: 376,
        title: { zh: "提子 · 21/21", en: "Capture · 21/21" },
        instruction: { zh: "黑先。在不使自己处于打吃状态的情况下吃掉白棋。", en: "Black to play. Capture white stones without putting yourself into atari." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dnbocpdpbqeqbrerfres", white: "eohoepcqdqfqgqcrgrfsgs" },
            correct: ["cs"],
            wrong: ["drds", "dscs"],
        },
    },
];

const bsEscapeLevels: Level[] = [
    {
        id: "basic-skills-bs-escape-1",
        chapterId: "basic-skills",
        order: 377,
        title: { zh: "逃跑 · 1/12", en: "Escape · 1/12" },
        instruction: { zh: "白先。选择落子于A或B点，使被标记的棋子逃脱？", en: "White to play. Choose where to play to escape with the marked stones, A or B?" },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "dgegbhchdi", white: "cfcgdheh" },
            marks: { A: "fh", B: "ei", triangle: "ehdh" },
            correct: ["fh"],
        },
    },
    {
        id: "basic-skills-bs-escape-2",
        chapterId: "basic-skills",
        order: 378,
        title: { zh: "逃跑 · 2/12", en: "Escape · 2/12" },
        instruction: { zh: "白先。选择落子于A或B点，使被标记的棋子逃脱？", en: "White to play. Choose where to play to escape with the marked stones, A or B?" },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "bccccedebfbgbh", white: "bdcdbecfcgch" },
            marks: { A: "ad", B: "dd", triangle: "becdbd" },
            correct: ["dd"],
        },
    },
    {
        id: "basic-skills-bs-escape-3",
        chapterId: "basic-skills",
        order: 379,
        title: { zh: "逃跑 · 3/12", en: "Escape · 3/12" },
        instruction: { zh: "白先。选择落子于A或B点，使被标记的棋子逃脱？", en: "White to play. Choose where to play to escape with the marked stones, A or B?" },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gcdfefdgfgbhch", white: "cebgcgegdheh" },
            marks: { A: "fh", B: "ei", triangle: "ehdheg" },
            correct: ["fh"],
        },
    },
    {
        id: "basic-skills-bs-escape-4",
        chapterId: "basic-skills",
        order: 380,
        title: { zh: "逃跑 · 4/12", en: "Escape · 4/12" },
        instruction: { zh: "白先。选择落子于A或B点，使被标记的棋子逃脱？", en: "White to play. Choose where to play to escape with the marked stones, A or B?" },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ccdebfdfbgcg", white: "ddedcecfgg" },
            marks: { A: "cd", B: "be", triangle: "cfce" },
            correct: ["cd"],
        },
    },
    {
        id: "basic-skills-bs-escape-5",
        chapterId: "basic-skills",
        order: 381,
        title: { zh: "逃跑 · 5/12", en: "Escape · 5/12" },
        instruction: { zh: "白先。选择落子于A或B点，使被标记的棋子逃脱？", en: "White to play. Choose where to play to escape with the marked stones, A or B?" },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "cdddbedeefdgch", white: "cbbcbdcecfdf" },
            marks: { A: "bf", B: "cg", triangle: "dfcfce" },
            correct: ["bf"],
        },
    },
    {
        id: "basic-skills-bs-escape-6",
        chapterId: "basic-skills",
        order: 382,
        title: { zh: "逃跑 · 6/12", en: "Escape · 6/12" },
        instruction: { zh: "白先。选择落子于A或B点，使被标记的棋子逃脱？", en: "White to play. Choose where to play to escape with the marked stones, A or B?" },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "deeeffdgeg", white: "cccdcedf" },
            marks: { A: "cf", B: "ef", triangle: "df" },
            correct: ["cf"],
        },
    },
    {
        id: "basic-skills-bs-escape-7",
        chapterId: "basic-skills",
        order: 383,
        title: { zh: "逃跑 · 7/12", en: "Escape · 7/12" },
        instruction: { zh: "白先。选择落子于A或B点，使被标记的棋子逃脱？", en: "White to play. Choose where to play to escape with the marked stones, A or B?" },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "cedefegecfefcgeggg", white: "ccdcedeedfffdgdh" },
            marks: { A: "gf", B: "fg", triangle: "ff" },
            correct: ["fg"],
        },
    },
    {
        id: "basic-skills-bs-escape-8",
        chapterId: "basic-skills",
        order: 384,
        title: { zh: "逃跑 · 8/12", en: "Escape · 8/12" },
        instruction: { zh: "白先。选择落子于A或B点，使被标记的棋子逃脱？", en: "White to play. Choose where to play to escape with the marked stones, A or B?" },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "cfagcgbhdh", white: "cdcebfbg" },
            marks: { A: "be", B: "af", triangle: "bgbf" },
            correct: ["be"],
        },
    },
    {
        id: "basic-skills-bs-escape-9",
        chapterId: "basic-skills",
        order: 385,
        title: { zh: "逃跑 · 9/12", en: "Escape · 9/12" },
        instruction: { zh: "白先。选择落子于A或B点，使被标记的棋子逃脱？", en: "White to play. Choose where to play to escape with the marked stones, A or B?" },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "cfdfefcgegbh", white: "fdffdgfgdh" },
            marks: { A: "ch", B: "eh", triangle: "dhdg" },
            correct: ["eh"],
        },
    },
    {
        id: "basic-skills-bs-escape-10",
        chapterId: "basic-skills",
        order: 386,
        title: { zh: "逃跑 · 10/12", en: "Escape · 10/12" },
        instruction: { zh: "白先。选择落子于A或B点，使被标记的棋子逃脱？", en: "White to play. Choose where to play to escape with the marked stones, A or B?" },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ccbdcededfcgch", white: "bfcfefbgdgeg" },
            marks: { A: "be", B: "bh", triangle: "bgcfbf" },
            correct: ["bh"],
        },
    },
    {
        id: "basic-skills-bs-escape-11",
        chapterId: "basic-skills",
        order: 387,
        title: { zh: "逃跑 · 11/12", en: "Escape · 11/12" },
        instruction: { zh: "白先。选择落子于A或B点，使被标记的棋子逃脱？", en: "White to play. Choose where to play to escape with the marked stones, A or B?" },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "gdffgfeggggh", white: "dfefcgfgfh" },
            marks: { A: "eh", B: "fi", triangle: "fhfg" },
            correct: ["eh"],
        },
    },
    {
        id: "basic-skills-bs-escape-12",
        chapterId: "basic-skills",
        order: 388,
        title: { zh: "逃跑 · 12/12", en: "Escape · 12/12" },
        instruction: { zh: "白先。选择落子于A或B点，使被标记的棋子逃脱？", en: "White to play. Choose where to play to escape with the marked stones, A or B?" },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "dbebccfcedde", white: "fbdcecgcge" },
            marks: { A: "dd", B: "fd", triangle: "ecdc" },
            correct: ["fd"],
        },
    },
];

const bsLibertiesLevels: Level[] = [
    {
        id: "basic-skills-bs-liberties-1",
        chapterId: "basic-skills",
        order: 389,
        title: { zh: "气数 · 1/22", en: "Liberties · 1/22" },
        instruction: { zh: "你可以通过夺气来攻击一个棋串。在这样做的同时，也要尝试实现其他目标，例如连接自己的棋子或保护领地。白先。选择最佳的夺气方式，A、B或C。", en: "You can attack a chain by taking away a liberty. In doing so, try to achieve other goals as well, such as connecting your stones or protecting territory. White to play. Choose the best way to reduce liberties, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpepfp", white: "cocpdqfq" },
            marks: { A: "do", B: "gp", C: "eq" },
            correct: ["eq"],
        },
    },
    {
        id: "basic-skills-bs-liberties-2",
        chapterId: "basic-skills",
        order: 390,
        title: { zh: "气数 · 2/22", en: "Liberties · 2/22" },
        instruction: { zh: "夺气的另一个目标是切断对手的棋子。白先。选择最佳的夺气方式，A、B或C。", en: "Another goal while taking away a liberty is to cut opponent's stones. White to play. Choose the best way to reduce liberties, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "hmgohodpepfp", white: "dncocpgpdqeqfqgr" },
            marks: { A: "do", B: "eo", C: "fo" },
            correct: ["fo"],
        },
    },
    {
        id: "basic-skills-bs-liberties-3",
        chapterId: "basic-skills",
        order: 391,
        title: { zh: "气数 · 3/22", en: "Liberties · 3/22" },
        instruction: { zh: "白先。选择最佳的夺气方式，A、B或C。", en: "White to play. Choose the best way to reduce liberties, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dmep", white: "cpgpdq" },
            marks: { A: "eo", B: "dp", C: "eq" },
            correct: ["eq"],
        },
    },
    {
        id: "basic-skills-bs-liberties-4",
        chapterId: "basic-skills",
        order: 392,
        title: { zh: "气数 · 4/22", en: "Liberties · 4/22" },
        instruction: { zh: "还有一个目标是阻止对手棋子的推进。白先。选择最佳的夺气方式，A、B或C。", en: "Yet another goal is to block the advance of stones of your opponent. White to play. Choose the best way to reduce liberties, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "epdqeq", white: "cldodpcqcr" },
            marks: { A: "eo", B: "dr", C: "er" },
            correct: ["eo"],
        },
    },
    {
        id: "basic-skills-bs-liberties-5",
        chapterId: "basic-skills",
        order: 393,
        title: { zh: "气数 · 5/22", en: "Liberties · 5/22" },
        instruction: { zh: "白先。选择最佳的夺气方式，A、B或C。", en: "White to play. Choose the best way to reduce liberties, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dodpdq", white: "clcofocphpcqfq" },
            marks: { A: "dn", C: "eq", B: "dr" },
            correct: ["dn"],
        },
    },
    {
        id: "basic-skills-bs-liberties-6",
        chapterId: "basic-skills",
        order: 394,
        title: { zh: "气数 · 6/22", en: "Liberties · 6/22" },
        instruction: { zh: "白先。选择最佳的夺气方式，A、B或C。", en: "White to play. Choose the best way to reduce liberties, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dndodp", white: "cocpepfpcq" },
            marks: { A: "dm", B: "cn", C: "dq" },
            correct: ["dq"],
        },
    },
    {
        id: "basic-skills-bs-liberties-7",
        chapterId: "basic-skills",
        order: 395,
        title: { zh: "气数 · 7/22", en: "Liberties · 7/22" },
        instruction: { zh: "白先。选择最佳的夺气方式，A、B或C。", en: "White to play. Choose the best way to reduce liberties, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cmbpcpdp", white: "eoepbqcqgq" },
            marks: { A: "co", B: "do", C: "dq" },
            correct: ["dq"],
        },
    },
    {
        id: "basic-skills-bs-liberties-8",
        chapterId: "basic-skills",
        order: 396,
        title: { zh: "气数 · 8/22", en: "Liberties · 8/22" },
        instruction: { zh: "白先。选择最佳的夺气方式，A、B或C。", en: "White to play. Choose the best way to reduce liberties, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "epdqeq", white: "bncpdpgpcqhq" },
            marks: { A: "eo", B: "fp", C: "dr" },
            correct: ["eo"],
        },
    },
    {
        id: "basic-skills-bs-liberties-9",
        chapterId: "basic-skills",
        order: 397,
        title: { zh: "气数 · 9/22", en: "Liberties · 9/22" },
        instruction: { zh: "白先。选择最佳的夺气方式，A、B或C。", en: "White to play. Choose the best way to reduce liberties, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fmdpepfpdq", white: "cmcocpcqeqfqgq" },
            marks: { A: "do", B: "gp", C: "dr" },
            correct: ["dr"],
        },
    },
    {
        id: "basic-skills-bs-liberties-10",
        chapterId: "basic-skills",
        order: 398,
        title: { zh: "气数 · 10/22", en: "Liberties · 10/22" },
        instruction: { zh: "白先。选择最佳的夺气方式，A、B或C。", en: "White to play. Choose the best way to reduce liberties, A, B or C." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dqeqfq", white: "cmcodpepfpcq" },
            marks: { A: "gq", B: "dr", C: "er" },
            correct: ["gq"],
        },
    },
    {
        id: "basic-skills-bs-liberties-11",
        chapterId: "basic-skills",
        order: 399,
        title: { zh: "气数 · 11/22", en: "Liberties · 11/22" },
        instruction: { zh: "黑先。增加被标记棋串的气数。", en: "Black to play. Increase the number of liberties of the marked chain." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "hqer", white: "cqeqdr" },
            marks: { triangle: "er" },
            correct: ["fr"],
        },
    },
    {
        id: "basic-skills-bs-liberties-12",
        chapterId: "basic-skills",
        order: 400,
        title: { zh: "气数 · 12/22", en: "Liberties · 12/22" },
        instruction: { zh: "黑先。增加被标记棋串的气数。", en: "Black to play. Increase the number of liberties of the marked chain." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqdqgq", white: "cncpbqcrdr" },
            marks: { triangle: "dqcq" },
            correct: ["eq"],
        },
    },
    {
        id: "basic-skills-bs-liberties-13",
        chapterId: "basic-skills",
        order: 401,
        title: { zh: "气数 · 13/22", en: "Liberties · 13/22" },
        instruction: { zh: "黑先。增加被标记棋串的气数。", en: "Black to play. Increase the number of liberties of the marked chain." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dpephq", white: "dndocpdqeq" },
            marks: { triangle: "epdp" },
            correct: ["fp"],
        },
    },
    {
        id: "basic-skills-bs-liberties-14",
        chapterId: "basic-skills",
        order: 402,
        title: { zh: "气数 · 14/22", en: "Liberties · 14/22" },
        instruction: { zh: "黑先。增加被标记棋串的气数。", en: "Black to play. Increase the number of liberties of the marked chain." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cmdpcqbrcrdr", white: "bpcpbqdqeqfqhq" },
            marks: { triangle: "dp" },
            correct: ["do"],
        },
    },
    {
        id: "basic-skills-bs-liberties-15",
        chapterId: "basic-skills",
        order: 403,
        title: { zh: "气数 · 15/22", en: "Liberties · 15/22" },
        instruction: { zh: "黑先。增加被标记棋串的气数。", en: "Black to play. Increase the number of liberties of the marked chain." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "epcqdqeq", white: "bncpdpbqfqcrdrergr" },
            marks: { triangle: "eqdqcqep" },
            correct: ["eo"],
        },
    },
    {
        id: "basic-skills-bs-liberties-16",
        chapterId: "basic-skills",
        order: 404,
        title: { zh: "气数 · 16/22", en: "Liberties · 16/22" },
        instruction: { zh: "黑先。增加被标记棋串的气数。", en: "Black to play. Increase the number of liberties of the marked chain." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cldodpdqdrds", white: "bncofocphpcqfqarcrfr" },
            marks: { triangle: "dsdrdqdpdo" },
            correct: ["dn"],
        },
    },
    {
        id: "basic-skills-bs-liberties-17",
        chapterId: "basic-skills",
        order: 405,
        title: { zh: "气数 · 17/22", en: "Liberties · 17/22" },
        instruction: { zh: "白先。黑棋用第1手填塞了自己的气。惩罚这一着。", en: "White to play. Black has filled his own liberty with move 1. Punish this." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpcpdpbqeqfqdrer", white: "epfpcqdqbrcrfrgr" },
            marks: { 1: "fq" },
            correct: ["gq"],
        },
    },
    {
        id: "basic-skills-bs-liberties-18",
        chapterId: "basic-skills",
        order: 406,
        title: { zh: "气数 · 18/22", en: "Liberties · 18/22" },
        instruction: { zh: "白先。黑棋用第1手填塞了自己的气。惩罚这一着。", en: "White to play. Black has filled his own liberty with move 1. Punish this." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpdpcqeqfqbrfrgrbsfs", white: "epfpdqgqhqcrdrerires" },
            marks: { 1: "fs" },
            correct: ["hr", "gshshr"],
        },
    },
    {
        id: "basic-skills-bs-liberties-19",
        chapterId: "basic-skills",
        order: 407,
        title: { zh: "气数 · 19/22", en: "Liberties · 19/22" },
        instruction: { zh: "白先。黑棋用第1手填塞了自己的气。惩罚这一着。", en: "White to play. Black has filled his own liberty with move 1. Punish this." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dpepgpcqfqcrdrfrcs", white: "bocpbqdqeqbreres" },
            marks: { 1: "dr" },
            correct: ["bs"],
            wrong: ["dsfs", "fsgs"],
        },
    },
    {
        id: "basic-skills-bs-liberties-20",
        chapterId: "basic-skills",
        order: 408,
        title: { zh: "气数 · 20/22", en: "Liberties · 20/22" },
        instruction: { zh: "白先。黑棋用第1手填塞了自己的气。惩罚这一着。", en: "White to play. Black has filled his own liberty with move 1. Punish this." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpbqfqgqcrercsdses", white: "cqdqeqdrfrfs" },
            marks: { 1: "er" },
            correct: ["br"],
            wrong: ["bsbr"],
        },
    },
    {
        id: "basic-skills-bs-liberties-21",
        chapterId: "basic-skills",
        order: 409,
        title: { zh: "气数 · 21/22", en: "Liberties · 21/22" },
        instruction: { zh: "白先。黑棋用第1手填塞了自己的气。惩罚这一着。", en: "White to play. Black has filled his own liberty with move 1. Punish this." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "bpbqcrdrercsds", white: "cqdqeqgqfres" },
            marks: { 1: "er" },
            correct: ["brfsbs"],
            wrong: ["brfsgsar", "fsbr", "bsbr"],
        },
    },
    {
        id: "basic-skills-bs-liberties-22",
        chapterId: "basic-skills",
        order: 410,
        title: { zh: "气数 · 22/22", en: "Liberties · 22/22" },
        instruction: { zh: "白先。黑棋用第1手填塞了自己的气。惩罚这一着。", en: "White to play. Black has filled his own liberty with move 1. Punish this." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fnfoepaqbqdqeqfqarcrbscs", white: "dneoapbpcpdpfpgpcqgqdr" },
            marks: { 1: "ep" },
            correct: ["fr", "erfrgr", "erfrfsgrhr"],
        },
    },
];

const encloseLevels: Level[] = [
    {
        id: "basic-skills-enclose-1",
        chapterId: "basic-skills",
        order: 411,
        title: { zh: "包围 · 1/9", en: "Enclose · 1/9" },
        instruction: { zh: "你不能总是通过直接打吃来提子。有时你需要先阻止对方逃跑来为提子做准备。白先。通过包围来提黑棋棋子。", en: "You can not always capture stones by putting them in atari immediately. Sometimes you need to prepare the capture by first preventing an escape. White to play. Capture black stones by enclosing them." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "codoepbqeqcr", white: "eofodpdqgq" },
            marks: { cross: "er" },
            correct: ["er"],
            wrong: ["drer"],
        },
    },
    {
        id: "basic-skills-enclose-2",
        chapterId: "basic-skills",
        order: 412,
        title: { zh: "包围 · 2/9", en: "Enclose · 2/9" },
        instruction: { zh: "白先。通过包围来提黑棋棋子。", en: "White to play. Capture black stones by enclosing them." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "clbncogobpdpbqdqgqdrgr", white: "emendocpepcqcrcs" },
            correct: ["er"],
            wrong: ["eseq", "eqerfrfs", "dseq"],
        },
    },
    {
        id: "basic-skills-enclose-3",
        chapterId: "basic-skills",
        order: 413,
        title: { zh: "包围 · 3/9", en: "Enclose · 3/9" },
        instruction: { zh: "白先。通过包围来提黑棋棋子。", en: "White to play. Capture black stones by enclosing them." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dnbocpgpbqdqeqar", white: "fodpepcqbrcr" },
            correct: ["fq"],
        },
    },
    {
        id: "basic-skills-enclose-4",
        chapterId: "basic-skills",
        order: 414,
        title: { zh: "包围 · 4/9", en: "Enclose · 4/9" },
        instruction: { zh: "白先。通过包围来提黑棋棋子。", en: "White to play. Capture black stones by enclosing them." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "clcmbndnbodoepfpgpbqeqcrdr", white: "emengneoapbpcpdpdqfqhqerfr" },
            correct: ["hp"],
            wrong: ["gohp", "hocq", "gqhp"],
        },
    },
    {
        id: "basic-skills-enclose-5",
        chapterId: "basic-skills",
        order: 415,
        title: { zh: "包围 · 5/9", en: "Enclose · 5/9" },
        instruction: { zh: "白先。通过包围来提黑棋棋子。", en: "White to play. Capture black stones by enclosing them." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "cncodocpdqeqgqbrcrer", white: "gmdneneobpdpepbqcq" },
            correct: ["cm"],
        },
    },
    {
        id: "basic-skills-enclose-6",
        chapterId: "basic-skills",
        order: 416,
        title: { zh: "包围 · 6/9", en: "Enclose · 6/9" },
        instruction: { zh: "白先。通过包围来提黑棋棋子。", en: "White to play. Capture black stones by enclosing them." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "eoepbqdqeqfqiqbrcrgrhr", white: "dmhndogobpcpdpcqgqhqdrerfr" },
            correct: ["en"],
            wrong: ["foen", "fnfs", "aqds", "csfs"],
        },
    },
    {
        id: "basic-skills-enclose-7",
        chapterId: "basic-skills",
        order: 417,
        title: { zh: "包围 · 7/9", en: "Enclose · 7/9" },
        instruction: { zh: "白先。通过包围来提黑棋棋子。", en: "White to play. Capture black stones by enclosing them." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "fofpdqeqfqiqbrcrgrhr", white: "cngocpdpgpcqgqdrerfr" },
            correct: ["fn"],
            wrong: ["enfn", "eofn", "bqds"],
        },
    },
    {
        id: "basic-skills-enclose-8",
        chapterId: "basic-skills",
        order: 418,
        title: { zh: "包围 · 8/9", en: "Enclose · 8/9" },
        instruction: { zh: "白先。通过包围来提黑棋棋子。", en: "White to play. Capture black stones by enclosing them." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "coeocpdpepbqfqbrfrhrbses", white: "cndnbofobpfpcqeqcrdrer" },
            correct: ["en"],
            wrong: ["aqds", "csdq"],
        },
    },
    {
        id: "basic-skills-enclose-9",
        chapterId: "basic-skills",
        order: 419,
        title: { zh: "包围 · 9/9", en: "Enclose · 9/9" },
        instruction: { zh: "白先。通过包围来提黑棋棋子。", en: "White to play. Capture black stones by enclosing them." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "white",
            initial_state: { black: "dmbndneodpepbqcqeqfq", white: "enfncodohocpdqdrerfr" },
            correct: ["gq"],
            wrong: ["fogq", "hqbp"],
        },
    },
];

const firstLineLevels: Level[] = [
    {
        id: "basic-skills-first-line-1",
        chapterId: "basic-skills",
        order: 420,
        title: { zh: "一路 · 1/12", en: "First Line · 1/12" },
        instruction: { zh: "在第一线的棋子很难逃脱。黑先。提掉第一线被标记的棋子。", en: "It is difficult to escape with stones on the first line. Black to play. Capture the marked stone on the first line." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "eqdr", white: "ds" },
            marks: { triangle: "ds" },
            correct: ["escscr", "escsbr", "escsbscrcq", "csesfs"],
        },
    },
    {
        id: "basic-skills-first-line-2",
        chapterId: "basic-skills",
        order: 421,
        title: { zh: "一路 · 2/12", en: "First Line · 2/12" },
        instruction: { zh: "黑先。提掉第一线被标记的棋子。", en: "Black to play. Capture the marked stone on the first line." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "fqer", white: "brhrbses" },
            marks: { triangle: "es" },
            correct: ["dsfsgs"],
            wrong: ["dsfsgrdr", "fsds"],
        },
    },
    {
        id: "basic-skills-first-line-3",
        chapterId: "basic-skills",
        order: 422,
        title: { zh: "一路 · 3/12", en: "First Line · 3/12" },
        instruction: { zh: "黑先。提掉第一线被标记的棋子。", en: "Black to play. Capture the marked stone on the first line." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "gqdrfr", white: "crhrircsfs" },
            marks: { triangle: "fs" },
            correct: ["gsesds"],
            wrong: ["gseserds", "esgs"],
        },
    },
    {
        id: "basic-skills-first-line-4",
        chapterId: "basic-skills",
        order: 423,
        title: { zh: "一路 · 4/12", en: "First Line · 4/12" },
        instruction: { zh: "黑先。提掉第一线被标记的棋子。", en: "Black to play. Capture the marked stone on the first line." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "gqcrdrfr", white: "hrircsdsfs" },
            marks: { triangle: "fs" },
            correct: ["gsesbs", "gseser"],
        },
    },
    {
        id: "basic-skills-first-line-5",
        chapterId: "basic-skills",
        order: 424,
        title: { zh: "一路 · 5/12", en: "First Line · 5/12" },
        instruction: { zh: "黑先。提掉第一线被标记的棋子。", en: "Black to play. Capture the marked stone on the first line." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dr", white: "es" },
            marks: { triangle: "es" },
            correct: ["fr"],
            wrong: ["erfr", "dsfr", "fser"],
        },
    },
    {
        id: "basic-skills-first-line-6",
        chapterId: "basic-skills",
        order: 425,
        title: { zh: "一路 · 6/12", en: "First Line · 6/12" },
        instruction: { zh: "黑先。提掉第一线被标记的棋子。", en: "Black to play. Capture the marked stones on the first line." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpbqbrdrbscs", white: "cocpcqcrirdses" },
            marks: { triangle: "esds" },
            correct: ["erfsgr"],
            wrong: ["erfsfrgs", "erfsgsfr", "fser", "frer"],
        },
    },
    {
        id: "basic-skills-first-line-7",
        chapterId: "basic-skills",
        order: 426,
        title: { zh: "一路 · 7/12", en: "First Line · 7/12" },
        instruction: { zh: "黑先。提掉第一线被标记的棋子。", en: "Black to play. Capture the marked stones on the first line." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "crer", white: "dses" },
            marks: { triangle: "esds" },
            correct: ["frdrdq"],
            wrong: ["drfr", "fsfr", "csfr"],
        },
    },
    {
        id: "basic-skills-first-line-8",
        chapterId: "basic-skills",
        order: 427,
        title: { zh: "一路 · 8/12", en: "First Line · 8/12" },
        instruction: { zh: "黑先。提掉第一线被标记的棋子。", en: "Black to play. Capture the marked stones on the first line." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "dqcr", white: "dses" },
            marks: { triangle: "esds" },
            correct: ["frfsgr"],
            wrong: ["frfsgsgr", "frfsergr", "fsfr", "csfr"],
        },
    },
    {
        id: "basic-skills-first-line-9",
        chapterId: "basic-skills",
        order: 428,
        title: { zh: "一路 · 9/12", en: "First Line · 9/12" },
        instruction: { zh: "黑先。提掉第一线被标记的棋子。", en: "Black to play. Capture the marked stones on the first line." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqcr", white: "dses" },
            marks: { triangle: "esds" },
            correct: ["frdqeqdrdp"],
            wrong: ["frdqdrereqfq", "frdqerdr", "erfr", "fsfr", "csfr"],
        },
    },
    {
        id: "basic-skills-first-line-10",
        chapterId: "basic-skills",
        order: 429,
        title: { zh: "一路 · 10/12", en: "First Line · 10/12" },
        instruction: { zh: "黑先。提掉第一线被标记的棋子。", en: "Black to play. Capture the marked stones on the first line." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "eqfqgqiq", white: "cqesfs" },
            marks: { triangle: "fses" },
            correct: ["drhrirhqhp", "drhrhqirjr", "drhrgrgshqirjr"],
            wrong: ["drhrirhqgrgshpis", "hrdr", "erdr", "dqdr"],
        },
    },
    {
        id: "basic-skills-first-line-11",
        chapterId: "basic-skills",
        order: 430,
        title: { zh: "一路 · 11/12", en: "First Line · 11/12" },
        instruction: { zh: "黑先。提掉第一线被标记的棋子。", en: "Black to play. Capture the marked stone on the first line." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "bpbqbrirbscs", white: "cocpcqcrgrds" },
            marks: { triangle: "ds" },
            correct: ["dreserfsfrgsgq"],
            wrong: ["erdr", "esdr"],
        },
    },
    {
        id: "basic-skills-first-line-12",
        chapterId: "basic-skills",
        order: 431,
        title: { zh: "一路 · 12/12", en: "First Line · 12/12" },
        instruction: { zh: "黑先。提掉第一线被标记的棋子。", en: "Black to play. Capture the marked stone on the first line." },
        puzzle: {
            width: 19,
            height: 19,
            initial_player: "black",
            initial_state: { black: "cqeq", white: "hphqhrds" },
            marks: { triangle: "ds" },
            correct: ["frfsgsesgr", "drercsesfr"],
            wrong: ["frfsgsescsgr", "frfsesergsesgrcrbrfq", "eresfsfr", "csesfrfsgsgr"],
        },
    },
];

const preventTwoEyesLevels: Level[] = [
    {
        id: "basic-skills-prevent_two_eyes-1",
        chapterId: "basic-skills",
        order: 432,
        title: { zh: "防止做两眼 · 1/12", en: "Prevent two eyes · 1/12" },
        instruction: { zh: "白先。阻止黑棋棋块做出两个眼而活棋。", en: "White to play. Prevent two eyes killing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "fdgdeegeefgfegggehfhgheifigi", white: "ecfcgcedhddehedfhfdghgdhhh" },
            correct: ["ff"],
        },
    },
    {
        id: "basic-skills-prevent_two_eyes-2",
        chapterId: "basic-skills",
        order: 433,
        title: { zh: "防止做两眼 · 2/12", en: "Prevent two eyes · 2/12" },
        instruction: { zh: "白先。阻止黑棋棋块做出两个眼而活棋。", en: "White to play. Prevent two eyes killing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "cchdcegeiegfcggghgig", white: "gbhcfdgdfefffgghhh" },
            correct: ["hf"],
        },
    },
    {
        id: "basic-skills-prevent_two_eyes-3",
        chapterId: "basic-skills",
        order: 434,
        title: { zh: "防止做两眼 · 3/12", en: "Prevent two eyes · 3/12" },
        instruction: { zh: "白先。阻止黑棋棋块做出两个眼而活棋。", en: "White to play. Prevent two eyes killing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "eccdifhgiggheifihi", white: "hdgehffgggdhfhdi" },
            correct: ["ih"],
        },
    },
    {
        id: "basic-skills-prevent_two_eyes-4",
        chapterId: "basic-skills",
        order: 435,
        title: { zh: "防止做两眼 · 4/12", en: "Prevent two eyes · 4/12" },
        instruction: { zh: "白先。阻止黑棋棋块做出两个眼而活棋。", en: "White to play. Prevent two eyes killing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "cchcichdhehfcghgighh", white: "gbhbgcgdgegfggghhi" },
            correct: ["ie"],
        },
    },
    {
        id: "basic-skills-prevent_two_eyes-5",
        chapterId: "basic-skills",
        order: 436,
        title: { zh: "防止做两眼 · 5/12", en: "Prevent two eyes · 5/12" },
        instruction: { zh: "白先。阻止黑棋棋块做出两个眼而活棋。", en: "White to play. Prevent two eyes killing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "cchcicddgdhdgedfhfcghgig", white: "gbhbibgcfdfegfggfhhhih" },
            correct: ["ie"],
        },
    },
    {
        id: "basic-skills-prevent_two_eyes-6",
        chapterId: "basic-skills",
        order: 437,
        title: { zh: "防止做两眼 · 6/12", en: "Prevent two eyes · 6/12" },
        instruction: { zh: "白先。阻止黑棋棋块做出两个眼而活棋。", en: "White to play. Prevent two eyes killing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ebbcbdedfdgdhdiddeheiedfefgffg", white: "dcecfcgchccdcecfhfdghgehfhgh" },
            correct: ["fe"],
        },
    },
    {
        id: "basic-skills-prevent_two_eyes-7",
        chapterId: "basic-skills",
        order: 438,
        title: { zh: "防止做两眼 · 7/12", en: "Prevent two eyes · 7/12" },
        instruction: { zh: "白先。阻止黑棋棋块做出两个眼而活棋。", en: "White to play. Prevent two eyes killing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "hfifcgggigghgi", white: "gcgehegffgfh" },
            correct: ["hh"],
        },
    },
    {
        id: "basic-skills-prevent_two_eyes-8",
        chapterId: "basic-skills",
        order: 439,
        title: { zh: "防止做两眼 · 8/12", en: "Prevent two eyes · 8/12" },
        instruction: { zh: "白先。阻止黑棋棋块做出两个眼而活棋。", en: "White to play. Prevent two eyes killing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "hcicfdgdidcefegfifgghg", white: "hbfcgcedeefffgfhghhh" },
            correct: ["he"],
        },
    },
    {
        id: "basic-skills-prevent_two_eyes-9",
        chapterId: "basic-skills",
        order: 440,
        title: { zh: "防止做两眼 · 9/12", en: "Prevent two eyes · 9/12" },
        instruction: { zh: "白先。阻止黑棋棋块做出两个眼而活棋。", en: "White to play. Prevent two eyes killing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "hcichdgegfhfhgigih", white: "hbgcgdfeffggfhhh" },
            correct: ["ie"],
        },
    },
    {
        id: "basic-skills-prevent_two_eyes-10",
        chapterId: "basic-skills",
        order: 441,
        title: { zh: "防止做两眼 · 10/12", en: "Prevent two eyes · 10/12" },
        instruction: { zh: "白先。阻止黑棋棋块做出两个眼而活棋。", en: "White to play. Prevent two eyes killing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "ccecgghgfhghihfi", white: "fegfhfifegfgeh" },
            correct: ["hi"],
        },
    },
    {
        id: "basic-skills-prevent_two_eyes-11",
        chapterId: "basic-skills",
        order: 442,
        title: { zh: "防止做两眼 · 11/12", en: "Prevent two eyes · 11/12" },
        instruction: { zh: "白先。阻止黑棋棋块做出两个眼而活棋。", en: "White to play. Prevent two eyes killing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "hdidgeiegfgghgigih", white: "gchcgdfefffgghhh" },
            correct: ["hf"],
        },
    },
    {
        id: "basic-skills-prevent_two_eyes-12",
        chapterId: "basic-skills",
        order: 443,
        title: { zh: "防止做两眼 · 12/12", en: "Prevent two eyes · 12/12" },
        instruction: { zh: "白先。阻止黑棋棋块做出两个眼而活棋。", en: "White to play. Prevent two eyes killing the black group." },
        puzzle: {
            width: 9,
            height: 9,
            initial_player: "white",
            initial_state: { black: "fggghgdhehhhaibicidihi", white: "ffgfhfcgdgegigbhchih" },
            correct: ["fi"],
        },
    },
];

export const LEVELS: Level[] = [
    ...atariToSideLevels,
    ...atariToStonesLevels,
    ...atariWithCutLevels,
    ...atariCorrectSideLevels,
    ...escapePossibleLevels,
    ...makeKoLevels,
    ...playDoubleAtariLevels,
    ...preventDoubleAtariLevels,
    ...connectedShapeLevels,
    ...basicSkillsCutLevels,
    ...connectWithHangingConnectionLevels,
    ...ladderLevels,
    ...shortageLibertiesLevels,
    ...falseEyeLevels,
    ...largeEyeLevels,
    ...bsGroupAliveLevels,
    ...snapbackLevels,
    ...netLevels,
    ...countTerritoryLevels,
    ...determineWinnerLevels,
    ...closeTerritoryLevels,
    ...compareLibertiesLevels,
    ...capturingRaceLevels,
    ...correctSideLevels,
    ...captureLevels,
    ...bsEscapeLevels,
    ...bsLibertiesLevels,
    ...encloseLevels,
    ...firstLineLevels,
    ...preventTwoEyesLevels,
];
